import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, observable } from 'rxjs';
import { Newsubscription } from './newsubscription';
import { FormGroup } from '@angular/forms';
import { AnyRecord } from 'dns';

@Injectable({
  providedIn: 'root',
})
export class DigisubservicesService {

  issueSellerIssueName?: string;
  issueSellerIssueDates?: string;

  getBusinessReport11(payload: { start_date: any; end_date: any; rep_name: any; office_rep_name: any; }) {
    throw new Error('Method not implemented.');
  }
  getInvoiceList() {
    throw new Error('Method not implemented.');
  }

  // PHP_API_SERVER = 'http://localhost/vivek_publication';
  PHP_API_SERVER = 'https://app.vivekweb.in/VivekApplication';
  //  PHP_API_SERVER = 'http://localhost/VIVEK_BE_PHP';
  constructor(private httpClient: HttpClient) { }

  getBookSearch(request: { bookname: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_all_book_data_by_search.php`,
      request);
  }


  get_User(dataFromUI: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/admin_auth.php`,
      dataFromUI
    );
  }

  get_book_names() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_names.php`,
      {}
    );
  }

  delete_journal_voucher(request: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_journal_voucher.php`,
      request
    );
  }

  getBookNameList(name: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_books_all_data.php`,
      {
        name
      }
    );
  }

  delete_main_expense(request: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_main_expense.php`,
      request
    );
  }

  deleteCreditor(id: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_creditor_data.php`,
      { id }
    );
  }

  deleteUser(id: number) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_user.php`,
      { id }
    );
  }

  getCreditorData(creditor_no: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/read_single_creditor_data_with_id.php`,
      { creditor_no }
    );
  }

  getCreditorNo(creditor_no: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/read_creditor_no.php`,
      { creditor_no }
    );
  }

  generateCreditorNo(date: string): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/generate-creditors-number.php`,
      { date }
    );
  }

  delete_sub_expense(request: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_sub_expense.php`,
      request
    );
  }

  get_journal_voucher_list() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_journal_voucher_list.php`,
      {}
    );
  }

  insert_person_book_names(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_person_book_names.php`,
      data
    );
  }
  get_journal_entry(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_journal_entry.php`,
      { data }
    );
  }

  get_AllRepresentative_List(): Observable<any> {
    return this.httpClient.get(`${this.PHP_API_SERVER}/read_Allrep_list.php`);
  }

  get_distinct_city_list(): Observable<any> {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/read_all_distinct_city.php`
    );
  }

  read_RepById(ds_repid: number) {
    return this.httpClient.post(`${this.PHP_API_SERVER}/read_repbyid.php`, {
      ds_repid,
    });
  }

  read_distwise_pincode_report(start_date: string, end_date: string, disct_list: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/read_disct_pincode_report.php`,
      { start_date, end_date, disct_list }
    );
  }

  getSubmagByIdorNumberCancel(mobileNumber: number) {
    //console.log(mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/portal_read_ntfc_mag_detail.php`,
      { mobileNumber }
    );
  }

  getaddolddata(data: Partial<{ invoiceNumber: any; invoiceDate: any; advtName: any; issueName: any; issueDate: any; receivedAmount: any; CreditdAmount: any; totalamt: any; pendingamt: any; rep_name: any; invoicedate: any; issuedate: any; off_rep_name: any; }>) {
    //console.log(mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_existing_advt_data.php`,
      { data }
    );
  }

  getaddadvttype(data: any) {
    //console.log(mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_advt_type.php`,
      { data }
    );
  }

  getaddudhishta(data: { repname: string | null | undefined; udhishta_amount: string | null | undefined; }) {
    //console.log(mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_rep_udhistha.php`,
      { data }
    );
  }

  addupdateddata(data: any) {
    //console.log(mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_advt_type.php`,
      { data }
    );
  }

  updateudhishta(data: { id: string | null | undefined; repname: string | null | undefined; udhishta_amount: string | null | undefined; }) {
    //console.log(mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_rep_udhishta.php`,
      { data }
    );
  }



  updateprintorder(prusthaData: any) {
    //console.log(mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_print_order_prustha1.php`,
      { prusthaData }
    );
  }

  updateprintorder2(typeData: any) {
    //console.log(mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_print_order_prustha2.php`,
      { typeData }
    );
  }

  updateprintorder3(orderid: any, total: any) {
    //console.log(mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_total_prushta.php`,
      { orderid, total }
    );
  }

  get_old_data() {
    //console.log(mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_existing_advt_data.php`,
      {}
    );
  }
  get_getadvttype() {
    //console.log(mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_advt_type.php`,
      {}
    );
  }

  getadvtudhishtha() {
    //console.log(mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_advt_udhishta.php`,
      {}
    );
  }


  getPincodeDetails(pincode: number) {
    // console.log(pincode);
    return this.httpClient.get<any>(
      `https://api.postalpincode.in/pincode/${pincode}`
    );
  }

  getPincodeData(pincode: number) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_pincode_data.php`,
      { pincode }
    );
  }

  getCountry(): Observable<any> {
    return this.httpClient.get<any>(`${this.PHP_API_SERVER}/get_Country.php`);
  }

  getState(country_code: any) {
    return this.httpClient.post<any>(`${this.PHP_API_SERVER}/get_states.php`, {
      country_code,
    });
  }
  // getStateN(): Observable<any> {
  //   return this.httpClient.get<any>(`${this.PHP_API_SERVER}/get_states.php`);
  // }

  getstates(country_code: number) {
    // console.log(country_code);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_all_states.php`,
      { country_code }
    );
  }

  getstates1(country_code: any) {
    // console.log(country_code);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_all_states_issue.php`,
      { country_code }
    );
  }

  getDistrict(state_id: any) {
    // console.log(state_id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_District.php`,
      { state_id }
    );
  }

  getTaluka(district_id: any) {
    // console.log(state_id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_taluka.php`,
      { district_id }
    );
  }
  getWTaluka(district_id: any) {
    // console.log(state_id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_taluka_name.php`,
      { district_id }
    );
  }

  getTaluka1(district_id: any) {
    // console.log(state_id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_taluka.php`,
      district_id
    );
  }


  // getTaluka(district_id) {
  //   return this.httpClient.post<any>(`${this.PHP_API_SERVER}/get_taluka.php`, district_id);
  // }

  getCity(state_id: number) {
    // console.log(state_id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_all_cities.php`,
      { state_id }
    );
  }

  updateRepData(dataFromUI: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/update_rep_data.php`,
      dataFromUI
    );
  }

  updateRep_book_commision(ds_repid: number, ds_repcomm: number) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/update_rep_book_comission.php`,
      { ds_repid, ds_repcomm }
    );
  }

  getRepwiseAddress(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_repwise_address.php`
    );
  }

  getSubscribersAddressData(
    start_date: string,
    end_date: string,
    title: string,
    district: string,
    taluka: string,
    subtype: string,
    complimentary: string
  ): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_subscribers_address.php`,
      { start_date, end_date, title, district, taluka, subtype, complimentary }
    );
  }

  getSubscribersAddressTitles(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_subscriber_address_titles.php`
    );
  }

  // Offiece rep

  getSubscribersAddressTitles1(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_subscriber_address_titles.php`
    );
  }

  getSubscribersAddressDistricts(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_subscriber_address_district.php`
    );
  }

  getSubscribersAddressTalukas(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_subscriber_address_taluka.php`
    );
  }

  getSubscribersAddressSubType(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_subscriber_address_subtype.php`
    );
  }

  getSubscriberLedgerData(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_subscriber_ledger_data.php`
    );
  }

  getSubscriberledgerDataCount() {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_subscriber_ledger_total.php`
    );
  }

  getSubscriberLedgerDataWithPagination(
    pageno: any,
    totalrecordsperpage: any
  ): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_subscriber_ledger_data_pagination.php`,
      { pageno, totalrecordsperpage }
    );
  }

  getAllSub(): Observable<any> {
    return this.httpClient.get(`${this.PHP_API_SERVER}/read_sub_list.php`);
  }

  getSearchedSub(searchedSub: { searchedSub: any; }) {
    ////console.log(searchedSub)
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/searchsubname.php`,
      searchedSub
    );
  }

  addSubscriber(newsub: any) {
    // console.log(dataFromUI);
    // var headers = new HttpHeaders();
    // headers.append('Accept', 'application/json');
    // headers.append('Content-Type', 'application/json');
    // headers.append('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, PUT');
    // headers.append('Access-Control-Allow-Origin', '*');
    // headers.append('Access-Control-Allow-Headers', '*');

    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_new_sub.php`,
      { newsub }
    );
    //return null;
  }

  addSub(newsub: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_new_sub_data.php`,
      { newsub }
    );
  }

  getSundayData(start: string, end: string) {
    return this.httpClient.post<any>('${this.PHP_API_SERVER}/insert_new_sub_data.php', { start, end });
  }


  getVatnavalData(data: { start: string; end: string }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_Vatnaval_all_data.php`,
      data
    );
  }

  saveVatnavalData(data: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_Vatnaval_Calculation_Data.php`,
      data
    );
  }


  getAllVatnavalTableData() {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/get_All_Vatnaval_Table_Data.php`
    );
  }

  getVatnavalDataByMonthYear(month: any, year: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_Vatnaval_View_Data_By_MothYear.php`,
      {
        month,
        year,
      }
    );
  }

  setPaymentcomm(req: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_advt_rep_commission.php`,
      req
    );
  }

  getdatabyreceipt(recpt_no: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_advt_print_details_rcptwise.php`,
      { recpt_no }
    );
  }

  getStamDataByReceiptNo(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_advt_stamp_rcpt_data_by_id.php`,
      { id }
    );
  }

  getdatabycomreceipt(recpt_no: string) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_print_comission_receipt.php`,
      { recpt_no }
    );
  }


  addPackage(pkgdata: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_new_package.php`,
      { pkgdata }
    );
  }

  addPackage1(pkgdata: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_package_1.php`,
      { pkgdata }
    );
  }

  addPackage3(pkgdata: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_package_3.php`,
      { pkgdata }
    );
  }

  addPackage5(pkgdata: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_package_5.php`,
      { pkgdata }
    );
  }

  updatePackage(pkgdata: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_package.php`,
      { pkgdata }
    );
  }

  updatePackage1(pkgdata: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_pkg_1_year.php`,
      { pkgdata }
    );
  }

  updatePackage3(pkgdata: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_pkg_3_year.php`,
      { pkgdata }
    );
  }

  updatePackage5(pkgdata: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_pkg_5_year.php`,
      { pkgdata }
    );
  }

  getsubcrdtvoucherPackageData(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_pkgdata_crdt_voucher.php`
    );
  }

  updatePackageManager(pkgdata: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_package_manager.php`,
      { pkgdata }
    );
  }

  getdistname(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_district_name.php`
    );
  }

  gettaluka(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_taluka_name.php`
    );
  }
  getprant(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_all_prant.php`
    );
  }
  get_dis_rep(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_dis_rep_list.php`
    );
  }

  getdistmode(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_dis_mode.php`
    );
  }
  getsubdistmode(dis_mode: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_dis_sub_mode.php`,
      { dis_mode }
    );
  }

  getsubdistmodeissue(dis_mode: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_dis_sub_mode_issuesale.php`,
      { dis_mode }
    );
  }

  getsubdistmodeissueseller(dis_mode: string[]) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_label_dis_mode.php`,
      { dis_mode }
    );
  }
  getsubdistmodeissueseller1(dis_mode: string[]) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_label_dis_mode1.php`,
      { dis_mode }
    );
  }

  getPackageData(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_package_data.php`
    );
  }

  getPackageBookingData(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_pkg_booking_data.php`
    );
  }

  // getPackageBookingData3(): Observable<any> {
  //   return this.httpClient.get<any>(
  //     `${this.PHP_API_SERVER}/get_pkg_booking_data3.php`
  //   );
  // }

  // getPackageBookingData5(): Observable<any> {
  //   return this.httpClient.get<any>(
  //     `${this.PHP_API_SERVER}/get_pkg_booking_data5.php`
  //   );
  // }

  getPackageId(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_next_package_id.php`
    );
  }

  getDebitVoucherPackageId(date: Date, bankcashaccount: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_next_debit_voucher_id.php`,
      { date, bankcashaccount }
    );
  }

  updateSub(newsub: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_sub_data.php`,
      { newsub }
    );
  }

  deleteSub(id: any) {
    return this.httpClient.put(
      `${this.PHP_API_SERVER}/update_subscribers_basic_details.php`,
      { id }
    );
  }

  addSubDetails(newsub: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_sub_details.php`,
      { newsub }
    );
  }

  updateSubType(subid: any, duration: any) {
    return this.httpClient.put(`${this.PHP_API_SERVER}/update_sub_type.php`, {
      subid,
      duration,
    });
  }

  getDatewiseAndRepwiseList(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_datewise_or_repwise_list.php`
    );
  }

  getDatewiseAndRepwiseData(
    start_date: any,
    end_date: any,
    rep_name: any,
    off_rep_name: any,
    district_name: any,
    taluka_name: any
  ): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_datewise_or_repwise_data.php`,
      {
        start_date,
        end_date,
        rep_name,
        off_rep_name,
        district_name,
        taluka_name,
      }
    );
  }

  getRepNameofSubDetails() {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_rep_name_subDetails.php`
    );
  }

  getOfficeRepwiseList(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_off_rep_wise_list.php`
    );
  }


  getOffRepWiseData(payload: { fy_start: string; fy_end: string }): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_montWiseVouvherData.php`,
      payload,
      { headers: { 'Content-Type': 'application/json' } }
    );
  }



  getvoucherbySub1(fyStart?: string, fyEnd?: string) {
    if (!fyStart || !fyEnd) {
      fyStart = sessionStorage.getItem('startDate') ?? '';
      fyEnd = sessionStorage.getItem('endDate') ?? '';
    }

    const payload: any = {};
    if (fyStart && fyEnd) {
      payload.fy_start = fyStart;
      payload.fy_end = fyEnd;
    }

    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_montWiseVouvherData.php`,
      payload
    );
  }



  getOffRepWiseList(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_off_rep_wise_list.php`
    );
  }




  getRemainingRenewableReceiptData(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_renewable_remaining_data.php`
    );
  }

  getRepresentativeSubAddressData(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_representativewise_sub_address.php`
    );
  }

  getDeptwiseOffRepList(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_deptwise_assign_off_rep_list.php`
    );
  }

  getSubscriberRcptNo(req: string): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_sub_rcpt_no.php`,
      { req }
    );
  }

  getSubscriberlatestRcptNo(date: string, rcpt_no: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_rcpt_newNo.php`,
      { date, rcpt_no }
    );
  }

  getSubscriberEntryDate(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_subscription_entry_date.php`,
      { id }
    );
  }

  NewMagazine(newmag: any, paymethod: string): Observable<any> {
    // console.log('newmag value ui', newmag);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_new_mag.php`,
      { newmag, paymethod }
    );
  }

  updateCreditLimit(
    ds_repid: number,
    ds_credit: number,
    ds_tempcredit: number
  ): Observable<any> {
    ////console.log(ds_repid, ds_credit , ds_tempcredit)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_rep_credit.php`,
      { ds_repid, ds_credit, ds_tempcredit }
    );
  }

  insertComissionLimit(
    ds_repid: number,
    ds_custmobile: number,
    ds_commamt: number,
    ds_id: number
  ): Observable<any> {
    ////console.log(ds_repid, ds_custmobile , ds_commamt)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_rep_comission.php`,
      { ds_repid, ds_custmobile, ds_commamt, ds_id }
    );
  }

  insertAdvtComissionLimit(
    ds_repid: number,
    ds_custmobile: number,
    ds_commamt: number,
    advt_id: number
  ): Observable<any> {
    ////console.log(ds_repid, ds_custmobile , ds_commamt)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_rep_advt_comission.php`,
      { ds_repid, ds_custmobile, ds_commamt, advt_id }
    );
  }

  getRepcredit(ds_repid: number) {
    ////console.log(ds_repid)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_rep_credit.php`,
      { ds_repid }
    );
  }

  addNewAdmin(dataFromUI: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/add_new_admin.php`,
      dataFromUI
    );
  }

  updateSubscriber(dataFromUI: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/cancel_subscriber.php`,
      dataFromUI
    );
  }

  cancelRepresentative(dataFromUI: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/cancel_representative.php`,
      dataFromUI
    );
  }

  getRepresentative(dataFromUI: number) {
    //////console.log("Data from Service : ",dataFromUI);
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_representative.php`,
      dataFromUI
    );
  }

  getPortalAllRepList() {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/portal_all_rep_list.php`
    );
  }

  getmaxadminid() {
    return this.httpClient.get(`${this.PHP_API_SERVER}/read_maxadmin.php`);
  }

  getPortalRepWiseCommission() {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/portal_repwise_commission.php`
    );
  }

  getAllBooks() {
    return this.httpClient.get(`${this.PHP_API_SERVER}/read_all_books.php`);
  }

  getAllBookData(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_all_book_data.php`
    );
  }
  getAllBookData3(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_author_list.php`
    );
  }

  getAllBooksData(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_books_all_data.php`
    );
  }

  getBookData(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_data.php`,
      {
        id,
      }
    );
  }

  insertMagazineIssueGranthCate(data: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_magazine_issue_granth_category.php`,
      { data }
    );
  }

  getMagazineIssueGranthCategoryData(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_magazine_issue_category_data.php`
    );
  }

  updateMagazineIssueGranthCategory(data: { id: any; mag_name: any; ig_cat: any; }, oldmag_name: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_magazine_and_category.php`,
      { data, oldmag_name }
    );
  }

  updateIssueDate(data: { id: any; issueName: any; issueDate: any; PublishedDate: any; price: any; lang: any; }) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_issue_dates.php`,
      { data }
    );
  }

  updateReturnReceipt(data: { id: any; clientname: any; returnreason: any; karyavahi: any; }) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_return_receipt.php`,
      { data }
    );
  }

  updateIssueDatetoInactive(id: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_issue_date_to_inactive.php`,
      { id }
    );
  }

  updateMagazineIssueGranthCategorytoInactive(id: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/updateMagazineInActive.php`,
      { id }
    );
  }

  getBookDataforCancel(bookname: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_data_for_cancel.php`,
      { bookname }
    );
  }

  getAdvtSizes(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/read_all_advt_sizes.php`
    );
  }

  getBookRegistration() {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/read_book_registration_report.php`
    );
  }

  getPortalSubRenewal() {
    return this.httpClient.get(`${this.PHP_API_SERVER}/portal_sub_renewal.php`);
  }

  getSubmagByIdorNumber(mobileNumber: number) {
    //console.log(mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_ntfc_mag_detail.php`,
      { mobileNumber }
    );
  }

  getSubRenewal(start_date: string, end_date: string, rep_id: any) {
    // console.log(start_date, end_date, rep_id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/portal_sub_renewal.php`,
      { start_date, end_date, rep_id }
    );
  }

  getBookwiseReport(book_name: any, start_date: any, end_date: any) {
    // console.log(book_name, start_date, end_date);
    // read_book_report_bookwise.php
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_book_report_bookwise.php`,
      { book_name, start_date, end_date }
    );
  }

  addSubscriptionType(data: { subtype: any; price: any; date: any; shortname: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_subscription_type.php`,
      { data }
    );
  }

  updateSubscriptionType(data: { id: number; subtype: any; price: any; date: any; shortname: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_subscription_type.php`,
      { data }
    );
  }

  getSubscriptionType() {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_subscription_type.php`,
      {}
    );
  }

  removeAdmin(id: number) {
    //console.log(id)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/Delete_admin.php`,
      { id }
    );
  }

  removeMag(magname: any) {
    // console.log(magname);
    return this.httpClient.post<any>(`${this.PHP_API_SERVER}/Delete_mag.php`, {
      magname,
    });
  }

  AddNewMag(
    magname: any,
    magedition: any,
    magprintamount: number,
    magdigitalamount: number,
    magbothamount: number,
    magyear: any,
    magdesc: any,
    magapp: any,
    magfullname: any
  ) {
    //console.log(magname)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_new_mags.php`,
      {
        magname,
        magedition,
        magprintamount,
        magdigitalamount,
        magbothamount,
        magyear,
        magdesc,
        magapp,
        magfullname,
      }
    );
  }

  changeMagPrice(
    magname: any,
    magedition: any,
    magprintamount: number,
    magdigitalamount: number,
    magbothamount: number,
    magyear: number
  ) {
    //console.log(magname)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/change_mag_price.php`,
      {
        magname,
        magedition,
        magprintamount,
        magdigitalamount,
        magbothamount,
        magyear,
      }
    );
  }

  AddNewevent(
    event_name: any,
    event_venue: any,
    event_fee: any,
    event_todate: any,
    event_fromdate: any,
    imagepath: any
  ) {
    //console.log(magname)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_new_events.php`,
      {
        event_name,
        event_venue,
        event_fee,
        event_todate,
        event_fromdate,
        imagepath,
      }
    );
  }

  AddNewBook(book: { bookname: any; authorname: any; bookdesc: any; prakashanname: any; bookpagesbw: any; bkpinsidecolor: any; bkpcover: any; totalpages: any; booksize: any; paperbw: any; paperinsidecolor: any; papercover: any; binding: any; booklang: any; book_img: any; isupcoming: any; upcomingdate: any; bookcategory: any; isgranth: string; }) {
    //console.log(magname)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_new_book.php`,
      {
        book,
      }
    );
  }

  updateBook(bookform: any) {
    return this.httpClient.post(`${this.PHP_API_SERVER}/update_new_book.php`, {
      bookform,
    });
  }

  addbooksize(booksize: any) {
    //console.log(magname)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_book_size.php`,
      { booksize }
    );
  }

  AddNewBookStock(bookeditiondata: { bookid: number; bookyear: any; bookprice: any; booksaleprice: any; yearwisebook: any; agentprice: any; discountupto: any; bookedition: any; bookedtndate: any; bookedtncpoies: any; opening_stock: any; author_honorarium: any; deliverychargesinclude: any; }) {
    //console.log(magname)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_book_stock.php`,
      { bookeditiondata }
    );
  }

  updateBookSubStockDetails(bookform: { bs_id: any; bookid: any; bookyear: any; bookprice: any; booksaleprice: any; book_price_year: any; agentprice: any; discountupto: any; bookedition: any; bookedtndate: any; bookedtncpoies: any; opening_stock: any; author_honorarium: any; deliverychargesinclude: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/update_book_stock_details.php`,
      { bookform }
    );
  }

  getBookEdition(bookname: any) {
    //console.log(magname)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_Book_Edition.php`,
      { bookname }
    );
  }

  cancelSubscriberrcpt(id: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_subscriber_rcpt_cancellation.php`,
      { id }
    );
  }

  getReceiptLedger(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_receipt_ledger.php`
    );
  }

  getReceiptLedgerTotal() {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_receipt_ledger_total.php`
    );
  }

  // getReceiptLedgerWithPagination(pageno, totalrecordsperpage): Observable<any> {
  //   return this.httpClient.post<any>(
  //     `${this.PHP_API_SERVER}/get_receipt_ledger_with_pagination.php`,
  //     { pageno, totalrecordsperpage }
  //   );
  // }

  //Old Code 
  // getReceiptLedgerData(startdate, enddate, cust_name): Observable<any> {
  //   return this.httpClient.post<any>(
  //     `${this.PHP_API_SERVER}/get_receipt_ledger_with_pagination.php`,
  //     { startdate, enddate, cust_name }
  //   );
  // }

  getReceiptLedgerData(startdate: string, enddate: string, cust_name: string): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_receipt_ledger_with_pagination.php`,
      { startdate, enddate, cust_name }
    );
  }

  getReceiptLedgerData3(data: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_receipt_ledger_with_pagination3.php`,
      { data }
    );
  }


  getalldata(): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_receipt_ledger_with_pagination2.php`,
      {}
    );
  }

  //Old Code
  // getGSTReportData(startdate, enddate) {
  //   return this.httpClient.post(
  //     `${this.PHP_API_SERVER}/get_gst_report_data.php`,
  //     { startdate, enddate }
  //   );
  // }

  getGSTReportData(startdate: string, enddate: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_gst_report_data.php`,
      { startdate, enddate }
    );
  }

  UpdateRcptCancellation(bookid: any) {
    //console.log(magname)
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_book_rcpt_cancellation.php`,
      { bookid }
    );
  }


  UpdateRcptCancellation1(bookid: any) {
    //console.log(magname)
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/Delete_bookbooking_seller.php`,
      { bookid }
    );
  }

  AddupdatedBookStock(bookid: any, total: number, available: number, comment: string) {
    // console.log(bookid, total, available, comment);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_new_book_stock.php`,
      { bookid, total, available, comment }
    );
  }

  ReadAllBookStock() {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/read_all_books_stock.php`
    );
  }

  removeEvent(event_id: number) {
    // console.log(event_id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/Delete_event.php`,
      { event_id }
    );
  }

  updateBookStock(book_id: any) {
    // console.log(book_id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_new_book_stock.php`,
      { book_id }
    );
  }

  Rep_invoiceBooks(rep_id: number, start_date: any, end_date: any) {
    // console.log(rep_id, start_date, end_date);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_rep_invoice_books.php`,
      { rep_id, start_date, end_date }
    );
  }

  getdepwiserepcount() {
    // console.log(category);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_depwise_rep_count.php`,
      {}
    );
  }

  getcountry() {
    // console.log(category);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_Country.php`,
      {}
    );
  }

  getseniority() {
    // console.log(category);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_seniority.php`,
      {}
    );
  }
  getlanguagelist() {
    // console.log(category);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_languages.php`,
      {}
    );
  }

  getoffrepname() {
    // console.log(category);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_off_rep_list.php`,
      {}
    );
  }


  getdept() {
    // console.log(category);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_department.php`,
      {}
    );
  }

  getRolesData() {
    // console.log(category);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_roles.php`,
      {}
    );
  }

  getUsersData() {
    // console.log(category);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_user_list.php`,
      {}
    );
  }

  getAdvtSizeByCategory(category: any) {
    // console.log(category);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_advt_sizes_by_category.php`,
      { category }
    );
  }

  saveAllRows(data: any[]) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/save_udishth.php`,
      { data }
    );
  }



  saveAllUdhistha(issue_name: string, issue_date: string, data: any[]) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/saveAllUdhistha.php`,
      {
        issue_name: issue_name,
        issue_date: issue_date,
        data: data
      }
    );
  }





  getListofassignrep(rep_type: string) {
    // console.log(category);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_depwise_rep.php`,
      { rep_type }
    );
  }

  getListofassignoff(off_rep: any) {
    // console.log(category);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_rep_offrepwise.php`,
      { off_rep }
    );
  }

  getAdvtCategory() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_category_list.php`,
      {}
    );
  }
  getgranthCategory() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_granth_category_list.php`,
      {}
    );
  }

  getLanguageList() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_languages.php`,
      {}
    );
  }

  getAdvtissuename() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_all_Issue_Dates.php`,
      {}
    );
  }

  getlabeldata(req1: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_sub_vargani_address.php`,
      { req1 }
    );
  }

  getdatabyvc(req1: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_voucher_against_data.php`,
      { req1 }
    );
  }
  getupdateolddata(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/update_old_advt.php`,
      { data }
    );
  }

  getdeleterecipt(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_deleted_all_type_receipt_no.php`,
      { data }
    );
  }
  getdeletebooking(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_deleted_all_type_receipt_no.php`,
      { data }
    );
  }


  getdeletecnrecipt(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_deleted_all_type_receipt_no.php`,
      { data }
    );
  }

  getIssueSellerName() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_name.php`,
      {}
    );
  }
  getIssueSellerByName(issuesellername: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/update_issue_seller_bu_name.php`,
      {}
    );
  }

  getSbhetdata(issue_date: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_saprem_bhet.php`,
      { issue_date }
    );
  }
  getIssuesaleSbhetdata(issue_date: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_all_issue_sale_saprem_bhet.php`,
      { issue_date }
    );
  }

  getRepName() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_rep_address.php`,
      {}
    );
  }

  getRepNameAddress() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_rep_advt_address.php`,
      {}
    );
  }

  getRepNameList(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_rep_address_list.php`,
      { req }
    );
  }

  getSbhetdataadmin() {

    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_saprem_bhet_admin.php`,
      {}
    );
  }
  getdeactivedata() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_saprem_bhet_deactive.php`,
      {}
    );
  }

  //Old Code 
  getDistributionRepresentativeSBhetHastewise(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_dis_repwise_hand_delivery.php`
    );
  }
  saveIssueSellerDistrictwiseStatementDataEntry1(
    data: {
      issue_date: string;
      country: string;
      state: string;
      district: string;

      number_of_subscribers: number;
      total: number;
      added_by: number;

      delivery_mode: string;
      distribution_mode?: string;
      sub_distribution_mode?: string;
      book_name?: string;
    }[]
  ) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_issue_seller_districtwise_statements1.php`,
      data
    );
  }
  saveIssueSellerDistrictwiseStatementDataEntry2(
    data: {
      issue_date: string;
      country: string;
      state: string;
      district: string;

      number_of_subscribers: number;
      total: number;
      added_by: number;

      delivery_mode: string;
      distribution_mode?: string;
      sub_distribution_mode?: string;
      book_name?: string;
    }[]
  ) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_issue_seller_districtwise_statements2.php`,
      data
    );
  }
  getDistributionRepresentativeSBhetHastewise1(
    payload: any
  ): Observable<any> {

    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_dis_repwise_hand_delivery1.php`,
      payload
    );

  }
  getDistributionRepresentativeSBhetHastewise2(
    payload: any
  ): Observable<any> {

    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_dis_repwise_hand_delivery2.php`,
      payload
    );

  }

  getDistributionRepresentativeJavakData(req1: any): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_print_order_data_used_by_javak.php`
    );
  }

  getprintOrderJavakCalData(req1: { issue_date_to: string }): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_Javak_Print_Data_Calculation.php`,
      req1
    );
  }

  getJavakDataFromAllDistCopies(req1: { issue_date_to: string }): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_javak_Data_Form_All_Distributer_Copies.php`,
      req1
    );
  }

  getnewapi(preweekfirstday: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_all_distributors_total.php`,
      { preweekfirstday }
    );
  }

  getnewapi1(req1: string) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_sub_vargani_count.php`,
      { req1 }
    );
  }

  getnewapi3(req1: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_sub_vargani_count_2.php`,
      { req1 }
    );
  }



  getissuenewapi1(req1: string) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_issue_Seller_sub_vargani_count.php`,
      { req1 }
    );
  }

  getJavakprati(req: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_advt_jawak.php`,
      { req }
    );
  }

  getMagzineJavakprati(req2: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_Magzine_Count_For_jawak.php`,
      req2
    );
  }

  addBookSellerEntry(bookseller: { title: any; name: any; address: any; sellertype: any; comptype: any; pincode: any; country: any; state: any; district: any; taluka: any; mobileNumber: any; gstNumber: any; email: any; dob: any; doa: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_book_seller_entry.php`,
      { bookseller }
    );
  }

  updateBookSellerEntry(bookseller: { bse_id: number; title: any; name: any; sellertype: any; comptype: any; address: any; pincode: any; country: any; state: any; district: any; taluka: any; mobileNumber: any; gstNumber: any; email: any; dob: any; doa: any; }) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_book_seller_entry.php`,
      { bookseller }
    );
  }

  addBookSellerEntryBookingDetails(bookseller: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_book_seller_entry_booking_details.php`,
      { bookseller }
    );
  }

  getBookSellerEntry() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_seller_entry.php`,
      {}
    );
  }

  getBookSellerEntryForBookRegistration() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_seller_entry_for_book_registration.php`,
      {}
    );
  }

  getBookRegistrationDataWithoutInvoice(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_book_registration_without_invoice.php`,
      {}
    );
  }

  getBookCrdtNote(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_book_crdt_note.php`,
      {}
    );
  }

  getBookCrdtNoteBooks(id: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_crdt_note_books.php`,
      { id }
    );
  }

  // getBookWiseReport() {
  //   return this.httpClient.post(
  //     `${this.PHP_API_SERVER}/get_book_wise_report.php`,
  //     {}
  //   );
  // }

  getBookCrdtVoucher() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_crdt_voucher.php`,
      {}
    );
  }

  getBookOutStandingData(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_book_out_standing_data.php`
    );
  }

  getBookRcptForLedger(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_book_rcpt_for_ledger.php`
    );
  }
  getBookUnpaidOutstandingIndetail(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_unpaid_outstanding_data_in_detail12.php`,
      req
    );
  }

  //Merge data of Book Seller Ledger
  // getBookSellerLedgerData(name) {
  //   return this.httpClient.post<any>(
  //     `${this.PHP_API_SERVER}/get_book_seller_ledger_data.php`,
  //     { name }
  //   );
  // }

  getBookdeleterecipt(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_deleted_receipt_no.php`,
      { data }
    );
  }


  getBookSellerLedgerData(req1: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_seller_ledger_data.php`,
      req1

    );
  }

  getBookSellerNames() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_seller_name.php`,
      {}
    );
  }
  getBookExpense(formData: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_stock_ledger_briefly2.php`,
      formData
    );
  }
  saveBookExpense(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/saveBookExpense.php`,
      data,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
  }

  getBookSellerNames1() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_seller_name1.php`,
      {}
    );
  }

  getBookRcptPymtData() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_data_for_book_rcpt_pymt.php`,
      {}
    );
  }

  insertBookPymtRcpt(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_book_pymt_rcpt_data.php`,
      { data }
    );
  }

  // getPymtRcptNo(): Observable<any> {
  //   return this.httpClient.get<any>(`${this.PHP_API_SERVER}/get_last_book_rcptno.php`);
  // }

  getPymtRcptNo(req: { date: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_last_book_rcptno.php`,
      { req }
    );
  }


  getCrdtNoteNo(date: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_crdtnote_no.php`,
      { date }
    );
  }

  insertCrdtNoteData(crdtNoteData: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_creditnote.php`,
      { crdtNoteData }
    );
  }

  insertCrdtNoteBooks(crdtNoteData: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_creditnote_books.php`,
      { crdtNoteData }
    );
  }

  insertBookPymtRcptandInvoicedata(bookrcptid: any, bookinvoiceid: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_book_pymt_rcpt_and_invoice_data.php`,
      { bookrcptid, bookinvoiceid }
    );
  }

  getBookSellerSpecificData(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_book_seller_specific_data.php`
    );
  }

  //   getBookSellerSpecificData3(receiverName: string): Observable<any> {
  //   return this.httpClient.get<any>(
  //     `${this.PHP_API_SERVER}/get_book_seller_specific_data.php`,
  //     { params: { receiver_name: receiverName } }
  //   );
  // }


  getBookSellerSpecificData3(receiver_name: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_seller_specific_data.php`,
      { receiver_name }
    );
  }

  sendWhatsAppReceipt(payload: { mobile: string; campaignName: string; templateParams: string[] }) {
    return this.httpClient.post(`${this.PHP_API_SERVER}/send_wp_msg_using_aisensy.php`, payload);
  }




  getBookSelSpecificData(request: { req1: { vstart_date: any; vend_date: any; estart_date: any; eend_date: any; rep_name: any; book_names: any; book_seller_name: any; }; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_vouchers_by_book_search.php`,
      request
    );
  }

  getGranthSelSpecificData(request: { req1: { vstart_date: any; vend_date: any; estart_date: any; eend_date: any; rep_name: any; book_names: any; book_seller_name: any; }; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_vouchers_by_granth_search.php`,
      request
    );
  }
  getBookSelSpecificData2(request: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_data_for_book_billing_Register_search.php`,
      request
    );
  }
  getBookSelSpecificData3(request: { req1: { start: string | null | undefined; end: string | null | undefined; bookwise: any[] | null | undefined; cust_name: any[]; }; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_data_book_invoice_search.php`,
      request
    );
  }

  getBookRegistrationReport(request: { start_date: string; end_date: string; rep_name: any; office_rep_name: any; book_seller_name: any; book_name: any; commissionFilter: string; complimentaryFilter: string; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_registration_report_search.php`,
      request
    );
  }


  getissueSelSpecificData(request: { req1: Partial<{ vstart_date: string; vend_date: string; estart_date: string; eend_date: string; rep_name: string; advtName: string; }>; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_vouchers_by_issue_seller_search.php`,
      request
    );
  }

  getBookSelSpecificData1(request: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_vouchers_by_book.php`,
      request
    );
  }

  getBookRegistrationLedgerReport5(req: { start_date: any; end_date: any; rep_name: any; office_rep_name: string[]; book_name: string[]; book_seller_name: string[]; commissionFilter: string[]; complimentaryFilter: string[]; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_data_for_book_registration_ledger.indetail6.php`,
      req
    );
  }


  getBookRegistrationLedgerReport3(req: { start_date: any; end_date: any; rep_name: any; office_rep_name: any; book_name: any; book_seller_name: any; commissionFilter: string[]; complimentaryFilter: string[]; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_data_for_book_registration_ledger.indetail3.php`,
      req
    );
  }





  getBookSellerSpecificData1(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_book_seller_data_for_additional_entry.php`
    );
  }

  // getRcptWiseBooks(id) {
  //   return this.httpClient.post<any>(
  //     `${this.PHP_API_SERVER}/get_rcptwise_book_data.php`,
  //     { id }
  //   );
  // }

  // getRcptWiseBooks1(id) {
  //   return this.httpClient.post<any>(
  //     `${this.PHP_API_SERVER}/get_rcptwise_book_data1.php`,
  //     { id }
  //   );
  // }

  getRcptWiseBooks(order_no: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_seller_specific_data1.php`,
      { order_no }
    );
  }

  getRcptWiseBooks1(order_no: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_seller_specific_data2.php`,
      { order_no }
    );
  }
  getBooksByOrderNos(uniqueOrderNos: any) {
    // console.log('bookdata', bookdata);
    return this.httpClient.post<any>(`${this.PHP_API_SERVER}/get_books1.php`, {
      uniqueOrderNos,
    });
  }
  getRcptWiseBooksForCreditNote(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_rcptwise_book_for_creditnote.php`,
      { id }
    );
  }

  updateRcptWiseBooks(bse_id: any, id: any, book_name: any, rcvdamt: any, remainingamt: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_rcptwise_book_data.php`,
      { bse_id, id, book_name, rcvdamt, remainingamt }
    );
  }

  updateRcptWiseBooks1(id: any, rcvdamt: any, remainingamt: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_rcptwise_book_data1.php`,
      { id, rcvdamt, remainingamt }
    );
  }

  getSingleBookSellerEntry(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_single_book_seller_entry.php`,
      { id }
    );
  }


  getSingleGranthSellerEntry(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_single_granth_seller_entry.php`,
      { id }
    );
  }

  getBookInviceForView(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_invoice_for_view.php`,
      { id }
    );
  }
  getgranthInviceForView(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_granth_invoice_for_view.php`,
      { id }
    );
  }
  getBookInviceDataForView(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_invoice_data_for_view.php`,
      { id }
    );
  }


  getgranthInviceDataForView(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_granth_invoice_data_for_view.php`,
      { id }
    );
  }
  addBookData(bookdata: any) {
    // console.log('bookdata', bookdata);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_book_data1.php`,
      { bookdata }
    );
  }

  getBookInvoiceData() {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_data_book_invoice.php`,
      {}
    );
  }
  getBookDataForCancel(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_data_for_cancel_order.php`,
      { id }
    );
  }

  getBooks(id: any) {
    // console.log('bookdata', bookdata);
    return this.httpClient.post<any>(`${this.PHP_API_SERVER}/get_books.php`, {
      id,
    });
  }

  getgranthBooks(id: any) {
    // console.log('bookdata', bookdata);
    return this.httpClient.post<any>(`${this.PHP_API_SERVER}/get_granth_book.php`, {
      id,
    });
  }
  updateBooksAsDeliverd(id: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_books_delivered.php`,
      {
        id,
      }
    );
  }

  getBookData1() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_data1.php`,
      {}
    );
  }

  getBookBillingData(name: any) {
    return this.httpClient.post<any>(
      //`${this.PHP_API_SERVER}/get_book_billing_data.php`,
      `${this.PHP_API_SERVER}/get_book_seller_credit_note_data.php`,
      { name }
    );
  }

  getBookDataforDelivery(payload: any = {}) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_data_for_delivery.php`,
      payload
    );
  }
  getBookDataforDelivery2(payload: any = {}) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_data_for_delivery2.php`,
      payload
    );
  }
  getBookDataforDelivery1(request: { req1: { start: string | null; end: string | null; repname: any; book_name: any; custname: any; }; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_data_for_delivery1.php`,
      request
    );
  }

  addAdvtSizes(advtdata: { advt_category: any; advt_size_name: any; isactive: string; }) {
    // console.log(advtdata);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_advt_sizes.php`,
      { advtdata }
    );
  }

  getAllAdvtSizes(): Observable<any> {
    // console.log(advtdata);
    return this.httpClient.get<any>(`${this.PHP_API_SERVER}/getAdvt_Sizes.php`);
  }

  updateAdvtSizes(data: { id: any; category: any; Advt_size: any; }) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/updateAdvtSizes.php`,
      { data }
    );
  }

  updateAdvtSizeInactive(id: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/updateAdvt_Size_Inactive.php`,
      { id }
    );
  }

  addIssueSellerEntry(issueseller: { issuesellername: any; address1: any; pincode: any; country: any; state: any; taluka: any; district: any; mnumber: any; email: any; landline_no: any; dob: any; gstno: any; panno: any; depositamt: any; option: any; sbhet?: any; distype?: any; issue_date?: any; issue_name?: any; id?: number; englishissuesellername?: any; edistricts?: any; opening_bal?: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_issue_seller_entry.php`,
      { issueseller }
    );
  }

  addIssueSellerSaprembhet(issueseller: { issueSellerId: any; sbhet: any; issue_name: any; issue_date: string; jahiratsbhet: any; issuesbhet: any; inputValue: any; input_value1: any; input_value2: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_issue_seller_saprem_bhet.php`,
      { issueseller }
    );
  }

  addstart_end_dates_to_rep(issueseller: { issueSellerId: number; start_date: any; end_date: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_issue_seller_saprem_bhet_deactive.php`,
      { issueseller }
    );
  }

  updatesbhetdata(issueseller: { issueSellerId: any; sbhet: any; issue_date: any; issue_name: any; jahiratsbhet: any; issuesbhet: any; input_value: any; input_value1: any; input_value2: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_issue_seller_saprem_bhet.php`,
      { issueseller }
    );
  }
  updatesdates(issueseller: { id: any; start_date: any; end_date: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_issue_seller_saprem_bhet_deactive.php`,
      { issueseller }
    );
  }
  addcountry(data: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_countries.php`,
      { data }
    );
  }

  addseniority(data: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_seniority.php`,
      { data }
    );
  }
  // addlanguage(data: any) {
  //   return this.httpClient.post<any>(
  //     `${this.PHP_API_SERVER}/insert_language.php`,
  //     { data }
  //   );
  // }

  updatecountry(data: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_countries.php`,
      { data }
    );
  }

  updateseniority(data: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_seniority.php`,
      { data }
    );
  }

  deleteseniority(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_seniority.php`,
      { id }
    );
  }

  deleteIssueSellerSaprembhet(issueseller: { issueSellerId: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_issue_seller_saprem_bhet.php`,
      { issueseller }
    );
  }
  deleteIssueStartEndDate(issueseller: { id: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_issue_seller_saprem_bhet_deactive.php`,
      { issueseller }
    );
  }

  deleteolddatalist(issueseller: { issueSellerId: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_issue_seller_entry.php`,
      { issueseller }
    );
  }

  deletemaster(data: { subTypeId: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_subscription_type.php`,
      { data }
    );
  }

  updateIssueSellerEntry(issueseller: { id: number; issuesellername: any; address1: any; pincode: any; country: any; state: any; taluka: any; district: any; mnumber: any; email: any; landline_no: any; dob: any; gstno: any; panno: any; depositamt: any; option: any; sbhet?: any; distype?: any; englishissuesellername?: any; edistricts?: any; opening_bal?: any; }) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_issue_seller_entry.php`,
      { issueseller }
    );
  }

  addOfficeRep(addofficerep: { officerep: any; address1: any; pincode: any; country: any; state: any; taluka: any; district: any; mnumber: any; email: any; landline_no: string | null; dob: any; gstno: any; panno: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_office_rep_data.php`,
      { addofficerep }
    );
  }

  adddeptwiseOfficeRep(deptwiserep: { rep_id: number; book_id: any; sub_id: any; advt_id: any; issue_id: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_deptwise_office_rep.php`,
      { deptwiserep }
    );
  }

  updateDeptwiseOffRepAssign(deptwiserep: { id: number; book_id: any; sub_id: any; advt_id: any; issue_id: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_deptwise_office_rep.php`,
      { deptwiserep }
    );
  }

  getBookWiseRep(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_book_store_wise_rep.php`
    );
  }

  getSubscriptionWiseRep(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_subscription_wise_rep.php`
    );
  }

  // updateOfficeRep(id, uid, type) {
  //   return this.httpClient.put<any>(
  //     `${this.PHP_API_SERVER}/update_office_rep.php`,
  //     { id, uid, type }
  //   );
  // }


  updateOfficeRep(id: number, uid: number, type: string, numberValue?: string | number | null | undefined) {
    const body: any = { id, uid, type };

    // Add number only if it's provided (for advt type)
    if (numberValue !== null && numberValue !== undefined && numberValue !== '') {
      body.number = numberValue;
    }

    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_office_rep.php`,
      body
    );
  }

  getAdvtWiseRep(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_advt_wise_rep.php`
    );
  }

  getNextBookingNo(date: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_next_booking_no.php`,
      { date }
    );
  }

  getIssueWiseRep(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_issue_wise_rep.php`
    );
  }

  getNextIssueSerialNo(issuedate: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_serial_no.php`,
      { issuedate }
    );
  }

  setnewbookingnumber() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_latest_invoice.php`,
      {}
    );
  }

  getAdvtcatsize(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_size_count.php`,
      { data }
    );
  }

  getAdvtcheckforudate(id: number) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_invoice_status_of_advt.php`,
      { id }
    );
  }


  addIssueSellerAgent(issueselleragent: { id: number; issuerate: any; issuecopies: any; grossamt: any; discount: any; amount: any; netamount: any; complementrycopies: any; subscriptioncopies: any; distributedtype: any; subtype: any; details: any; opening_bal: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_issue_seller_agent.php`,
      { issueselleragent }
    );
  }

  addAdvtDates(issuedata: { advt_category: any; issuedate: string; publisheddate: string; issue_name: any; issue_price: any; lang: any; blackwhite: any; insidecolour: any; cover: any; totalpages: any; issuesize: any; percopyweight: any; prntdcopies: any; maflitho: any; lwc: any; artpaper: any; paperreams1: any; paperreams2: any; paperreams3: any; rnireleated: any; }) {
    // console.log('issue dates', issuedata);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_advt_dates.php`,
      { issuedata }
    );
  }

  checkDuplicateIssueDate(issueName: any, issueDate: string, publishedDate: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/check_repeat_issue_date.php`,
      { issueName, issueDate, publishedDate }
    );
  }

  getAdvtByid(advt_id: number) {
    // console.log(advt_id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_advt_details_by_id_mobile.php`,
      { advt_id }
    );
  }

  removeBook(book_id: any) {
    // console.log(book_id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_book_status.php`,
      { book_id }
    );
  }

  getSubByIdorNumber(sub_id: number, mobileNumber: number) {
    //console.log(sub_id, mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_ntfc_sub_details.php`,
      { sub_id, mobileNumber }
    );
  }

  getAdvtMobileorid(owner_name: number, mobileNumber: number, advt_name: string) {
    //console.log(sub_id, mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_advt_person_by_mobile.php`,
      { owner_name, mobileNumber, advt_name }
    );
  }

  cancelAdvt(id: number) {
    return this.httpClient.post<any>(`${this.PHP_API_SERVER}/cancelAdvt.php`, {
      id,
    });
  }

  cancelContractDetails(id: number) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/cancelContractDetails.php`,
      {
        id,
      }
    );
  }

  cancelAdvtSubDetails(id: number) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/cancelAdvtSubDetails.php`,
      {
        id,
      }
    );
  }

  insertContractDetails(data: { advt_id: number; contractno: any; contractdate: string; repname: any; offrepname: any; advtname: any; priviousbal: any; contractamt: any; discountamt: any; gstie: any; netamt: any; netgstprice: any; nettotal: any; subCategory: any; contractfromdate: string; contracttodate: string; bookingadvtamt: any; balamt: any; instruction: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insertContractDetails.php`,
      { data }
    );
  }

  getNextContractNo(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_next_contract_no.php`
    );
  }

  getContractDetails(advt_id: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_contract_details_using_advt_id.php`,
      { advt_id }
    );
  }


  getSubprofile(mobileNumber: number) {
    //console.log(mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_subscriberProfile.php`,
      { mobileNumber }
    );
  }

  getvalidAdmin(mobileNumber: number) {
    //console.log(mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_valid_admin.php`,
      { mobileNumber }
    );
  }

  getalladmin() {
    return this.httpClient.get(`${this.PHP_API_SERVER}/read_all_admin.php`);
  }

  getalldeliverydetails() {
    return this.httpClient.get(`${this.PHP_API_SERVER}/read_bookDelivery.php`);
  }

  updateBookDelivery(tracking_id: string, transport_method: string, id: any, transporter_name: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/update_delivery_details.php`,
      { tracking_id, transport_method, id, transporter_name }
    );
  }

  UpdateDeliveryStatus(id: any, delivery_date: any) {
    // console.log(id, delivery_date);
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/update_delivery_status.php`,
      { id, delivery_date }
    );
  }

  CancelDeliveryStatus(id: any, cancel_date: string) {
    // console.log(id, cancel_date);
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/update_cancel_delivery_status.php`,
      { id, cancel_date }
    );
  }

  getallEvent() {
    return this.httpClient.get(`${this.PHP_API_SERVER}/read_event_list.php`);
  }

  getPortalSubEmailMobile() {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/portal_sub_email_mobile.php`
    );
  }

  getPortalWiseCollectionDetails(rptstartdate: string, rptenddate: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/portal_datewise_collection_details.php`,
      { rptstartdate, rptenddate }
    );
  }

  getNewSubscibersDataDateWise(repid: number, todate: string, frmdate: string) {
    //console.log("From Service -> Id : ",repid,"date : ",rptdate);
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/portal_repwise_datewise_subnames.php`,
      { repid, todate, frmdate }
    );
  }

  cancelSubscriber(dataFromUI: any) {
    ////console.log("Data from Service : ",dataFromUI);
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_subscriber.php`,
      dataFromUI
    );
  }

  getPortaldashboardheadings() {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/portal_dashboard_headings.php`
    );
  }

  getPortaldashboardtotalsales() {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/portal_dashboard_totalsales.php`
    );
  }

  getPortaldashboardnewsubs() {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/portal_dashboard_newsubcount.php`
    );
  }

  getPortaldashboardrepdata() {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/portal_dashboard_repdetails.php`
    );
  }

  getMag(): Observable<any[]> {
    ////console.log(ds_repid)
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/read_magList.php`
    );
  }

  insertNewMag(newmag: any, paymethod: any) {
    //console.log("Mag Form Data",newmag,"paymethod",paymethod);
    return this.httpClient.post(`${this.PHP_API_SERVER}/insert_new_mag.php`, {
      newmag,
      paymethod,
    });
  }

  updateNewMag(
    mobileNumber: number,
    ds_mag1: string,
    ds_mag1edition: string
  ): Observable<any> {
    //console.log(mobileNumber , ds_mag1 , ds_mag1edition)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_mag_renew.php`,
      { mobileNumber, ds_mag1, ds_mag1edition }
    );
  }

  getcustrep(mobile: number) {
    //console.log(mobile)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_cust_repid.php`,
      { mobile }
    );
  }

  getRepbyid(ds_repid: any) {
    //console.log(ds_repid)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_repbyid.php`,
      { ds_repid }
    );
  }

  addAuthorAddress(data: { authorname: any; address: any; pincode: any; country: any; state: any; district: any; taluka: any; mob_no: any; email: any; pan_no: any; aadhar_no: any; bank_name: any; branch: any; acc_no: any; ifsc_code: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_author_address.php`,
      { data }
    );
  }

  updateAuthorAddress(data: { id: number; authorname: any; address: any; pincode: any; country: any; state: any; district: any; taluka: any; mob_no: any; email: any; pan_no: any; aadhar_no: any; bank_name: any; branch: any; acc_no: any; ifsc_code: any; }) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_author_address.php`,
      { data }
    );
  }

  deleteAuthorAddress(id: number) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/delete_author_address.php`,
      { id }
    );
  }

  getAuthorData() {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_author_data.php`
    );
  }

  getBookSellerAddress() {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_book_seller_address.php`
    );
  }

  getOfficeRepData() {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_office_rep_data.php`
    );
  }


  getDataForInvoice(sub_id: any, mobileNumber: any) {
    //console.log(sub_id, mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_ntfc_sub_details.php`,
      { sub_id, mobileNumber }
    );
  }

  updatecreditvoucher(id: any, crdtvno: any, amt: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_credit_voucher_book.php`,
      { id, crdtvno, amt }
    );
  }

  updatecreditvoucherofsub(id: any, amt: number) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_credit_voucher_sub.php`,
      { id, amt }
    );
  }

  updatecreditvoucherofsubpkg(id: any, amt: number) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_crdt_voucher_pkg_sub.php`,
      { id, amt }
    );
  }

  updatebookinvoice(id: any, invoiceno: any, remaingamt: any, check: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_book_receipt.php`,
      { id, invoiceno, remaingamt, check }
    );
  }

  updatecustrep(repid: number, mobileNumber: number) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_cust_rep.php`,
      { repid, mobileNumber }
    );
  }

  insertCustRepdata(mobile: number, repid: number): Observable<any> {
    //console.log(mobile, repid)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_cust_rep.php`,
      { mobile, repid }
    );
  }

  updateMagCancel(
    mobileNumber: number,
    ds_mag1: string,
    ds_mag1edition: string
  ): Observable<any> {
    //console.log(mobileNumber , ds_mag1 , ds_mag1edition)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_mag_cancel.php`,
      { mobileNumber, ds_mag1, ds_mag1edition }
    );
  }

  insertSubRenew(sub_id: number): Observable<any> {
    //console.log(sub_id)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_renewsub_notif.php`,
      { sub_id }
    );
  }

  checksubisexist(ds_mobile: number) {
    // console.log(ds_mobile);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/check_sub_exist.php`,
      { ds_mobile }
    );
  }

  inactivesub(id: any, status: any) {
    // console.log(ds_mobile);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_active_inactive.php`,
      { id, status }
    );
  }

  checkrepisexist(rep_mobile: number) {
    // console.log(rep_mobile);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/check_rep_exist.php`,
      { rep_mobile }
    );
  }

  makesuperAdmin(id: number, flag: string) {
    // console.log(id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_superAdmin.php`,
      { id, flag }
    );
  }

  checkadminisexist(mobile: number) {
    // console.log(mobile);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/check_admin_exist.php`,
      { mobile }
    );
  }

  checkadminissuper(id: number) {
    // console.log(id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/check_admin_is_super.php`,
      { id }
    );
  }

  getAllContries(): Observable<any[]> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/read_all_countries.php`
    );
  }

  getAllContries1(): Observable<any[]> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/read_all_countries_issue.php`
    );
  }

  sendSMS(mobile: number, msg: string, template: string) {
    //mobile = 7276169890
    var headers = new HttpHeaders();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, PUT');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Access-Control-Allow-Headers', '*');
    //console.log(mobile, msg)
    return this.httpClient.post<any>(`${this.PHP_API_SERVER}/send_language_sms.php`, {
      mobile,
      msg,
      template,
    });
    //return this.httpClient.get<any>(`http://sms6.rmlconnect.net:8080/bulksms/bulksms?username=Oemtrans&password=Oem@1234&type=0&dlr=1&destination=7276169890&source=BRHMAN&message=${msg}` , {headers:headers});
  }

  sendWhatsAppMSG(payload: any) {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    });

    return this.httpClient.post<any>(`${this.PHP_API_SERVER}/send_wp_msg_using_aisensy.php`,
      payload,
      { headers }
    );
  }

  sendWhatsAppMSGForVoucherListMaually(payload: any) {

    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    });

    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/send_Uncompleted_Vouchers_Againest_Recipt_List.php`,
      payload,
      { headers }
    );

  }

  getPendingPayment(): Observable<any[]> {
    //console.log(ds_repid)
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/read_pending_payment.php`
    );
  }

  getAdvtPendingPayment(): Observable<any[]> {
    //console.log(ds_repid)
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/read_advt_pending_payment.php`
    );
  }

  getBookPendingPayment(): Observable<any[]> {
    //console.log(ds_repid)
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/read_book_pending_payment.php`
    );
  }

  getPrevCommpay(ds_repid: any) {
    // console.log(ds_repid);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_paybyid.php`,
      { ds_repid }
    );
  }

  getPrevCommpay_book(ds_repid: number, id: number) {
    // console.log(ds_repid);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_paybyid_book.php`,
      { ds_repid, id }
    );
  }

  getcurrentcommpay(ds_repid: any) {
    // console.log(ds_repid);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_currentpaybyid.php`,
      { ds_repid }
    );
  }

  getcurrentcommpay_book(ds_repid: number, id: number) {
    // console.log(ds_repid, id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_currentpaybyid_book.php`,
      { ds_repid, id }
    );
  }

  updatepaymentdep(
    id: number,
    closingoutstanding: any,
    ispartial: string,
    comment: any
  ): Observable<Newsubscription> {
    // console.log(id, closingoutstanding, ispartial);
    return this.httpClient.post<Newsubscription>(
      `${this.PHP_API_SERVER}/update_payment_deposite.php`,
      { comment, id, closingoutstanding, ispartial }
    );
  }

  updatepaymentdep_book(
    id: number,
    closingoutstanding: any,
    ispartial: string,
    comment: any
  ): Observable<Newsubscription> {
    // console.log(id, closingoutstanding, ispartial);
    return this.httpClient.post<Newsubscription>(
      `${this.PHP_API_SERVER}/update_payment_deposite_book.php`,
      { comment, id, closingoutstanding, ispartial }
    );
  }

  updatepaymentdep_advt(
    id: number,
    closingoutstanding: any,
    ispartial: string,
    comment: any
  ): Observable<Newsubscription> {
    // console.log(id, closingoutstanding, ispartial);
    return this.httpClient.post<Newsubscription>(
      `${this.PHP_API_SERVER}/update_payment_deposite_advt.php`,
      { comment, id, closingoutstanding, ispartial }
    );
  }

  updatepaymntstus_book(
    bdp_id: number,
    ds_subpymtcmpt: string
  ): Observable<any> {
    // console.log(ds_subpymtcmpt, bdp_id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_sub_pymt_book.php`,
      { bdp_id, ds_subpymtcmpt }
    );
  }

  updatepaymntstus_advt(
    advt_id: number,
    ds_subpymtcmpt: string
  ): Observable<any> {
    // console.log(ds_subpymtcmpt, advt_id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_sub_pymt_advt.php`,
      { advt_id, ds_subpymtcmpt }
    );
  }

  updatepaymntstus(
    mobileNumber: number,
    ds_subpymtcmpt: string
  ): Observable<any> {
    // console.log(ds_subpymtcmpt, mobileNumber);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_sub_pymt.php`,
      { mobileNumber, ds_subpymtcmpt }
    );
  }

  updateMagpaymntstus(
    ds_subid: number,
    ds_subpymtcmpt: string
  ): Observable<any> {
    // console.log(ds_subpymtcmpt);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_renewsub_pymt.php`,
      { ds_subid, ds_subpymtcmpt }
    );
  }

  insertCashNtfcn(amt: number, repid: number): Observable<any> {
    // console.log(amt, repid);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_cash_ntfcn.php`,
      { amt, repid }
    );
  }

  updateVoucherStatus(voucher_no: any): Observable<Newsubscription> {
    return this.httpClient.post<Newsubscription>(
      `${this.PHP_API_SERVER}/update_voucher_status.php`,
      { voucher_no }
    );
  }

  updatePartialPayment_book(rep_id: number): Observable<Newsubscription> {
    return this.httpClient.post<Newsubscription>(
      `${this.PHP_API_SERVER}/update_partial_payment_book.php`,
      { rep_id }
    );
  }

  updatePartialPayment_advt(rep_id: number): Observable<Newsubscription> {
    return this.httpClient.post<Newsubscription>(
      `${this.PHP_API_SERVER}/update_partial_payment_advt.php`,
      { rep_id }
    );
  }

  updatePartialPayment(rep_id: number): Observable<Newsubscription> {
    // console.log(rep_id);
    return this.httpClient.post<Newsubscription>(
      `${this.PHP_API_SERVER}/update_partial_payment.php`,
      { rep_id }
    );
  }

  insertTitle(title: any): Observable<any> {
    //console.log(sub_id)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_new_titles.php`,
      { title }
    );
  }

  insertOccupations(occupation: any, occupation_value: any): Observable<any> {
    //console.log(sub_id)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_new_occupation.php`,
      { occupation, occupation_value }
    );
  }

  getAlltitle(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/read_all_titles.php`
    );
  }

  getOccupation(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/read_all_occupation.php`
    );
  }

  removetitle(title: any): Observable<Newsubscription> {
    // console.log(title);
    return this.httpClient.post<Newsubscription>(
      `${this.PHP_API_SERVER}/update_title.php`,
      { title }
    );
  }

  removeoccupdation(occupation: any): Observable<Newsubscription> {
    // console.log(occupation);
    return this.httpClient.post<Newsubscription>(
      `${this.PHP_API_SERVER}/update_occupation.php`,
      { occupation }
    );
  }

  removeStateandCity(state_id: number): Observable<any> {
    // console.log(state_id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_state_and_cities.php`,
      { state_id }
    );
  }
  removeOlddatay(id: number): Observable<any> {
    // console.log(state_id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_old_advt.php`,
      { id }
    );
  }
  removeadvttype(id: number): Observable<any> {
    // console.log(state_id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_advt_type.php`,
      { id }
    );
  }

  removeadvtudhishta(id: number): Observable<any> {
    // console.log(state_id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_rep_udhishta.php`,
      { id }
    );
  }

  // InsertNewState(state_name: any, country_code: string, country_id: number): Observable<any> {
  //   // console.log(state_name);
  //   return this.httpClient.post<any>(
  //     `${this.PHP_API_SERVER}/insert_new_state.php`,
  //     { state_name, country_code, country_id }
  //   );
  // }

  // InsertNewCity(city_name: any, prant_id: any, state_id: number): Observable<any> {
  //   // console.log(city_name, state_id);
  //   return this.httpClient.post<any>(
  //     `${this.PHP_API_SERVER}/insert_new_city.php`,
  //     { city_name, prant_id, state_id }
  //   );
  // }

  removeCity(id: number): Observable<any> {
    // console.log(id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_cities.php`,
      { id }
    );
  }

  // InsertNewTaluka(taluka_name: any, pincode: any, district_id: number): Observable<any> {
  //   // console.log(city_name, state_id);
  //   return this.httpClient.post<any>(
  //     `${this.PHP_API_SERVER}/insert_new_taluka.php`,
  //     { taluka_name, pincode, district_id }
  //   );
  // }

  removeTaluka(id: number): Observable<any> {
    // console.log(id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_talukas.php`,
      { id }
    );
  }




  getOfficeRepwiseListByDateRange(fyStart: string, fyEnd: string): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_last_year_business_data.php`,
      { fy_start: fyStart, fy_end: fyEnd }
    );
  }



  InsertNewState(state_name: any, country_code: string, sequence_id: number, country_id: number): Observable<any> {
    // console.log(state_name);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_new_state.php`,
      { state_name, country_code, sequence_id, country_id }
    );
  }



  InsertNewCity(city_name: any, prant_id: any, sequence_id: any, state_id: number): Observable<any> {
    // console.log(city_name, state_id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_new_city.php`,

      { city_name, prant_id, sequence_id, state_id }
    );
  }


  InsertNewTaluka(taluka_name: any, pincode: any, sequence_id: number, district_id: number): Observable<any> {
    // console.log(city_name, state_id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_new_taluka.php`,

      { taluka_name, pincode, sequence_id, district_id }
    );
  }


  updateDistrictName(district_id: number, district_name: any, sequence_id: number, prant_id: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_district_name.php`,

      { district_id, district_name, sequence_id, prant_id }
    );
  }


  updateStateName(state_id: number, state_name: any, sequence_id: number) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_state_name.php`,
      { state_id, state_name, sequence_id }
    );
  }


  updateTalukaName(taluka_id: number, taluka_name: any, sequence_id: number, taluka_pincode: number) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_taluka_name.php`,
      { taluka_id, taluka_name, sequence_id, taluka_pincode }
    );
  }



  // ***************** Prant Master Start *************************
  // insertPrantData(prant_name: string) {
  //   return this.httpClient.post(
  //     `${this.PHP_API_SERVER}/insert_prant_master.php`,
  //     { prant_name }
  //   );
  // }

  getAllPrantData() {
    return this.httpClient.get(`${this.PHP_API_SERVER}/get_all_prant_data.php`);
  }

  removePrant(id: number) {
    return this.httpClient.post(`${this.PHP_API_SERVER}/delete_prant.php`, {
      id,
    });
  }

  // updatePrantData(id: number, prant_name: any) {
  //   return this.httpClient.post(
  //     `${this.PHP_API_SERVER}/update_prant_name.php`,
  //     {
  //       id,
  //       prant_name,
  //     }
  //   );
  // }
  // ***************** Prant Master End ***************************

  getBookCustInvoiceId(date: string) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_cust_invoiceid.php`,
      { date }
    );
  }



  getBookSellerId(date: string) {
    const requestBody = { req: { date } }; // Correct JSON format

    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_seller_id.php`,
      requestBody
    );
  }




  InsertInvoice(
    rep_name: string,
    rep_mobile: string,
    rep_id: number,
    rep_address: string,
    state: string,
    state_code: string,
    gst: any,
    total_amount: number,
    rep_commision: number,
    cgst: number,
    sgst: number,
    igst: number
  ) {
    //console.log("Mag Form Data",newmag,"paymethod",paymethod);
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_rep_invoice.php`,
      {
        rep_name,
        rep_mobile,
        rep_id,
        rep_address,
        state,
        state_code,
        gst,
        total_amount,
        rep_commision,
        cgst,
        sgst,
        igst,
      }
    );
  }

  InsertCustInvoice(
    rep_name: any,
    rep_mobile: any,
    rep_id: any,
    rep_address: any,
    invoice_id: any,
    invoice_date: string,
    state: string,
    state_code: string,
    gst: string,
    total_amount: number,
    total_shipping_charges: number,
    rep_commision: number,
    cgst: number,
    sgst: number,
    igst: number,
    isGranth?: string   // ✅ FIXED (optional + correct type)
  ) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_cust_invoice.php`,
      {
        rep_name,
        rep_mobile,
        rep_id,
        rep_address,
        invoice_id,
        invoice_date,
        state,
        state_code,
        gst,
        total_amount,
        total_shipping_charges,
        rep_commision,
        cgst,
        sgst,
        igst,
        isGranth: isGranth || 'N'   // ✅ default value
      }
    );
  }
  InsertCustInvoiceSubscription(
    rep_name: string,
    rep_mobile: string,
    rep_id: number,
    rep_address: string,
    state: string,
    state_code: string,
    gst: any,
    total_amount: number,
    rep_commision: number,
    cgst: number,
    sgst: number,
    igst: number
  ) {
    //console.log("Mag Form Data",newmag,"paymethod",paymethod);
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_cust_invoice_subscription.php`,
      {
        rep_name,
        rep_mobile,
        rep_id,
        rep_address,
        state,
        state_code,
        gst,
        total_amount,
        rep_commision,
        cgst,
        sgst,
        igst,
      }
    );
  }

  InsertCustInvoiceadvertisement(
    rep_name: string,
    rep_mobile: string,
    rep_id: number,
    rep_address: string,
    state: string,
    state_code: string,
    gst: any,
    total_amount: number,
    rep_commision: number,
    cgst: number,
    sgst: number,
    igst: number,
    total_discount: number,
    discounted_price: number
  ) {
    //console.log("Mag Form Data",newmag,"paymethod",paymethod);
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_cust_invoice_advt.php`,
      {
        rep_name,
        rep_mobile,
        rep_id,
        rep_address,
        state,
        state_code,
        gst,
        total_amount,
        rep_commision,
        cgst,
        sgst,
        igst,
        total_discount,
        discounted_price,
      }
    );
  }

  InsertInvoiceData(invoice_id: number, description: any, qty: number, rate: number, total: number) {
    //console.log("Mag Form Data",newmag,"paymethod",paymethod);
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_rep_invoice_data.php`,
      {
        invoice_id,
        description,
        qty,
        rate,
        total,
      }
    );
  }

  insertBankName(data: { bank_name: any; bank_short_name: any; bank_o_bal: any; crdtdebt: any; is_active: string; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_bank_names.php`,
      { data }
    );
  }

  updateBankName(data: { id: number; bank_name: any; bank_short_name: any; bank_o_bal: any; crdtdebt: any; }) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_bank_master.php`,
      { data }
    );
  }

  read_bank_names() {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/read_bank_names.php`
    );
  }
  read_bank_names1() {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_bank_names.php`
    );
  }


  readBankwiseOpeningBalance(banktype: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/read_bankwise_opening_bal.php`,
      {
        banktype,
      }
    );
  }

  getdataforbookbilling() {
    //console.log("Mag Form Data",newmag,"paymethod",paymethod);
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_data_for_book_billing_Register.php`,
      {}
    );
  }

  getdataforgranthbilling() {
    //console.log("Mag Form Data",newmag,"paymethod",paymethod);
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_granth_data_for_billing_register.php`,
      {}
    );
  }

  InsertCustInvoiceData(
    invoice_id: number,
    bookname: any,
    authorname: any,
    bookcopies: number,
    discount: number,
    discountamt: number,
    bookprice: number,
    booksaleprice: number,
    agentprice: number,
    book_price_year: number,
    total: number,
    shippingcharges: number,
    total_amount: number,
    received_amt: number,
    remaining_amt: number,
    rep_commission_precent: number,
    rep_commission_amt: number
  ) {
    //console.log("Mag Form Data",newmag,"paymethod",paymethod);
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_cust_invoice_data.php`,
      {
        invoice_id,
        bookname,
        authorname,
        bookcopies,
        discount,
        discountamt,
        bookprice,
        booksaleprice,
        total,
        shippingcharges,
        total_amount,
        received_amt,
        remaining_amt,
        rep_commission_precent,
        rep_commission_amt,
      }
    );
  }

  InsertCustInvoiceDataSubscription(invoice_id: number, description: any, qty: number, rate: number, total: number) {
    //console.log("Mag Form Data",newmag,"paymethod",paymethod);
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_cust_invoice_data_subscription.php`,
      {
        invoice_id,
        description,
        qty,
        rate,
        total,
      }
    );
  }

  InsertCustInvoiceDataAdvertisment(
    invoice_id: number,
    description: any,
    advt_size: any,
    published_date: any,
    page_number: any
  ) {
    //console.log("Mag Form Data",newmag,"paymethod",paymethod);
    console.log(
      invoice_id,
      description,
      advt_size,
      published_date,
      page_number
    );
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_cust_invoice_data_advt.php`,
      {
        invoice_id,
        description,
        advt_size,
        published_date,
        page_number,
      }
    );
  }

  getRepInvoices(start_date: any, end_date: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_rep_invoices.php`,
      { start_date, end_date }
    );
  }

  getCustInvoices(start_date: any, end_date: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_cust_invoices.php`,
      { start_date, end_date }
    );
  }

  getRepCommissionData() {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_rep_commission_data.php`
    );
  }

  getCustInvoicesSubscription(start_date: any, end_date: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_cust_invoices_Subscription.php`,
      { start_date, end_date }
    );
  }

  getCustInvoicesadvt(start_date: any, end_date: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_cust_invoices_advt.php`,
      { start_date, end_date }
    );
  }

  getRepInvoicesData(invoice_id: number) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_rep_invoices_data.php`,
      { invoice_id }
    );
  }

  getCustInvoicesData(invoice_id: number) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_cust_invoices_data.php`,
      { invoice_id }
    );
  }

  getVoucher_no(id: number) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_voucher_no_by_dept.php`,
      { id }
    );
  }

  getCustInvoicesDataSubscription(invoice_id: number) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_cust_invoices_data_Subscription.php`,
      { invoice_id }
    );
  }

  getadvtInvoiceData(invoice_id: number) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_advt_invoices_data.php`,
      { invoice_id }
    );
  }

  getCustInvoicesName(start_date: any, end_date: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_cust_invoice_books.php`,
      { start_date, end_date }
    );
  }

  getCustInvoicesbookNames(bdp_id: string) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_cust_invoice_books_name.php`,
      { bdp_id }
    );
  }

  getCustbymobileordate(start_date: string, end_date: string, mobile: string | number, cust_id: string | number) {
    console.log(start_date, end_date, mobile, cust_id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_cust_details.php`,
      { start_date, end_date, mobile, cust_id }
    );
  }

  getOldStartDates(ds_id: number, mobile: number) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_mag_start_dates.php`,
      { ds_id, mobile }
    );
  }

  getOldendDates(ds_id: number, mobile: number) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_mag_end_dates.php`,
      { ds_id, mobile }
    );
  }

  updateEndDate(mobileNumber: number, ds_magenddate: string, ds_magedition: any): Observable<any> {
    // console.log(mobileNumber, ds_magenddate, ds_magedition);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_mag_end_date.php`,
      { mobileNumber, ds_magenddate, ds_magedition }
    );
  }

  updateStartDate(
    mobileNumber: number,
    ds_magstartdate: string,
    ds_magedition: any
  ): Observable<any> {
    // console.log(mobileNumber, ds_magstartdate, ds_magedition);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_mag_start_date.php`,
      { mobileNumber, ds_magstartdate, ds_magedition }
    );
  }

  updateSubTrackingDetails(
    ds_id: any,
    transport_method: any,
    transporter_name: any,
    tracking_details: any
  ): Observable<any> {
    // console.log(ds_id, transport_method, transporter_name, tracking_details);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_sub_tracking_details.php`,
      {
        ds_id,
        transport_method,
        transporter_name,
        tracking_details,
      }
    );
  }

  updateUserBlockingStatus(cust_id: any, setStatus: any, mobile: number): Observable<any> {
    // console.log(cust_id, setStatus, mobile);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_sub_block_status.php`,
      { cust_id, setStatus, mobile }
    );
  }

  readRepWiseReports(rep_id: any, start_date: string, end_date: string): Observable<any> {
    // console.log(rep_id, start_date, end_date);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_repwise_details.php`,
      { rep_id, start_date, end_date }
    );
  }

  getlabels(start_date: string, end_date: string) {
    // console.log(start_date, end_date);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_post_label.php`,
      { start_date, end_date }
    );
  }

  getDepositSlipAccountReport(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_deposit_slip_account.php`,
      data
    );
  }

  // getlabelsforDispatch(curweekfirstday: any, preweekfirstday: any) {
  //   // console.log(curweekfirstday, preweekfirstday);
  //   return this.httpClient.post<any>(
  //     `${this.PHP_API_SERVER}/get_Label_for_Dispatch.php`,
  //     { curweekfirstday, preweekfirstday }
  //   );
  // }

  getlabelsforDispatch(curweekfirstday: any, preweekfirstday: any) {
    const selectedYear = sessionStorage.getItem('selectedYear') || '';

    const years = selectedYear.match(/\d{4}/g);

    let loginFY = '';

    if (years && years.length >= 2) {
      loginFY = `${years[0].slice(-2)}-${years[1].slice(-2)}`;
    }
    // console.log(curweekfirstday, preweekfirstday);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_Label_for_Dispatch.php`,
      { curweekfirstday, preweekfirstday, fy: loginFY }
    );
  }

  addMainExpenseLedger(exp_Data: { expensename: any; exptype: any; opening_bal: any; opening_yes_no: any; type: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/add_main_expense_ledger_name.php`,
      { exp_Data }
    );
  }

  getSubExpenseEedgeCvDvReport(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_all_sub_expense_ledger_cv_and_dv_report.php`,
      data
    );
  }

  getProfitLossAccountReport(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_profit_loss_account.php`,
      data
    );
  }

  getTrialBalanceReport(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_trial_balance.php`,
      data
    );
  }

  getdatajournal(startdate: any, enddate: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_journal_entry.php`,
      { startdate, enddate }
    );
  }

  getchequedata(bankType: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_credit_cheques.php`,
      { bankType }
    );
  }

  updateMainExpenseLedger(id: number, exp_name: any, exp_type: any, opening_bal: any, exp_order: any, opening_yes_no: any, cr_dr: any) {
    return this.httpClient.put(
      `${this.PHP_API_SERVER}/update_main_expense_ledger_name.php`,
      { id, exp_name, exp_type, opening_bal, exp_order, opening_yes_no, cr_dr }
    );
  }

  getMainExpenseLedger(): Observable<any> {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/get_main_expense_ledger_names.php`
    );
  }

  getMainExpenseLedgerForPackageManager(): Observable<any> {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/get_main_expense_ledger_for_package_manager.php`
    );
  }

  getMainExpenseLedgerForCreditors(): Observable<any> {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/get_main_expense_ledger_names_for_creditors.php`
    );
  }

  getJournalVoucherNumber(date: any, startDate: any, endDate: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_new_journal_voucher_number.php`,
      { date, startDate, endDate }
    );
  }
  getsavejournal(item: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/add_journal_entry.php`,
      { item }
    );
  }

  getdeletejvoucher(voucherno: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_journal_entry.php`,
      { voucherno }
    );
  }

  changestatus(credit_voucher_id: any, voucher_no: any, cheque: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/add_credit_cheque_status.php`,
      { credit_voucher_id, voucher_no, cheque }
    );
  }

  changestatusadvt_sub(voucher_no: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/update_chequewise_status_department.php`,
      { voucher_no }
    );
  }

  getCreditVoucherData(voucher_no: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_credit_voucher_data.php`,
      { voucher_no }
    );
  }


  // getCreditorsReport(start_date, end_date) {
  //   return this.httpClient.get(
  //     `${this.PHP_API_SERVER}/get_main_expense_ledger_names.php`,
  //     {start_date, end_date}
  //   );
  // }
  getCreditorsReport(start_date: any, end_date: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_creditor_vouchers_report.php`,
      { start_date, end_date }
    );
  }
  insertStampReceipt(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/add_advt_stamp_rcpt.php`,
      { data }
    );
  }

  addSubExpenseLedger(subexpdata: { mainexpid: any; subexpname: any; subShortName: any; subOpeningBal: any; subStatus: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/add_sub_expense_ledger_name.php`,
      { subexpdata }
    );
  }

  updateSubExpenseLedger(subexpdata: { id: number; mainexpid: any; subexpname: any; opening_bal: any; short_name: any; status: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/update_sub_expense_ledger_name.php`,
      { subexpdata }
    );
  }

  getSubExpenseLedger(): Observable<any> {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/get_sub_expense_ledger_names.php`
    );
  }

  getSubExpenseLedgerWithId(id: any): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_sub_expense_ledger_names_with_id.php`,
      { id }
    );
  }

  updatejvoucher(data: any): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/update_journal_entry.php`,
      { data }
    );
  }

  UpdatenewSubscriber(newsub: Newsubscription): Observable<Newsubscription> {
    // console.log(newsub);
    return this.httpClient.post<Newsubscription>(
      `${this.PHP_API_SERVER}/update_sub_details.php`,
      newsub
    );
  }

  updateNewSubSubscription(
    mobileNumber: number,
    ds_subisactive: string,
    isupdated: string
  ): Observable<Newsubscription> {
    // console.log(mobileNumber, ds_subisactive, isupdated);
    return this.httpClient.post<Newsubscription>(
      `${this.PHP_API_SERVER}/update_sub_details.php`,
      { mobileNumber, ds_subisactive, isupdated }
    );
  }

  getsubnotification(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/read_ntfcn_sub.php`
    );
  }

  getUpdatesubnotification(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/read_updtntfcn_sub.php`
    );
  }

  updatesubNotif(sub_id: number, ischecked: string) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_sub_notif.php`,
      { sub_id, ischecked }
    );
  }

  getAdvtTypes(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/read_all_advt_types.php`
    );
  }


  getUdhishta(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/read_all_advt_types.php`
    );
  }

  getPackagesList(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/get_package_list.php`
    );
  }

  getAdvtPersonName(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/read_all_advt_person.php`
    );
  }

  getSubNoAndMobileNo(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/read_subno_mobno.php`
    );
  }

  getSubNames(name: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/read_sub_names.php`,
      { name }
    );
  }
  getSubNamespack(): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/read_books_sub_name.php`,
      {}
    );
  }
  getRepNames(name: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/read_rep_names_renew_report.php`,
      { name }
    );
  }

  getAdvtNames(name: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/read_advt_names.php`,
      {
        name
      }
    );
  }

  getAdvtNamesForPymt(name: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/read_advt_invoices_for_pymt.php`,
      { name }
    );
  }

  getCreditVoucherNo(v_no: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/read_credit_voucher_no.php`,
      { v_no }
    );
  }

  getDebitVoucherNo(v_no: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/read_debit_voucher_no.php`,
      { v_no }
    );
  }

  checkforreciept(v_no: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/read_credit_voucher_no.php`,
      { v_no }
    );
  }

  getCrditVoucherData(id: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/read_single_credit_voucher_data_with_id.php`,
      { id }
    );
  }

  getDebitVoucherData(id: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/read_single_debit_voucher_data_with_id.php`,
      { id }
    );
  }

  getUpdateJournalVoucher(item: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/update_journal_entry.php`,
      item
    );
  }

  getJournalVoucherNo(jv_no: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/read_journal_voucher_no.php`,
      { jv_no }
    );
  }

  getJournalVoucherData(voucherNum: string, startDate?: string | null, endDate?: string | null) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/read_single_journal_voucher_data_with_id.php`,
      { voucherNum, startDate, endDate }
    );
  }

  getDebitVoucherlist(id: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/read_single_dv_exp_data.php`,
      { id }
    );
  }

  deleteDebitVoucherlist(debitvoucher: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_dv_main_expense.php`,
      debitvoucher
    );
  }

  deleteDebitVoucher(id: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_debit_voucher.php`,
      { id }
    );
  }

  updateDebitVoucherlist(debitvoucher: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/Update_debit_voucher.php`,
      { debitvoucher }
    );
  }

  getCreditMainExpenseDataById(id: number) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_credit_main_expense_by_crdt_id.php`,
      { id }
    );
  }

  getCreditSubExpenseDataById(id: number) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_credit_sub_expense_by_exp_id.php`,
      { id }
    );
  }

  getCrditVoucherPackageData(id: number) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/read_crdt_voucher_package_data.php`,
      { id }
    );
  }

  getAllLabelForDispatch(start_date: string, end_date: string, rep_name: string) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_all_label_for_dispatch.php`,
      { start_date, end_date, rep_name }
    );
  }

  getSubNos(no: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/read_sub_nos.php`,
      { no }
    );
  }

  getSubMobNos(no: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/read_sub_mob_nos.php`,
      { no }
    );
  }

  creditorsbookingnum(date: string): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_latest_no.php`,
      { date }
    );
  }

  savecreditorsdetail(req: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/insert_creditor_main_expense.php`,
      { req }
    );
  }

  savecreditorsdetail1(items: any[]): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/insert_creditor_sub_expense.php`,
      { items }
    );
  }

  updatecreditorsdetail(req: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/insert_creditor_main_expense.php`,
      { req }
    );
  }

  updateCreditorsDetail(id: number, req: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/update_creditor_main_expense.php`,
      { id, req }
    );
  }

  updateCreditorsDetail1(main_id: number, items: any[]): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/update_creditor_sub_expense.php`,
      { main_id, items }
    );
  }

  getIssuesellersname(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/read_all_issue_seller_name.php`
    );
  }

  getrepledgerinfo(start_date: string, end_date: string, rep_name: string, departmentTypes: string[]) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_rep_db_voucher_data.php`,
      { start_date, end_date, rep_name, department_type: departmentTypes.join(',') }
    );
  }

  getrepledgerinfo1(start_date: string, end_date: string, rep_name: string, departmentTypes: string[]) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_rep_cr_voucher_data.php`,
      { start_date, end_date, rep_name, department_type: departmentTypes.join(',') }
    );
  }

  deletecrvoucher(id: number) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_credit_voucher.php`,
      { id }
    );
  }

  checkrepforcredit(voucher_no: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/check_existence_of_voucher.php`,
      { voucher_no }
    );
  }

  getOfficeRepName(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/read_all_office_rep_name.php`
    );
  }


  getSubscribersDeatilsDataForReport(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/get_Subscriber_Details_Count_Talukawise.php`
    );

  }

  getIssuesellersentry(id: number): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_issue_seller_entry.php`,
      { id }
    );
  }

  getSubData(id: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_sub_data.php`,
      { id }
    );
  }

  getSubscriberData(id: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_subscriber_data.php`,
      { id }
    );
  }

  getSubscribersDeatilsData(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/get_subscribers_data.php`
    );
  }

  getSubscribersDeatilsDataWithPagination(
    pageno: any,
    totalrecordsperpage: any, formattedDate: any
  ): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_subscriber_data_with_pagination.php`,
      {
        pageno,
        totalrecordsperpage, formattedDate
      }
    );
  }
  // getSubscribersDeatilsDataWithFilter(req): Observable<any[]> {
  //   return this.httpClient.post<any[]>(
  //     `${this.PHP_API_SERVER}/get_subscriber_data_with_filter.php`,
  //     {req}
  //   );
  // }

  updateOtherMainExpense(data: any) {
    return this.httpClient.put(
      `${this.PHP_API_SERVER}/update_other_main_expenses.php`,
      { data }
    );
  }

  updateOtherSubExpense(data: any) {
    return this.httpClient.put(
      `${this.PHP_API_SERVER}/update_other_sub_expenses.php`,
      { data }
    );
  }

  geTotalSubscribersData() {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_subscribers_total_count.php`
    );
  }

  pincodebttaluka(taluka_names: string) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_taluka_pincodewise.php`,
      { taluka_names }
    );
  }

  updateActive(id: any, startdate: string, sub_perid_to_date: string, startremark: string | null, days: number) {
    return this.httpClient.put(
      `${this.PHP_API_SERVER}/update_active_rcpt.php`,
      {
        id,
        startdate,
        sub_perid_to_date,
        startremark,
        days,
      }
    );
  }

  getDistributorData(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_distributor_rep.php`
    );
  }

  getDistributorDataForIssueSeller(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_issue_seller_distribution_mode_rep.php`
    );
  }
  getDistributorData1(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_distributor_rep.php`
    );
  }

  getDistributorModeDataForIssueSeller(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_delivery_mode_issuesale.php`
    );
  }

  getSubDetailsData(id: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_subscriber_details_data.php`,
      { id }
    );
  }

  insertReturnRcpt(data: { id: any; ankdate: any; date: any; reason: any; karyavahi: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_return_receipt.php`,
      { data }
    );
  }

  getReturnRcpt(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_return_receipt.php`
    );
  }

  updateSubDetails(newsub: { id: any; crepname: any; repmobno1: any; officerep: any; crdtdate: any; crdtvno: any; magedition: any; duration: any; subfromdate: any; subtodate: any; distype: any; disrep: any; subremark: any; subremark1: any; subremark2: any; ds_subisactive: any; rcptstopdate: any; rcptstopremark: any; newid: any; newvid: any; balamt: any; vamount: any; select_entry_amt: any; subfromdate1: any; subtodate1: any; distype1: any; }) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_subscriber_details.php`,
      {
        newsub,
      }
    );
  }
  updateSubDetails1(newsub: { id: any; crepname: any; repmobno1: any; officerep: any; crdtdate: any; crdtvno: any; magedition: any; duration: any; subfromdate: any; subtodate: any; distype: any; disrep: any; subremark: any; subremark1: any; subremark2: any; ds_subisactive: any; rcptstopdate: any; rcptstopremark: any; newid: any; newvid: any; balamt: any; vamount: any; select_entry_amt: any; subfromdate1: any; subtodate1: any; distype1: any; }) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_subscriber_sub_type.php`,
      {
        newsub,
      }
    );
  }

  deleteSubDetails(id: any, voucher_no: any, amt: any, flag: boolean) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/delete_subscriber_details.php`,
      {
        id,
        voucher_no,
        amt
      }
    );
  }

  insertAdvtSubDetails(data: { advt_id: number; contract_no: string; bookingdate: string; bookingno: any; advtname: any; custname: any; repname: any; rep_mobile_no: any; offrepname: any; ro_number: any; ro_dates: string; instruction: any; otherdetls: any; pageno: any; advtamout: any; advtdiscount: any; gstie: string; cgst: number; sgst: number; igst: number; totalamt: any; amount: any; ispartpayment: any; partAmount: any; remainingAmount: any; paymentmode: any; chequeno: any; subCategory: any; receiptdate: string; receiptno: any; document_name: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_advt_sub_details.php`,
      { data }
    );
  }

  updateAdvtSubDetails(data: { advt_sub_id: number; advt_id: number; contract_no: string; bookingdate: string; bookingno: any; advtname: any; custname: any; repname: any; rep_mobile_no: any; offrepname: any; ro_number: any; ro_dates: string; instruction: any; otherdetls: any; pageno: any; advtamout: any; advtdiscount: any; gstie: string; cgst: number; sgst: number; igst: number; totalamt: any; amount: any; ispartpayment: any; partAmount: any; remainingAmount: any; paymentmode: any; chequeno: any; subCategory: any; receiptdate: string; receiptno: any; document_name: any; }) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_advt_sub_details.php`,
      { data }
    );
  }

  insertNewadvtPerson(newadvt: any) {
    // console.log(newadvt);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_advt_personinfo.php`,
      { newadvt }
    );
  }

  insertNewadvtdetails(newadvtdtl: any) {
    // console.log(newadvtdtl);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_new_advt.php`,
      { newadvtdtl }
    );
  }

  updatepaymentreceipt(data: { id: number; credit_v_amt: number; seamt: any; bal_amt: number; }) {
    // console.log(newadvtdtl);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_advt_paymnt_rcpt.php`,
      { data }
    );
  }

  updateNewadvtdetails(data: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/updateNewAdvtDetails.php`,
      { data }
    );
  }

  getOffRepAndRepForRegReport() {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_off_rep_for_reg_report.php`
    );
  }

  getRegReportInDetails(): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_reg_report_indetails.php`,
      {}
    );
  }

  getRegReportInDetails1(req1: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_reg_report_indetails.php`,
      { req1 }
    );
  }

  getRegReportInDetailsoff(req1: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_reg_report_offrepwise_indetails.php`,
      { req1 }
    );
  }


  getAdvtInvoiceRegisterListBriefly(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_invoice_register_indetail_officer.php`,
      req
      // getAdvtInvoiceRegisterList
    );
  }

  getRegReportInDetailsrep(req1: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_reg_report_repwise_indetail.php`,
      { req1 }
    );
  }
  getRegReportbrifleyrep(req1: { representativeId: string; startDate: string; endDate: string; officeRepresentativeId: string; issueNameId: string; issueSellerDate: string; }): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_issue_reg_report_repwise_briefly.php`,
      { req1 }
    );
  }

  getRegReportInDetailsdatewise(req1: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_reg_report_datewise_indetail.php`,
      { req1 }
    );
  }

  getRegReportBriefly(req1: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_reg_report_inbriefly.php`,
      { req1 }
    );
  }

  getRegReportOff_rep(req1: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_reg_report_offrepwise.php`,
      { req1 }
    );
  }

  getRegReportOff_repb(req1: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_reg_report_repwise.php`,
      { req1 }
    );
  }

  getAdvtSubDetailsById(advt_id: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_advt_sub_details_by_advtid.php`,
      { advt_id }
    );
  }

  insertIssueSellerAgentAdvtDetails(newadvtdtl: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_issue_seller_agent_advt.php`,
      { newadvtdtl }
    );
  }

  insertCustRepAdvt(mobile: number, repid: number) {
    // console.log(mobile, repid);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_cust_rep_advt.php`,
      { mobile, repid }
    );
  }

  getAdvtReports(advt_name: string, mobile: string, issue_name: any, rep_name: string) {
    // console.log(start_date, end_date);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_advt_details_by_filter.php`,
      { advt_name, mobile, issue_name, rep_name }
    );
  }

  getAdvtRegistrationReports(start_date: any, end_date: any, issue_name: any, issueDates: any) {
    // console.log(start_date, end_date);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_advt_registration_report.php`,
      { start_date, end_date, issue_name, issueDates }
    );
  }

  getAdvtReportRepWise(start_date: string, end_date: string, rep_name: string) {
    // console.log(start_date, end_date, rep_name);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_advt_rep_registration_report.php`,
      { start_date, end_date, rep_name }
    );
  }

  insertAdvt(data: { name: any; ownername: any; email: any; address: any; country: any; state: any; taluka: any; district: any; mobileNumber: any; pincode: any; advtType: any; e_advt_name: any; e_district: any; dob: any; companyRegistration: any; gstno: any; rep_name: any; rep_mobile_no: any; landline_no: any; instruction: any; }) {
    return this.httpClient.post(`${this.PHP_API_SERVER}/insertAdvt.php`, {
      data,
    });
  }

  updateAdvtPerson(data: { old_advt_name: string; id: number; name: any; ownername: any; email: any; address: any; country: any; state: any; taluka: any; district: any; mobileNumber: any; pincode: any; advtType: any; e_advt_name: any; e_district: any; dob: any; companyRegistration: any; gstno: any; rep_name: any; rep_mobile_no: any; landline_no: any; instruction: any; receiptdate: string; receiptno: string; }) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_advt_person_details.php`,
      { data }
    );
  }

  updateContractDetails(data: { contract_id: number; advt_id: number; contractno: any; contractdate: string; repname: any; offrepname: any; advtname: any; priviousbal: any; contractamt: any; discountamt: any; gstie: any; netamt: any; netgstprice: any; nettotal: any; subCategory: any; contractfromdate: string; contracttodate: string; bookingadvtamt: any; balamt: any; instruction: any; }) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_contract_details.php`,
      { data }
    );
  }

  updateContractBalAmount(contract_id: number, bookadvtamt: number, contact_bal_amt: number) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_contract_bal_amt.php`,
      { contract_id, bookadvtamt, contact_bal_amt }
    );
  }

  updateAdvtPublishDates(advt_dtl_id: any, advt_dates: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_advt_publishdates.php`,
      { advt_dtl_id, advt_dates }
    );
  }

  updateAdvtIssueDates(advt_dtl_id: any, advt_dates: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_advt_issuedates.php`,
      { advt_dtl_id, advt_dates }
    );
  }

  updateAdvtdtlStatus(advt_dtl_id: number) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_advt_publish_status.php`,
      { advt_dtl_id }
    );
  }

  getAdvtMagNames(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/read_advt_magList.php`
    );
  }

  getAllIssueDates(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/get_all_Issue_Dates.php`
    );
  }

  getAdvtDatesAndNames(issueName: any) {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/read_advt_issue.php`,
      // read_advt_issue
      { issueName }
    );
  }



  // getAdvtDatesAndId(id) {
  //   return this.httpClient.post<any[]>(
  //     `${this.PHP_API_SERVER}/read_advt_issueId.php`,
  //     // read_advt_issue
  //     { id }
  //   );
  // }
  addpp_pageno(req: any) {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/update_advt_page_no.php`,
      // read_advt_issue
      { req }
    );
  }

  getAdvtDatesAndNames1(issueName: any) {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/read_advt_issue_by_issuename.php`,
      // read_advt_issue
      { issueName }
    );
  }

  getAllVouchers(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/read_all_vouchers.php`
    );
  }


  addDebitVoucher(data: { bcaccount: any; dvnumber: any; dvoucherdate: any; rname: any; othername: any; exp_amt: any; chequeno: any; chequedate: string | null; totalexp: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/add_debit_voucher.php`,
      { data }
    );
  }

  getAllCreditVouchersData(startdate: any, enddate: any, banktype: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/read_all_credit_vouchers_data.php`,
      {
        startdate,
        enddate,
        banktype,
      }
    );
  }

  getReconsilationReportData(startdate: string, enddate: string, banktype: string, cheque_no: string, bankfullname: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/read_reconsilation_bankwise_report.php`,
      {
        startdate,
        enddate,
        banktype,
        cheque_no,
        bankfullname
      }
    );
  }

  getReconsilationReportData1(startdate: string, enddate: string, banktype: string, cheque_no: string, bankfullname: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/read_reconsilation_bankwise_dv_report.php`,
      {
        startdate,
        enddate,
        banktype,
        cheque_no,
        bankfullname
      }
    );
  }

  updateClearingDate(id: any, date: string) {
    return this.httpClient.put(
      `${this.PHP_API_SERVER}/update_cheque_clearing_date.php`,
      {
        id,
        date,
      }
    );
  }

  updateClearingDate1(id: any, date: string) {
    return this.httpClient.put(
      `${this.PHP_API_SERVER}/update_cheque_clearing_date_dv.php`,
      {
        id,
        date,
      }
    );
  }

  cancelClearingDate(id: any, voucher_type: String) {
    return this.httpClient.put(
      `${this.PHP_API_SERVER}/cancel_reco.php`,
      {
        id,
        voucher_type,
      }
    );
  }

  getAllDebitVouchersData(startdate: any, enddate: any, banktype: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/read_all_debit_vouchers_data.php`,
      {
        startdate,
        enddate,
        banktype,
      }
    );
  }

  getAllcontra(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/read_bankwise_contro_bal.php`,
      {
        req
      }
    );
  }

  getAllCreditVoucherList(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.PHP_API_SERVER}/read_all_credit_voucher_list.php`
    );
  }

  getDeliveryMode(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/read_delivery_mode.php`
    );
  }
  getDeliveryMode1(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/read_delivery_mode1.php`
    );
  }
  getDistributionModes(
    deliveryModeName: string
  ): Observable<any[]> {

    return this.httpClient.get<any[]>(

      `${this.PHP_API_SERVER}/read_sub_delivery_mode1.php/?delivery_mode=${encodeURIComponent(deliveryModeName)}`

    );
  }
  getSubDistributionModes(
    distributionModeName: string
  ): Observable<any[]> {

    return this.httpClient.get<any[]>(

      `${this.PHP_API_SERVER}/read_sub_delivery_mode2.php/?sub_delivery_mode=${encodeURIComponent(distributionModeName)}`

    );
  }
  getRepAssignedModes(repName: string): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.PHP_API_SERVER}/read_sub_delivery_mode3.php/?rep_name=${repName}`);
  }
  // Add this one new method
  getAllDistributionMode(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.PHP_API_SERVER}/read_sub_delivery_mode1.php`);
  }

  addSubDeliveryMode(data: { delivery_mode_id: any; subdeliverymode: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_sub_delivery_mode.php`,
      {
        data,
      }
    );
  }
  addSubDeliveryMode1(data: { delivery_mode_id: any; subdeliverymode: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_sub_delivery_mode1.php`,
      {
        data,
      }
    );
  }
  addSubDelivery(dev_mode: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_delivery_mode.php`,
      {
        dev_mode,
      }
    );
  }

  addMagzineIds(id_name: any, delivery_mode_name: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_Magzine_Ids_data.php`,
      {
        id_name, delivery_mode_name,
      }
    );
  }

  addColumnMagzineMaster(col_name: any, field_Name: any, delivery_mode_name: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_Excel_Magzine_Master.php`,
      {
        col_name, field_Name, delivery_mode_name,
      }
    );
  }

  getExcelAllMagzineMasterData(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_Excel_Column_Master_Data.php`
    );
  }

  deleteExcelMagzineMaster(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_Excel_Column_Magzine_Master.php`,
      { id }
    );
  }

  addSubDelivery1(dev_mode: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_delivery_mode1.php`,
      {
        dev_mode,
      }
    );
  }

  getSubDeliveryMode(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/read_sub_delivery_mode.php`
    );
  }
  getSubDeliveryMode3(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/read_sub_delivery_mode1.php`
    );
  }
  getSubDeliveryMode4(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_label_dis_mode2.php`
    );
  }
  getDistributionModeByRep(data: any) {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/read_sub_delivery_mode.php`
    );
  }
  getSubDeliveryMode1(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_all_sub_distribution_modes1.php`
    );
  }

  getSubDeliveryModeisuuesale(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_delivery_mode_issuesale.php`
    );
  }

  getSubDistributionMode(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/read_sub_distribution_mode.php`
    );
  }

  getSubDistributionModeissuesale(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/read_sub_distribution_mode_issuesale.php`
    );
  }


  addAssignDistributionMode(data: { disrep: any; dismode: any; dissubmode: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_assign_dis_mode_to_rep.php`,
      { data }
    );
  }
  addAssignDistributionMode1(data: { disrep: any; dismode: any; dissubmode: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_assign_dis_mode_to_rep1.php`,
      { data }
    );
  }

  getDistributionModeRep(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_distribution_mode_rep.php`
    );
  }

  getDistributionModeRep1(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_distribution_mode_rep1.php`
    );
  }

  getAllDistributionModes(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_all_distribution_modes.php`
    );
  }
  getAllDistributionModes3(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_all_distribution_modes1.php`
    );
  }
  getAllDistributionModes1(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_delivery_mode_data.php`
    );
  }

  getAllMagzineIdMasterData(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_Magzine_IDS_All_Data.php`
    );
  }

  getAllDistributionModes2(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_delivery_mode_data1.php`
    );
  }

  getAllSubDistributionModes(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_all_sub_distribution_modes.php`
    );
  }
  getAllSubDistributionModes1(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_all_sub_distribution_modes1.php`
    );
  }

  updateAssignDistributionMode(data: { id: any; disrep: any; dismode: any; dissubmode: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_distribution_mode_rep.php`,
      { data }
    );
  }

  updateAssignDistributionMode1(data: { id: any; disrep: any; dismode: any; dissubmode: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_distribution_mode_rep3.php`,
      { data }
    );
  }

  deletedelmode(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_delivery_mode.php`,
      { id }
    );
  }

  deleteMagzineIds(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_Magzine_IDs.php`,
      { id }
    );
  }

  deletedelmode1(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_delivery_mode1.php`,
      { id }
    );
  }

  updatedeliverymode(id: any, dev_mode: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_delivery_mode.php`,
      { id, dev_mode }
    );
  }

  updateMagzineIDs(id: any, id_Name: any, delivery_mode_name: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_Magzine_IDs.php`,
      { id, id_Name, delivery_mode_name }
    );
  }

  updateExcelMagzineMaster(id: any, col_name: any, field_Name: any, delivery_mode_name: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_Excel_Magzine_Master.php`,
      { id, col_name, field_Name, delivery_mode_name }
    );
  }

  updatedeliverymode1(id: any, dev_mode: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_delivery_mode1.php`,
      { id, dev_mode }
    );
  }

  updateAddSubDeliveryMode(data: { id: number; deliverymode: any; subdeliverymode: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_add_sub_delivery_mode.php`,
      { data }
    );
  }
  updateAddSubDeliveryMode1(data: { id: number; deliverymode: any; subdeliverymode: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_add_sub_delivery_mode1.php`,
      { data }
    );
  }

  updateAddSubDeliverySubMode(data: { id: number; deliverymode: any; subdeliverymode: any; vajan: any; rate: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_sub_delivery_of_sub_mode.php`,
      { data }
    );
  }
  updateAddSubDeliverySubMode1(data: {
    id: number;
    deliverymode: any;
    subdeliverymode: any;
  }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_sub_delivery_of_sub_mode1.php`,
      data
    );
  }

  deleteSubDisMode(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_sub_distribution_sub_mode.php`,
      { id }
    );
  }
  deleteSubDisMode1(id: number) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_sub_distribution_sub_mode1.php`,
      { id }   // ✅ MUST be object
    );
  }

  deleteDisMode(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_sub_distribution_mode.php`,
      { id }
    );
  }
  deleteDisMode1(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_sub_distribution_mode1.php`,
      { id }
    );
  }

  deleteAssignDisMode(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_assign_distribution_rep.php`,
      { id }
    );
  }
  deleteAssignDisMode1(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_assign_distribution_rep1.php`,
      { id }
    );
  }

  addSubModes(data: { sub_delivery_mode_id: any; subdeliverymode: any; vajan: any; rate: any; }) {
    return this.httpClient.post(`${this.PHP_API_SERVER}/insert_sub_modes.php`, {
      data,
    });
  }
  addSubModes1(data: { sub_delivery_mode_id: any; subdeliverymode: any }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_sub_modes1.php`,
      data   // ✅ direct send
    );
  }

  getvoucherbyAdvt(start: string, end: string) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_vouchers_by_advt.php`,
      {
        start: start,
        end: end
      }
    );
  }


  // getvoucherbySub() {
  //   // console.log(dept_name);
  //   return this.httpClient.post<any>(
  //     `${this.PHP_API_SERVER}/read_vouchers_by_subscription.php`,
  //     {}
  //   );
  // }

  getvoucherbySub(fyStart?: string, fyEnd?: string) {
    if (!fyStart || !fyEnd) {
      fyStart = sessionStorage.getItem('startDate') ?? '';
      fyEnd = sessionStorage.getItem('endDate') ?? '';
    }

    const payload: any = {};
    if (fyStart && fyEnd) {
      payload.fy_start = fyStart;
      payload.fy_end = fyEnd;
    }

    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_vouchers_by_subscription.php`,
      payload
    );
  }

  getvoucherbyIssueSale() {
    // console.log(dept_name);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_vouchers_by_issuesale.php`,
      {}
    );
  }

  getvoucherbybook() {
    // console.log(dept_name);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_vouchers_by_book.php`,
      {}
    );
  }
  getvoucherbygranth() {
    // console.log(dept_name);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_vouchers_by_Granth.php`,
      {}
    );
  }

  getSubIdWithMobile(mobile: any) {
    // console.log(mobile);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_sub_id_using_mobile.php`,
      { mobile }
    );
  }

  getBookIdWithMobile(name: any) {
    // console.log(name);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_book_id_using_mobile.php`,
      { name }
    );
  }

  getCreditVoucherId(date: any, bankcashaccount: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_credit_voucher_id.php`,
      { date, bankcashaccount }
    );
  }

  getAdvtIdWithMobile(mobile: any) {
    // console.log(mobile);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_advt_id_using_mobile.php`,
      { mobile }
    );
  }

  updateVoucheritemId(id: any, item_id: any, department: any, voucher_no: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_voucher_item_id.php`,
      { id, item_id, department, voucher_no }
    );
  }

  insertAdvtMagazine(magazine_name: { igcategory: any; igsubcategory: any; }) {
    // console.log(magazine_name);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_advt_mags.php`,
      { magazine_name }
    );
  }

  insertCreditVoucher(voucher_no: string, department: any, comment: any, amount: any) {
    // console.log(voucher_no, department, comment, amount);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_credit_voucher.php`,
      { voucher_no, department, comment, amount }
    );
  }

  insertcreditVoucher(creditvoucher: { entrydate: any; vnumber: any; bcaccount: any; voucherdate: any; othername: any; rname: any; damount: any; pymtoptions: any; cnumber: any; chequedate: any; bank: any; branch: any; deposits: any; depositsname: any; pancard: any; narration: any; odeposit: any; packagecount: any; packageamount: any; otheramount: any; total: any; expenditure: any; totalexp: any; ndeposit: any; }) {
    // console.log(voucher_no, department, comment, amount);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_Credit_Voucher.php`,
      { creditvoucher }
    );
  }

  updatecreditVoucher(creditvoucher: { id: number; bcaccount: any; vnumber: any; voucherdate: any; rname: any; othername: any; damount: any; pymtoptions: any; cnumber: any; bank: any; branch: any; pancard: any; narration: any; chequedate: Date; entrydate: any; deposits: any; depositsname: any; donation: any; odeposit: any; packagecount: any; packageamount: any; otheramount: any; total: any; expenditure: any; totalexp: any; ndeposit: any; }) {
    return this.httpClient.put(
      `${this.PHP_API_SERVER}/update_Credit_Voucher.php`,
      { creditvoucher }
    );
  }

  insertCrdtPackage(data: { crdt_id: number; pkg_id: any; pkg_name: any; pkg_amt: any; client_name: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/crdt_voucher_package.php`,
      {
        data,
      }
    );
  }

  updateCrdtPackage(data: any) {
    return this.httpClient.put(
      `${this.PHP_API_SERVER}/update_credit_voucher_package.php`,
      { data }
    );
  }

  insertCrdtPackageDetails(data: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_crdt_voucher_pkg_details.php`,
      {
        data,
      }
    );
  }

  updateCrdtPackageDetails(data: any) {
    return this.httpClient.put(
      `${this.PHP_API_SERVER}/update_crdt_voucher_pkg_details.php`,
      { data }
    );
  }

  insertCreditVoucherSubscribers(saib: { crdt_vucher_id: number; subscription: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_credit_voucher_saib.php`,
      { saib }
    );
  }

  updateCrdtVoucherSubcribers(saib: { crdt_voucher_id: number; subscription: any; }) {
    return this.httpClient.put(
      `${this.PHP_API_SERVER}/update_Crdt_vouchers_subscribers.php`,
      { saib }
    );
  }

  updateCrdtVoucherSubscribersNames(id: any, names: string) {
    return this.httpClient.put(
      `${this.PHP_API_SERVER}/update_crdt_voucher_sub_names.php`,
      { id, names }
    );
  }

  insertSubCommission(com: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_sub_commission.php`,
      { com }
    );
  }

  insertIssueCommission(com: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_issue_commission.php`,
      { com }
    );
  }

  insertAdvtCommission(com: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_advt_commission.php`,
      { com }
    );
  }

  insertBookCommission(com: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_book_commission.php`,
      { com }
    );
  }

  insertCreditVoucherAdvt(saib: { crdt_vucher_id: number; adverties: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_credit_voucher_advt.php`,
      { saib }
    );
  }

  updateCreditVoucherAdvt(saib: { crdt_voucher_id: number; adverties: any; }) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_crdt_voucher_advt.php`,
      { saib }
    );
  }

  updateCrdtVoucherAdvtNames(id: any, names: string) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_crdt_voucher_advt_names.php`,
      { id, names }
    );
  }

  insertCreditVoucherBook(saib: { crdt_vucher_id: number; granthbook: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_credit_voucher_book.php`,
      { saib }
    );
  }

  updateCreditVoucherBook(saib: { crdt_vucher_id: number; granthbook: any; }) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_crdt_voucher_book.php`,
      { saib }
    );
  }

  updateCrdtVoucherBookNames(id: any, sellername: any, bookname: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_crdt_voucher_book_names.php`,
      { id, sellername, bookname }
    );
  }

  insertCreditVoucherIssueSale(saib: { crdt_vucher_id: number; isale: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_credit_voucher_issuesale.php`,
      { saib }
    );
  }

  updateCreditVoucherIssueSale(saib: { crdt_voucher_id: number; isale: any; }) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_crdt_voucher_issue_sale.php`,
      { saib }
    );
  }

  updateCrdtVoucherIssueSaleNames(id: any, names: string) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_crdt_voucher_issue_sale_names.php`,
      { id, names }
    );
  }

  insertCreditVoucherDonationNames(credit_id: any, names: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_credit_voucher_donamtionNames.php`,
      { credit_id, names }
    );
  }

  updateCrdtVoucherDonationNames(id: any, names: any) {
    return this.httpClient.put(
      `${this.PHP_API_SERVER}/updatecrdtvoucherDonationNames.php`,
      { id, names }
    );
  }

  insertCreditVoucherDepositsNames(credit_id: any, names: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_credit_voucher_depositsNames.php`,
      { credit_id, names }
    );
  }

  updateCrdtVoucherDepositsNames(id: any, names: any) {
    return this.httpClient.put(
      `${this.PHP_API_SERVER}/update_crdt_voucher_deposits_names.php`,
      { id, names }
    );
  }

  insertCreditVoucherOtherDepositsNames(credit_id: any, names: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_credit_voucher_otherdepositsNames.php`,
      { credit_id, names }
    );
  }

  updateCrdtVoucherOtherDepositsNames(id: any, names: any) {
    return this.httpClient.put(
      `${this.PHP_API_SERVER}/update_crdt_voucher_other_deposits_names.php`,
      { id, names }
    );
  }

  insertCreditVoucherSubscribersNames(id: any, names: string) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_credit_voucher_SubscribersNames.php`,
      { id, names }
    );
  }

  insertCreditVoucherAdvtNames(id: any, names: string) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_credit_voucher_AdvtNames.php`,
      { id, names }
    );
  }

  insertCreditVoucherBookNames(id: any, sellername: any, bookname: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_credit_voucher_BookNames.php`,
      { id, sellername, bookname }
    );
  }

  insertCreditVoucherIssueSaleNames(id: any, names: string) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_credit_voucher_IssueSaleNames.php`,
      { id, names }
    );
  }

  updateAdvtMagDates(advt_id: any, advt_dates: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_advt_new_dates.php`,
      { advt_id, advt_dates }
    );
  }

  updateAdvtMagStatus(advt_id: any, status: string) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_advt_mag_status.php`,
      { advt_id, status }
    );
  }

  getAdvtBusinessReport(startdate: string, enddate: string) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_advt_bussiness_report.php`,
      { startdate, enddate }
    );
  }

  getAdvtPrasiddhiPatrak(issue_name: any, issue_date: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_advt_prasiddhi_patrak.php`,
      { issue_name, issue_date }
    );
  }

  getPrasiddhiPatrakData(req: { value: any; value1?: any; valueT?: any; issue_name: string; issue_date: string; start_date: string; end_date: string; advt_name: string; rep_name: string; off_rep_name: string; cust_name?: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_prasiddhi_patrak_data.php`,
      { req }
    );
  }

  updatePagenoPrasiddhiPatrak(data: any) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_pages_no.php`,
      { data }
    );
  }
  deletesubscriberrcpt(req: { subTypeId: any; }) {
    debugger
    return this.httpClient.post(
      // ${this.PHP_API_SERVER}/delete_sub_rcp.php,
      `${this.PHP_API_SERVER}/delete_sub_rcp.php`,
      { req }
    );
  }


  getPrasiddhiPatrakOff_Rep_and_advt_name() {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/getPrasiddhiPatrak_Off_rep_and_advt_name.php`
    );
  }

  // updateStateName(state_id: number, state_name: any) {
  //   return this.httpClient.put<any>(
  //     `${this.PHP_API_SERVER}/update_state_name.php`,
  //     { state_id, state_name }
  //   );
  // }

  // updateDistrictName(district_id: number, district_name: any, prant_id: any) {
  //   return this.httpClient.put<any>(
  //     `${this.PHP_API_SERVER}/update_district_name.php`,
  //     { district_id, district_name, prant_id }
  //   );
  // }

  // updateTalukaName(taluka_id: number, taluka_name: any, taluka_pincode: number) {
  //   return this.httpClient.put<any>(
  //     `${this.PHP_API_SERVER}/update_taluka_name.php`,
  //     { taluka_id, taluka_name, taluka_pincode }
  //   );
  // }

  addCreditMainExpense(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/add_credit_main_expenses.php`,
      { data }
    );
  }

  otherMainExpense(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/add_other_main_expenses.php`,
      { data }
    );
  }

  get_other_deposit_main_expenses_by_cv_id(data: number) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_other_deposit_main_expenses_by_cv_id.php`,
      { id: data }
    );
  }

  get_other_deposit_sub_expenses_by_exp_id(id: number) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_other_deposit_sub_expenses_by_exp_id.php`,
      { id }
    );
  }


  updateCreditMainExpense(data: any) {
    return this.httpClient.put(
      `${this.PHP_API_SERVER}/update_credit_main_expenses.php`,
      { data }
    );
  }

  addCreditSubExpense(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/add_credit_sub_expenses.php`,
      { data }
    );
  }

  otherSubExpense(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/add_other_sub_expenses.php`,
      { data }
    );
  }

  updateCreditSubExpense(data: any) {
    return this.httpClient.put(
      `${this.PHP_API_SERVER}/update_credit_sub_expenses.php`,
      { data }
    );
  }

  addOrUpdateOrDeleteDebitMainExpense(data: { voucher_id: any; mainexpid: any; expamt: any; status: any; id?: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/add_update_delete_debit_main_expenses.php`,
      { data }
    );
  }

  addOrUpdateOrDeleteDebitSubExpense(data: { mainid: any; subexpid: any; expamt: any; status: any; id?: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/add_update_delete_debit_sub_expenses.php`,
      { data }
    );
  }

  // All contract Details API
  getAllContractDetails(): Observable<any> {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/get_advt_contract_details.php`
    );
  }

  dataforrec(): Observable<any> {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/get_advt_pyt_datewise_detail.php`
    );
  }

  // All indetails contract Details API
  getAllIndetailsContractDetails(req: { rep_name: any; start_date: any; end_date: any; off_rep_name: any; advt_name: string; fiscal_year: any; }): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_indetails_contract_details.php`,
      { req }
    );
  }



  // // In digisubservices.service.ts
  // getAllContractDetails1(year: number, advtName: string = ''): Observable<any> {
  //   let params = new HttpParams().set('year', year.toString());

  //   const trimmed = (advtName || '').trim();
  //   console.log('getAllContractDetails1 service → advtName param:', JSON.stringify(trimmed));

  //   if (trimmed !== '') {
  //     params = params.set('advt_name', trimmed);
  //   }

  //   return this.httpClient.get(
  //     `${this.PHP_API_SERVER}/get_advt_contract_details.php`, 
  //     { params }
  //   );
  // }



  sendWhatsAppMSGBook(payload: any) {

    const headers = new HttpHeaders({

      'Accept': 'application/json',

      'Content-Type': 'application/json',

    });



    return this.httpClient.post<any>(`${this.PHP_API_SERVER}/send_wp_msg_using_aisensy.php`,

      payload,

      { headers }

    );

  }





  getAllContractDetails1(year: number, advtName: string, repName: string = '', offRepName: string = '') {

    let params = new HttpParams().set('year', year.toString());



    const trimmedAdvt = (advtName || '').trim();

    const trimmedRep = (repName || '').trim();

    const trimmedOffRep = (offRepName || '').trim();



    console.log('getAllContractDetails1 service → advtName param:', JSON.stringify(trimmedAdvt));

    console.log('getAllContractDetails1 service → repName param:', JSON.stringify(trimmedRep));

    console.log('getAllContractDetails1 service → offRepName param:', JSON.stringify(trimmedOffRep));



    if (trimmedAdvt !== '') {

      params = params.set('advt_name', trimmedAdvt);

    }



    if (trimmedRep !== '') {

      params = params.set('rep_name', trimmedRep);

    }



    if (trimmedOffRep !== '') {

      params = params.set('off_rep_name', trimmedOffRep);

    }



    return this.httpClient.get(

      `${this.PHP_API_SERVER}/get_advt_contract_details.php`,

      { params }

    );

  }

  getAllDebitVocher(dv: { exp_id: any; subexp_id: string; startdate: any; enddate: any; }): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_expense_ledger_dv_report.php`,
      { dv }
    );
  }

  getAllSubscriptiontype(cv: { exp_id: any; subexp_id: string; source?: any; startdate: any; enddate: any; }): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_sub_ledger_for_account.php`,
      { cv }
    );
  }

  getAllCreditVocher(cv: { exp_id: any; subexp_id: string; startdate: any; enddate: any; }): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_expense_ledger_cv_report.php`,
      { cv }
    );
  }


  getDistrictwiseSubscription(payload: any): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_district_rep_cus.php`,
      payload
    );
  }

  getAdvtInvoiceData() {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/get_advt_invoice_data.php`
    );
  }

  getAdvtInvoiceDataById(name: any, type: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_invoice_data_by_id.php`,
      { name, type }
    );
  }

  getentrybyrepname(name: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_payrecipt_data.php`,
      { name }
    );
  }

  getentrybyrepname1(name: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_payreceipt_data.php`,
      { name }
    );
  }

  getNewAdvtName() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_list.php`,
      {}
    );
  }
  getNewissueName() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_list.php`,
      {}
    );
  }

  getAdvtRepNames(name: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_advt_repName.php`,
      {
        name
      }
    );
  }

  getAdvtInvoiceforAdvtNames(dates: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_names_for_invoice.php`,
      { dates }
    );
  }

  getNextAdvtInvoiceNo(date: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_next_advt_invoice_no.php`,
      { date }
    );
  }

  insertAdvtInvoice(data: { invoice_no: any; booking_no: any; invoice_date: string; gst_no: string; pan_no: string; advt_name: any; first_week_id: any; second_week_id: any; third_week_id: any; fourth_week_id: any; fifth_week_id: any; pre_amt: any; pay_amt: any; remaining_amt: any; }) {
    return this.httpClient.post(`${this.PHP_API_SERVER}/add_advt_invoice.php`, {
      data,
    });
  }

  updateIssueSellerInvoice(data: any) {
    return this.httpClient.post(`${this.PHP_API_SERVER}/update_issue_seller_invoice.php`, {
      data,
    });
  }

  deleteIssueSellerInvoice(id: number) {
    return this.httpClient.post(`${this.PHP_API_SERVER}/delete_issue_seller_invoice.php`, {
      id,
    });
  }

  updateAdvtInvoice(data: { invoice_no: any; booking_no: any; invoice_date: string; advt_name: any; first_week_id: any; second_week_id: any; third_week_id: any; fourth_week_id: any; fifth_week_id: any; pre_amt: any; pay_amt: any; remaining_amt: any; }) {
    return this.httpClient.post(`${this.PHP_API_SERVER}/update_advt_invoice.php`, {
      data,
    });
  }

  updateIssueInvoice1(data: { invoice_no: any; booking_no: any; invoice_date: string; gst_no: string; pan_no: string; issue_seller_name: any; first_week_id: any; second_week_id: any; third_week_id: any; fourth_week_id: any; fifth_week_id: any; pre_amt: any; pay_amt: any; remaining_amt: any; }) {
    return this.httpClient.post(`${this.PHP_API_SERVER}/update_issue_seller_invoice.php`, {
      data,
    });
  }


  getAllAdvtInvoicesList(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_all_advt_invoices_list.php`,
      req
    );
  }

  getIssueSellerInvoiceList(issuesellerinvoice: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_invoice.php`,
      issuesellerinvoice
    );
  }
  getinvoicdedetails(id: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_date_by_id.php`,
      { "id": id }
    );
  }

  // getAllAdvtInvoicesForPymt(name) {
  //   return this.httpClient.post(
  //     `${this.PHP_API_SERVER}/get_advt_invoices_for_pymt.php`,
  //     { name }
  //   );
  // }
  getAllAdvtInvoicesForPymt(name: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_invoices_for_pymt.php`,
      { name }
    );
  }
  getAllAdvtInvoicesForPymt1(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_invoices_for_pymt.php`,
      req
    );
  }

  getAllIssueInvoicesForPymt(name: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_invoices_for_pytm.php`,
      { name }
    );
  }
  getAllIssueInvoicesForPymt1(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_invoices_for_pytm.php`,
      req
    );
  }

  getAdvtInvoiceRegisterList(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_invoice_register.php`,
      req
      // getAdvtInvoiceRegisterList
    );
  }



  getAdvtInvoiceRegisterListIndetail(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_invoice_register_indetail_officer.php`,
      req
      // getAdvtInvoiceRegisterList
    );
  }

  getAdvtInvoiceRegisterListmonthly(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_invoice_monthwise.php`,
      req
      // getAdvtInvoiceRegisterList
    );
  }

  getAdvtInvoiceRegisterListbriefly(req: { start_date: any; end_date: any; issue_name: string; issue_date: string; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_invoice_register_briefly.php`,
      req
      // getAdvtInvoiceRegisterList
    );
  }
  cancelAdvtInvoice(id: number) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/cancel_advt_invoice.php`,
      { id }
    );
  }

  getBasicInfoOfAdvtInvoice(id: number) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_invoice_basic_details_by_Id.php`,
      { id }
    );
  }



  insertAdvtPymtRcptData(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_advt_pymt_rcpt_data.php`,
      {
        data,
      }
    );
  }

  // ********* print order start ************

  getPrintOrderData(subPeriodFromDate: string, subPeriodToDate: string, subscription_type: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_print_order_data.php`,
      { subPeriodFromDate, subPeriodToDate, subscription_type }
    );
  }

  insertPrintOrderData(data: { order_date: string; issue_date_from: string; issue_date_to: string; total_prati: any; total_prustha: any; weeksCount?: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_print_order.php`,
      { data }
    );
  }

  insertPrintOrderPrustha(order_id: any, data: any[]) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_print_order_prustha.php`,
      { order_id, data }
    );
  }

  insertPrintOrderTypes(order_id: any, data: { no: number; name: string; prati: number; shera: string; }[]) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_print_order_types.php`,
      { order_id, data }
    );
  }

  getAllPrintOrderData() {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/get_all_print_order_data.php`
    );
  }


  cancelPrintOrder(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/cancel_print_order.php`,
      { req }
    );
  }

  deletePymtreceipt(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_advt_py_reciept.php`,
      { req }
    );
  }

  deleteCommission(req: { id: number; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_advt_comm_recipt.php`,
      { req }
    );
  }


  deleteCreditNote(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_credit_note_receipt.php`,
      { req }
    );
  }

  getPrintDataByID(id: number) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_print_order_data_by_id.php`,
      {
        id,
      }
    );
  }

  getPrintOrderDataByDate(startDate: string, endDate: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_print_order_data_by_dates.php`,
      {
        startDate,
        endDate,
      }
    );
  }

  // ************ print order end ***************

  // ************ Javak start *******************

  // ************ Javak end *********************

  getSearchedDistrictName(districtName: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_search_district_name.php`,
      { districtName }
    );
  }




  getAdvtOfficerVb(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_pyt_officer_vb.php`,
      req
    );
  }

  getAdvtBriefly(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_pyt_datewise.php`,
      req
    );
  }

  getAdvtMonthwise(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_pyt_monthwise.php`,
      req
    );
  }

  GSTFullReport(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_gst_register.php`,
      req
    );
  }

  IssueGSTFullReport(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_gst_register.php`,
      req
    );
  }
  getAdvtOfficerBriefly1(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_pyt_officer_b.php`,
      { req }
    );
  }



  getCreditNoteVB(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_credit_officer_vb.php`,
      { req }
    );
  }
  getAdvtOutstanding(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_outstanding_detail.php`,
      req
    );
  }

  getAdvtOutstandingBriefly(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_outstanding_briefly_data.php`,
      req
    );
  }



  getBookOutstandingInDetail(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_outstanding_data_in_detail.php`,
      req
    );
  }

  getBookOutstandingBriefly(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_outstanding_data_in_detail.php`,
      req
    );
  }

  getBookUnpaidOutstandingBriefly(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_unpaid_outstanding_data_in_detail.php`,
      req
    );
  }


  practiceC(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_print_comission_receipt.php`,
      req
    );
  }

  getPaidCommData(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_rep_commission_report.php`,
      req
    );
  }


  getPendingCommData(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_pending_comm_report.php`,
      req
    );
  }
  getBookUnpaidOutstandingIndetailgranth(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_unpaid_outstanding_data_in_detailgranth.php`,
      req
    );
  }
  getBookUnpaidOutstandingbrieflygranth(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_unpaid_outstanding_data_brieflygranth.php`,
      req
    );
  }
  getBookOutstandingInDetailgranth(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_outstanding_data_in_detailgranth.php`,
      req
    );
  }
  getBookOutstandinggranthBriefly(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_outstanding_data_brieflygranth.php`,
      req
    );
  }
  getBookUnpaidOutstandingBreiflygranth(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_unpaid_outstanding_data_briefly.php`,
      req
    );
  }

  getBookUnpaidOutstandingBrieflygranth(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_unpaid_outstanding_data_in_detailgranth1.php`,
      req
    );
  }

  getPersoanlLed(req1: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_personal_leadger_detail.php`,
      req1
    );
  }
  getstatewisecount(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_statewise_subscriberCount.php`,
      { req }
    );
  }

  f: any

  // getPersoanlLedBriefly(req1) {
  //   return this.httpClient.post(
  //     `${this.PHP_API_SERVER}/get_personal_leadger_briefly.php`,
  //     req1
  //   );
  // }

  getPersoanlLedBriefly(req1: { start_date: any; end_date: any; advt_name: string; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_personal_leadger_briefly_new.php`,
      req1
    );
  }

  getOpeningBalanceReport(req: { request: { startdate: any } }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_opening_balance_report.php`,
      req
    );
  }


  practice(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_rep_commission.php`,
      req
    );
  }

  getCRreceipt() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/add_advt_credit_note.php`,
      {}
    );
  }

  getCdatabyid(req3: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_credit_invoice_data_by_id.php`,
      req3
    );
  }


  getCreditNoteDetails(body: { id: string }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_credit_invoice_databy_id.php`,
      body
    );
  }


  getAdvtOutstanding1(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_pyt_officer_b.php`,
      { data }
    );
  }

  getCreditNoteV(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_credit_officer_b.php`,
      req
    );
  }
  getCreditNoteM(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_credit_monthwise.php`,
      req
    );
  }
  getCreditNoteNB() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_credit_datewise.php`,
      {}
    );
  }
  getOutstandingB(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_outstanding_b.php`,
      req
    );
  }
  getonlyOutstandingindetail(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_unpaid_outstanding_detail.php`,
      req
    );
  }
  creditoutstaqndingindetails(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_credit_outstanding_detail.php`,
      req
    );
  }
  getonlyOutstandingB(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_unpaid_outstanding_b.php`,
      req
    );
  }

  getonlyOutstandingVB(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_unpaid_outstanding_vb.php`,
      req
    );
  }

  getissueonlyOutstandingVB(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_unpaid_outstanding_vb.php`,
      req
    );
  }

  getBusinessOutstanding(req: { rep_name: any; start_date: any; end_date: any; off_rep_name: any; advt_name: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_outstanding_business_yearwise.php`,
      req
    );
  }




  getcreditbrieflyoutstanding(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_credit_outstanding_b.php`,
      req
    );
  }

  getpendingreceipt(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_remainder_cus.php`,
      req
    );
  }
  getpendingreceipt1(req: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/getInvoiceBySeller.php`,
      req
    );
  }
  getpendingreceipt2(req: { rep_name: any; start_date: any; end_date: any; off_rep_name: any; booksellername?: string; issue_name: string; issue_date: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/getInvoiceBySeller1.php`,
      req
    );
  }

  getpendingreceiptRep(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_remainder_rep.php`,
      req
    );
  }
  getpendingreceiptRep1(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/getInvoiceBySeller1.php`,
      req
    );
  }
  // getPaymentRegiInDetails() {
  //   return this.httpClient.post(
  //     `${this.PHP_API_SERVER}/get_advt_pyt_datewise_detail.php`,
  //     {  }
  //   );
  // }
  // get officer rep for subscr
  getOffRepSub() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_rep_list.php`,
      {}
    );
  }
  getprantname() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_all_prant.php`,
      {}
    );
  }

  getAllCommData(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_all_comm_data.php`,
      req
    );
  }



  getOffRepSub1() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_all_offrepname.php`,
      {}
    );
  }


  getBookDeliveryMOdeList() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_delivery_mode.php`,
      {}
    );
  }
  getBookDeliveryMOdeList1() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_delivery_mode1.php`,
      {}
    );
  }


  addbookdeliveryMode(dev_mode: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_book_delivery_modes.php`,
      {
        dev_mode,
      }
    );
  }


  deletedDeliveryModeType(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_book_delivery_mode.php`,
      { id }
    );
  }


  getSubByZilha(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_sub_renewal_district.php`,
      req
    );
  }

  getSubByZilhaIndetails(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_sub_renewal_district_indetail.php`,
      req
    );
  }

  getDeliverytype(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_sub_renewal_prant.php`,
      req
    );
  }

  getSubRemDist(req: any) {
    // return this.httpClient.post(
    //   `${this.PHP_API_SERVER}/get_renewable_separate_count_districtwise.php`,
    //   req
    // );
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_renewable_separate_count_state_taluka.php`,
      req
    );
  }


  getBookRcptwise(recpt_no: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_print_details_rcptwise.php`,
      { recpt_no }
    );
  }



  getBookReceiptRegisterSearch(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_search_data_rcpt_pymt.php`,
      req
    );
  }
  getBookReceiptRegisterSearch1(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_data_for_book_crdt_payment_search.php`,
      req
    );
  }

  getDataByBooksRcptwise(recpt_no: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_print_data_by_rcpt_wise.php`,
      { recpt_no }
    );
  }
  deleteBookPymtreceipt(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_book_by_receipt.php`,
      { req }
    );
  }

  getSubRemDistBriefly(req: any) {
    // return this.httpClient.post(
    //   `${this.PHP_API_SERVER}/get_renewable_separate_count_districtwise.php`,
    //   req
    // );


    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_renewable_separate_count_districtwise_briefly.php`,
      req
    );
  }


  getSubRemTaluka(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_renewable_separate_count_talukawise.php`,
      req
    );
  }

  getSubRemRenewTalukabriefly(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_renewable_separate_count_talukawise_briefly.php`,
      req
    );
  }

  getSubRemOffRepbrief(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_renewable_separate_count_off_rep_briefly.php`,
      req
    );
  }


  getSubRemOffRep(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_renewable_separate_count_off_rep.php`,
      req
    );
  }

  getSubRemRep(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_renewable_separate_count_repwise.php`,
      req
    );
  }


  getSubRemOffVbriefly(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_renewable_separate_count_off_rep_vbriefly.php`,
      req
    );
  }

  getSubRemRepVbriefly(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_renewable_separate_count_repwise_vbriefly.php`,
      req
    );
  }

  getSubRemRepbriefly(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_renewable_separate_count_repwise_briefly.php`,
      req
    );
  }

  getSubByRep(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_sub_renewal_rep_taluka.php`,
      req
    );
  }
  getSubByOffRep(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_sub_renewal_off_rep_taluka.php`,
      req
    );
  }
  getSubByTypewise(req1: any) {

    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_sub_delivery_district.php`,
      req1
    );
  }

  getSubByTalukawise(req1: any) {

    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_sub_delivery_taluka.php`,
      req1
    );
  }

  getSubByZilhaBriefly(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_sub_renewal_district_briefly.php`,
      req
    );
  }

  getSubByTalukaIndetails(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_sub_renewal_taluka_indetail.php`,
      req
    );
  }

  getSubByoffcierwise(req1: any) {

    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_sub_delivery_off_rep_name.php`,
      req1
    );
  }

  getSubByReprwise(req1: any) {

    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_sub_delivery_rep_name.php`,
      req1
    );
  }

  getSubByTaluka(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_sub_renewal_taluka.php`,
      req
    );
  }

  getPaymentRegiInDetails1(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_pyt_datewise_detail.php`,
      req
    );
  }

  dataforrec1(): Observable<any> {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/get_issue_pyt_datewise_detail.php`
    );
  }
  getPaymentRegiInDetails11(req: { req: { rep_name: any; startDate: any; endDate: any; off_rep_name: any; issue_name: any; issue_Date: any; }; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_pyt_datewise_detail.php`,
      req
    );
  }





  getPaymentRegiOffInDetails(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_pyt_datewaise_office_detail.php`,
      req
    );
  }
  // getCreditRegiInDetails(req) {
  //   return this.httpClient.post(
  //     `${this.PHP_API_SERVER}/get_credit_datewise_Detail.php`,
  //     req
  //   );
  // }

  getCreditRegiInDetails(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_credit_datewise_indetail.php`,
      req
    );
  }


  getCreditRegiInDetails1(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_credit_datewise_Detail.php`,
      req
    );
  }

  getCreditRegiInDetails12(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_credit_datewise_Detail.php`,
      req
    );
  }
  getCreditRegiOffInDetails(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_credit_datewaise_office_detail.php`,
      { req }
    );
  }
  getCreditRegiInBriefly(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_credit_datewise.php`,
      { req }
    );
  }

  getAllAdvtAdd(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_outstanding_address.php`,
      req
    );
  }


  getBusinessReportInDetail(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_businessReportIndetail.php`,
      payload
    );
  }


  getBusinessReportIssue(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issuewiseAdvt_businessReport.php`,
      payload
    );
  }


  getBusinessDetailReportIssue(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issuewiseAdvtDetail_businessReport.php`,
      payload
    );
  }



  getAllAdd(req: { value: any; issue_name: any; issue_date: any; start_date: any; end_date: any; advt_name: any; rep_name: any; off_rep_name: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_prasiddhi_patrak_address_data.php`,
      req
    );
  }


  getAllAddlables(req: { value: any; issue_name: any; issue_date: any; start_date: any; end_date: any; advt_name: any; rep_name: any; off_rep_name: any; country: any; state: any; taluka: any; district: any; advttype: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_address_labels.php`,
      req
    );
  }


  challandata(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_price_by_issuedate.php`,
      { req }
    );
  }

  issueSellerchallandata(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_sale_price_by_issuedate.php`,
      { req }
    );
  }
  getgetpendingAdd(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_rep_cus_add.php`,
      req
    );
  }
  getgetAllAdd(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_cus_add.php`,
      req
    );
  }
  getgetAllAddList(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_cus_add.php`,
      req
    );
  }

  getNewRepList() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_rep_list.php`,
      {}
    );
  }
  withoutpagenopatrak(req: { issue_date: any; issueName: any; issue_name: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_without_page_no.php`,
      { req }
    );
  }
  getNewNameList() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/read_advt_names.php`,
      {}
    );
  }

  getCreditNoteMain(req1: { advt_name: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_pay_details.php`,
      req1
    );
  }
  getStampdata(start_date: string, end_date: string, advt_name: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_stamp_rcpt_list.php`,
      { start_date, end_date, advt_name }
    );
  }

  getStampdata1(
    start_date: any,
    end_date: any,
    advt_name: any,
    repName: any,
    offRepName: any,
    issueDates: any
  ) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_stamp_rcpt_list.php`,
      {
        start_date,
        end_date,
        advt_name,
        repName,
        offRepName,
        issueDates
      }
    );
  }



  getCreditNoteModal(req: { data: { credit_voc_no: any; invoice_no: any; advt_amt: any; invoice_date: any; advt_name: any; advt_no: any; creation_date: any; voc_date: string; credit_amt: any; tds_amt: any; other_credit_amt: any; credit_type: any; rep_name: any; credit_remark: any; credit_count: any; }; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/add_advt_credit_note.php`,
      req
    );
  }
  stampreceiptdelete(id: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_advt_stamp_rcpt.php`,
      { id }
    );
  }
  getCreditNoteG() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_last_credit_voc_count.php`,
      {}
    );
  }
  getAdvtStampNumber(date: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_stamp_rcpt.php`,
      { date }
    );
  }
  getCreditNoteG1(date: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_credit_note_rcpt.php`,
      { date }
    );
  }
  getReceiptnumber(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_last_advt_rcptno.php`,
      { req }
    );
  }

  getReceiptnumber1(req: { date: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_last_issue_rcptno.php`,
      { req }
    );
  }

  // saveIssueSellerBookingEntry(issuesellerbooking): Observable<any[]> {
  //   return this.httpClient.post<any[]>(
  //     `${this.PHP_API_SERVER}/save_issue_seller_booking.php`,
  //     { issuesellerbooking }
  //   );
  // }
  saveIssueSellerBookingEntry(issuesellerbooking: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/save_issue_seller_booking.php`,
      { issuesellerbooking }
    );
  }
  updateRecordIssueRegistration(issuesellerbooking: { id: any; bookingDate: any; bookingNumber: any; issueSellerId: any; representativeId: any; officeRepresentativeId: any; issueCatregoryId: any; issueSellerDate: any; issueNameId: any; issueSellerPrice: any; issueSellerCopies: any; complementaryCopies: any; amount: any; discountPercentage: any; discountAmount: any; netAmount: any; issueRemark: any; issueSellerGstType: any; gstPercentage: any; gstAmount: any; withoutGstAmount: any; withGstAmount: any; deliveryModeId: any; deliverySubModeId: any; distributionRepresentativeId: any; totalAmount: any; distributionMode: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_issue_registration_indetail_report.php`,
      { issuesellerbooking }
    );
  }
  deleteIssueRegistration(issuesellerbooking: { id: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_issue_representation_indetail_report.php`,
      { issuesellerbooking }
    );
  }
  getIssueSellerList(payload: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_issue_seller_total_list.php`,
      payload
    );
  }


  // getIssueSellerRegDetailsReportList(issuesellerbooking): Observable<any> {
  //   return this.httpClient.post<any>(
  //     `${this.PHP_API_SERVER}/get_issue_registration_indetail_report.php`,
  //     { issuesellerbooking }
  //   );
  // }
  getIssueSellerRegDetailsReportList(issuesellerbooking: { representativeId: any; startDate: any; endDate: any; officeRepresentativeId: any; issueNameId: any; issueSellerDate: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_issue_registration_indetail_report.php`,
      { issuesellerbooking }
    );
  }

  getIssueSellerBookingNo(date: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_booking_no.php`,
      { date }
    );
  }
  insertIssueSaleInvoice(data: { invoice_no: any; booking_no: any; invoice_date: string; gst_no: string; pan_no: string; issue_seller_name: any; first_week_id: any; second_week_id: any; third_week_id: any; fourth_week_id: any; fifth_week_id: any; pre_amt: any; pay_amt: any; remaining_amt: any; }) {
    return this.httpClient.post(`${this.PHP_API_SERVER}/add_issue_seller_invoice.php`, {
      data,
    });
  }
  saveIssueSellerBill(issuesellerbooking: { billno: any; date: any; issuename: any; issuedate: any; issue_seller_name: any; newordeleted: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_issue_seller_invoice.php`,
      { issuesellerbooking }
    );
  }

  getNextIssueSaleInvoiceNo(issuesellerbooking: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_name_invoice.php`,
      { issuesellerbooking }
    );
  }
  getdeleteIssueSaleReceipt(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_deleted_all_type_receipt_no.php`,
      { data }
    );
  }
  getIssueSellerBookingList() {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/get_issue_seller_invoice.php`
    );
  }

  getIssueSellerInvoiceByFilterList(issuesellerinvoice: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_invoice_byfilter.php`,
      issuesellerinvoice
    );
  }
  getRenewableDataByDate(
    startDate: any,
    endDate: any,
    repName: any,
    offRepName: any,
    district: any,
    taluka: any
  ) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_renewable_data_by_date.php`,
      {
        startDate,
        endDate,
        repName,
        offRepName,
        district,
        taluka,
      }
    );
  }


  accountUserLogin(data: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/user_login.php`, data
    );
  }

  updateDebitVoucherData(debitvoucher: { dvnumber: any; rname: any; othername: any; exp_amt: any; chequeno: any; chequedate: string | null; totalexp: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/update_debit_voucher_data.php`,
      { debitvoucher }
    );
  }

  getBookSeNames(name: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/read_book_seller_names.php`,
      {
        name
      }
    );
  }

  getBookSellerLedgerBriefly(req: { start_date: any; end_date: any; book_seller_name: string; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_seller_ledger_briefly.php`,
      req
    );
  }

  cancelBookInvoice(id: number, invoice_no: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/cancel_book_invoice.php`,
      { id, invoice_no }
    );
  }

  getBookOrderForView(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_order_for_view.php`,
      { id }
    );
  }

  getBookOrderDataForView(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_order_data_for_view.php`,
      { id }
    );
  }
  get_assign_office_representatives(rep_type: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_assign_office_representatives.php`,
      { rep_type }
    );
  }


  getBookdeleteOrder(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_deleted_order_no.php`,
      { data }
    );
  }
  getIssueSellerRegbriflyReportList(issuesellerbooking: { representativeId: any; startDate: any; endDate: any; officeRepresentativeId: any; issueNameId: any; issueSellerDate: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_issue_registration_brifly.php`,
      { issuesellerbooking }
    );
  }
  getIssueSellerRegrepwiseindetailReportList(issuesellerbooking: { representativeId: any; startDate: any; endDate: any; officeRepresentativeId: any; issueNameId: any; issueSellerDate: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_issue_reg_report_repwise_indetail.php`,
      { issuesellerbooking }
    );
  }
  getIssueSellerRegoffwiseindetailReportList(issuesellerbooking: { representativeId: any; startDate: any; endDate: any; officeRepresentativeId: any; issueNameId: any; issueSellerDate: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_issue_reg_report_offrepwise.php`,
      { issuesellerbooking }
    );
  }
  getIssueSellerRegoffwisebriflyReportList(issuesellerbooking: { representativeId: any; startDate: any; endDate: any; officeRepresentativeId: any; issueNameId: any; issueSellerDate: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_issue_reg_report_repwise.php`,
      { issuesellerbooking }
    );
  }

  newdelcrdtnote(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_deleted_crdtnote_no.php`,
      { data }
    );
  }

  getBookCrdtPymtData() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_data_for_book_crdt_payment.php`,
      {}
    );
  }

  insertBookPymtCrdt(data: any[]) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_creditnote.php`,
      { data }
    );
  }



  getBusinessReportBriefly(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_businessReportBriefly.php`,
      payload
    );
  }


  getBusinessReportVBriefly(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_businessReportVBriefly.php`,
      payload
    );
  }


  getCrdtWiseBooks(order_no: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_seller_credit_note_bookwise_data.php`,
      { order_no }
    );
  }
  getCrdtWiseBooks1(crdtnote_no: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_seller_credit_note_bookwise_data1.php`,
      { crdtnote_no }
    );
  }

  updateBookCopies(data: any[]): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update-book-copies.php`,
      data
    );
  }



  deleteBookPymtCrdt(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_book_by_crdt.php`,
      { req }
    );
  }

  deleteIssuePymtCrdt(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_issue_credit_note_details.php`,
      req // FIXED: no extra wrapper like { req }
    );
  }

  insertissuePymtRcptData(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_issue_pymt_rcpt_data.php`,
      {
        data,
      }
    );
  }

  getissueInvoiceDataById(name: any, type: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_invoice_data_by_id.php`,
      { name, type }
    );
  }

  updatepaymentreceiptissue(data: any) {
    // console.log(newadvtdtl);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_issue_paymnt_rcpt.php`,
      { data }
    );
  }

  getBookCrdtwise(crdtnote_no: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_crdt_details_rcptwise.php`,
      { crdtnote_no }
    );
  }

  getIssueCrdtwise(credit_voc_no: string[]) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_credit_note_open_print.php`,
      { credit_voc_no }
    );
  }

  getdeleteissuerecipt(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_deleted_all_type_receipt_no.php`,
      { data }
    );
  }
  getdeleteissuecnrecipt(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_deleted_all_type_receipt_no.php`,
      { data }
    );
  }

  getIssuesaleInvoiceRegisterListmonthly(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_s_invoice_monthwise.php`,
      req
      // getAdvtInvoiceRegisterList
    );
  }



  getissueMonthwise(req: { req: { rep_name: any; startDate: any; endDate: any; off_rep_name: any; issue_name: any; issue_Date: any; }; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_pyt_monthwise.php`,
      req
    );
  }


  getissueOfficerBriefly1(req: { rep_name: any; startDate: any; endDate: any; off_rep_name: any; issue_name: any; issue_Date: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_pyt_officer_b.php`,
      { req }
    );
  }


  getissuePaymentRegiOffInDetails(req: { rep_name: any; startDate: any; endDate: any; off_rep_name: any; issue_name: any; issue_Date: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_pyt_datewaise_office_detail.php`,
      { req }
    );
  }


  getissueOfficerVb(req: { rep_name: any; startDate: any; endDate: any; off_rep_name: any; issue_name: any; issue_Date: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_pyt_officer_vb.php`,
      { req }
    );
  }

  getissuesllerOfficerBriefly1(req: { rep_name: any; startDate: any; endDate: any; off_rep_name: any; issue_name: any; issue_Date: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_pyt_b.php`,
      { req }
    );
  }

  getBookRepNames() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_rep_name.php`,
      {}
    );
  }


  getBookCommRcptPymtData() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_data_for_book_comm_rcpt_pymt.php`,
      {}
    );
  }

  getCommPymtRcptNo(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_last_book_commno.php`,
      { req }
    );
  }

  getBusinessReport4(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_unpaid_outstanding_data_bookwise.php`,
      payload
    );
  }
  getBusinessReport41(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_unpaid_outstanding_data_in_detail4.php`,
      payload
    );
  }
  getOfficeRepMonthwiseReport(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_unpaid_outstanding_data_bookwise1.php`,
      payload
    );
  }

  getBookCommisionSpecificData(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_book_rep_wise_specific_data.php`
    );
  }

  // getBookRepSpecificData(request) {
  //   return this.httpClient.post<any>(
  //     `${this.PHP_API_SERVER}/read_vouchers_by_commission_search.php`,
  //     request
  //   );
  // }

  getRcptCommWiseBooks(order_no: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_rep_wise_specific_data1.php`,
      { order_no }
    );
  }
  getRcptCommWiseBooks1(order_no: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_rep_wise_specific_data2.php`,
      { order_no }
    );
  }


  getvoucherbycommision() {
    // console.log(dept_name);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_vouchers_by_comission.php`,
      {}
    );
  }




  getcommissionnumber(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_last_advt_commision_no.php`,
      { req }
    );
  }



  getvoucherbycommisionadvt(startDate: string, endDate: string, rep_name?: string) {
    const payload: any = {
      start: startDate,
      end: endDate,
      repname: rep_name,
    };

    console.log("Payload being sent:", payload); // Debug log

    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_vouchers_advt_commision.php`,
      payload,
      { headers: { 'Content-Type': 'application/json' } }
    );
  }


  getBookReppNames(name: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_book_rep_name.php`,
      {
        name
      }
    );
  }

  insertBookPymtCommission(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_commissiondata.php`,
      { data }
    );
  }

  deleteBookCommPymtCrdt(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_book_by_comm.php`,
      { req }
    );
  }

  getBookCommwise(commission_no: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_comm_detsild_rcptwise.php`,
      { commission_no }
    );
  }

  getBusinessReport(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_billing_report_monthwise1.php`,
      payload
    );
  }
  getBusinessReport1(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_billing_report_monthwise2.php`,
      payload
    );
  }
  getBusinessReport2(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_billing_report_monthwise3.php`,
      payload
    );
  }
  getBusinessReport3(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_billing_report_monthwise4.php`,
      payload
    );
  }
  getCreditdatabyid(req3: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_credit_invoice_data_by_id.php`,
      req3
    );
  }

  getissueInvoiceRegisterList(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_invoice_register.php`,
      req
      // getAdvtInvoiceRegisterList
    );
  }

  getissueInvoiceRegisterListbriefly(req: { start_date: any; end_date: any; issue_name: string; issue_date: string; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_invoice_register_briefly.php`,
      req
      // getAdvtInvoiceRegisterList
    );
  }

  getCreditNoteissueMain(req1: { issue_seller_name: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_pay_details.php`,
      req1
    );
  }

  getAllRepList(): Observable<any> {
    return this.httpClient.get<any>(`${this.PHP_API_SERVER}/get_all_list_rep_name.php`);
  }

  getAllOfcRepList(): Observable<any> {
    return this.httpClient.get<any>(`${this.PHP_API_SERVER}/get_all_list_office_rep_name.php`);
  }

  getAllBookSellerNameList(): Observable<any> {
    return this.httpClient.get<any>(`${this.PHP_API_SERVER}/get_all_list_book_seller_name.php`);
  }
  getAllgranthSellerNameList(): Observable<any> {
    return this.httpClient.get<any>(`${this.PHP_API_SERVER}/get_all_granth_seller_list_outstanding.php`);
  }
  getExpenseOrder(): Observable<any> {
    return this.httpClient.get<any>(`${this.PHP_API_SERVER}/get_expenses_with_orders.php`);
  }


  getBillNos() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_all_list_bill_no.php`,
      {}
    );
  }


  getBookInvoiceCommissionSearch(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_rep_commission_data_search.php`,
      req
    );
  }

  getBookOutstandingSearch2(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_rep_commission_data_search.php`,
      req
    );
  }

  getBookOutstandingSearch(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_out_standing_data_search.php`,
      req
    );
  }
  getBookOutstandingSearch1(req: { rep_name: any; office_rep_name: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_store_wise_rep_search.php`,
      req
    );
  }


  getCreditNoteModalissue(req: { data: { credit_note_no: any; invoice_no: any; issue_no: any; invoice_amt: any; invoice_date: string; issue_seller_name: any; creation_date: any; credit_note_date: string; creadit_note_amt: any; credit_type: any; representative_name: any; remark: any; copies: any; crdcopies: any; price: any; credit_count: any; }; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/add_issue_seller_credit_note_details.php`,
      req
    );
  }

  getInvoicenos(invoice_no: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/read_bill_nos.php`,
      {
        invoice_no
      }
    );
  }

  getBookReceiptRegisterrSearch(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_data_for_book_rcpt_pymt_search.php`,
      req
    );
  }
  getBookReceiptRegisterrSearch1(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_data_for_book_rcpt_pymt_search1.php`,
      req
    );
  }

  saveSubscriptionBarcodesDataEntry(data: { ds_sub_id: string; ds_sub_name: any; ds_sub_e_name: any; issue_date: string | null; barcode_number: any; weight: any; sender_mobile_number: any; added_date_time: string | null; is_barcode_generated: string; status: string; issueDate: any; subno: any; magzineIdName: any; }[]) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_add_barcode_master.php`,
      data
    );
  }

  saveParcelBarcodesDataEntry(data: any[]) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_add_parcel_barcode_master.php`,
      data
    );
  }

  getBarcodeList(request: { barcode_number: string; issue_date?: any; stateName?: any; districtName?: any; talukaName?: any; pincode?: any; rep?: any; officerep?: any; delivery_mode_name?: any; isIds?: any; subname?: any; disrep?: any; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_barcodes_list.php`,
      request
    );
  }

  getBarcodeParcelLabel(data: { issue_date: any; country: string; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_Barcode_Parcel_Label.php`,
      data
    );
  }

  deleteBarcodesByBarcodeNumbers(request: { barcode_number: any; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/deleteBarcodesByBarcodeNumbers.php`,
      request
    );
  }

  deleteParcelBarcodesByBarcodeNumbers(request: { parcel_barcode_number: any; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/deleteParcelBarcodesByBarcodeNumbers.php`,
      request
    );
  }

  getissueAllContractDetails(): Observable<any> {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/get_issue_contract_details.php`
    );
  }
  getIssuePersoanlLedBriefly(req: { startDate: any; endDate: any; issue_seller_name: string; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_Issue_personal_leadger_briefly.php`,
      req
    );
  }
  getissuePersoanlLed(req1: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_personal_leadger_detail.php`,
      req1
    );
  }

  getIssuesellerNames(issueSellerName: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/read_issue_seller_names.php`,

      {
        issueSellerName
      }
    );
  }
  saveDistrictwiseStatementDataEntry(data: { issue_date: any; country: any; state: any; number_of_subscribers: any; total: number; added_by: number; publish_date: string; delivery_mode: any; dispatch_date: string; no_of_books_in_bundle: any; bundle_count: any; district: any; allDistributerId: any; }[]) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_districtwise_statement.php`,
      data
    );
  }

  getDistrictwiseStatementList(request: { issue_date: any; country: string; districts: any; state: any; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_districtwise_statement_list.php`,
      request
    );
  }

  deleteDistrictwiseStatement(request: { ids: any; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/delete_districtwise_statement.php`,
      request
    );
  }


  savePincodewiseStatement(data: { issue_date: string; country: string; state: any; added_by: number; publish_date: string; delivery_mode: any; dispatch_date: string; district: any; pincode1: any; count_bundle1: any; no_of_book_bundle1: any; no_subscriber1: any; total1: number; pincode2: any; count_bundle2: any; no_of_book_bundle2: any; no_subscriber2: any; total2: number; pincode3: any; count_bundle3: any; no_of_book_bundle3: any; no_subscriber3: any; total3: number; allDistributerId1: any; allDistributerId2: any; allDistributerId3: any; }[]) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_pincodewise_statement.php`,
      data
    );
  }

  saveIssueSellerPincodewiseStatement(data: { issue_date: string; country: string; state: any; added_by: number; publish_date: string; delivery_mode: any; dispatch_date: string; district: any; pincode1: any; no_of_book_bundle1: any; count_bundle1: any; no_subscriber1: any; total1: number; pincode2: any; no_of_book_bundle2: any; count_bundle2: any; no_subscriber2: any; total2: number; pincode3: any; no_of_book_bundle3: any; count_bundle3: any; no_subscriber3: any; total3: number; }[]) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_issue_seller_pincodewise_statement.php`,
      data
    );
  }


  deletePincodewiseStatement(request: { ids: any; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/delete_pincodewise_statement.php`,
      request
    );
  }

  deleteIssueSellerPincodewiseStatement(request: { ids: any; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/delete_issue_seller_pincodewise_statement.php`,
      request
    );
  }
  getIssueOutstanding(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_outstanding_detail.php`,
      req
    );
  }

  getissueonlyOutstandingB(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_unpaid_outstanding_b.php`,
      req
    );
  }

  getissueonlyOutstandingindetail(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_unpaid_outstanding_detail.php`,
      req
    );
  }

  issuecreditoutstaqndingindetails(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_credit_outstanding_detail.php`,
      req
    );
  }


  getPincodewiseStatementList(request: { issue_date: any; countryName: any; districtName: any; stateName: any; talukaName: any; pincode: any; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_pincodewise_statement_list.php`,
      request
    );
  }

  getIssueSellerPincodewiseStatementList(request: { issue_date: any; country: string; district: any; state: any; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_pincodewise_statement_issue_seller_list.php`,
      request
    );
  }

  getPincodewiseEntryCheck(request: { issue_date: any; country: string; district: any; state: any; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_pincodewise_entry_check.php`,
      request
    );
  }

  getIssueSellerPincodewiseEntryCheck(request: { issue_date: any; country: string; district: any; state: any; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_issue_seller_pincodewise_entry_check.php`,
      request
    );
  }

  savePincodeStatewiseStatement(data: { issue_date: any; country: string; added_by: number; publish_date: string; delivery_mode: any; dispatch_date: string; state1: any; pincode1: any; no_of_book_bundle1: any; count_bundle1: any; no_subscriber1: any; state2: any; pincode2: any; no_of_book_bundle2: any; count_bundle2: any; no_subscriber2: any; otherStateTotal: number; otherStateGatthe: number; otherStatesankhya: number; mumbaiPincodeWiseTotal: number; mumbaiGatthe: number; mumbaisankhya: number; thanePincodeWiseTotal: number; thaneGatthe: number; thanesankhya: number; districtWiseTotal: number; districtWiseGatthe: number; districtWisesankhya: number; allAdditionTotal: number; allAdditionGatthe: number; allAdditionsankhya: number; allDistributerId1: any; allDistributerId2: any; }[]) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_pincode_statewise_statement.php`,
      data
    );
  }

  saveIssueSellerPincodeStatewiseStatement(data: { issue_date: any; country: string; added_by: number; publish_date: string; delivery_mode: any; dispatch_date: string; state1: any; pincode1: any; no_of_book_bundle1: any; count_bundle1: any; no_subscriber1: any; state2: any; pincode2: any; no_of_book_bundle2: any; count_bundle2: any; no_subscriber2: any; otherStateTotal: number; otherStateGatthe: number; otherStatesankhya: number; mumbaiPincodeWiseTotal: number; mumbaiGatthe: number; mumbaisankhya: number; thanePincodeWiseTotal: number; thaneGatthe: number; thanesankhya: number; districtWiseTotal: number; districtWiseGatthe: number; districtWisesankhya: number; allAdditionTotal: number; allAdditionGatthe: number; allAdditionsankhya: number; }[]) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_issue_seller_pincode_statewise_statement.php`,
      data
    );
  }

  getOtherStatePincodewiseStatementList(request: { issue_date: any; country: string; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_other_state_pincode_wise_list.php`,
      request
    );
  }
  getIssueSellerOtherStatePincodewiseStatementList(request: { issue_date: any; country: string; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_other_issue_seller_pincodewise_list.php`,
      request
    );
  }

  deleteOtherPincodewiseStatement(request: { ids: any; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/delete_other_pincode_statewise_statement.php`,
      request
    );
  }
  deleteIssueSellerOtherPincodewiseStatement(request: { ids: any; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/delete_other_pincodewise_statewise_statement.php`,
      request
    );
  }

  getissueOutstandingB(request: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_issue_outstanding_b.php`,
      request
    );
  }
  saveAllDistributerEntry(data: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_All_Distributer_Copies_Total.php`,
      data
    );
  }

  saveIssueSellerAllDistributerEntry(data: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_all_distributor_copies_for_issue_seller.php`,
      data
    );
  }
  getAllDistributerCopiesList(request: { issue_date: any; countryName?: any; stateName: any; distributionMode: any; subDistributionMode: any; districtName: any; talukaName: any; pincode: any; isOtherPincodeWise?: string; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_list_All_Distributer_Copies_Total.php`,
      request
    );
  }

  getAllDistributerCopiesListByDistrictwiseStatement(request): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/getAllDistributerCopiesListByDistrictwiseStatement.php`,
      request
    );
  }

  get_list_All_Distributer_Copies_Total_For_Other_State_Pincodewise_Statement(request): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_list_All_Distributer_Copies_Total_For_Other_State_Pincodewise_Statement.php`,
      request
    );
  }


  getIssueSellerAllDistributerCopiesList(request: { issue_date: any; stateName: any; pincode: any; distributionMode?: any; subDistributionMode?: any; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_list_All_Issue_Seller_Distributer_Copies_Total.php`,
      request
    );
  }
  getAllDistributerCopiesForHandDelevery(request: { issue_date: any; distributionMode: any; subDistributionMode: any; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_all_distributer_copies_total_for_hand_delevery.php`,
      request
    );
  }
  deleteAllDistributerCopiesTotal(request: { ids: string; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/delete_All_Distributer_Copies_Total.php`,
      request
    );
  }


  deleteIssueSaleAllDistributerCopiesTotal(request: { ids: string; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/delete_All_issue_Seller_Distributer_copies.php`,
      request
    );
  }
  getAllissuesellerAdd(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_outstanding_address.php`,
      req
    );
  }
  getissuecreditbrieflyoutstanding(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_credit_outstanding_b.php`,
      req
    );
  }

  // Issue seller credit note In-Detail Report 
  getissueCreditRegiInDetails(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_credit_datewise_Detail.php`,
      req
    );
  }
  getRegReportbriflyrep(req: { representativeId: any; startDate: any; endDate: any; officeRepresentativeId: any; issueNameId: any; issueSellerDate: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_reg_report_repwise_briefly.php`,
      req
    );
  }

  getIssueCreditNoteM(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_credit_monthwise.php`,
      req
    );
  }

  getIssueCreditRegiOffInDetails(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_credit_datewaise_office_detail.php`,
      { req }
    );
  }
  getIssueCreditNoteVB(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_credit_officer_vb.php`,
      { req }
    );
  }
  getIssueCreditNoteV(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_credit_officer_b.php`,
      req
    );
  }

  saveStatewiseStatement(data: { issue_date: string; country: string; state: any; number_of_subscribers: any; district: any; total: any; added_by: number; publish_date: string; delivery_mode: any; dispatch_date: string; }[]) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_statewise_statement.php`,
      data
    );
  }
  getStatewiseStatementList(request: { issue_date: any; country: string; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_statewise_statement_list.php`,
      request
    );
  }

  deleteStatewiseStatement(request: { ids: any; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/delete_statewise_statement.php`,
      request
    );
  }



  saveParcelLabelDataEntry(data: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_parcel_label.php`,
      data
    );
  }

  saveIssueSellerParcelLabelDataEntry(data: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_issue_seller_parcel_label.php`,
      data
    );
  }

  getparcelLabel(data: { issue_date: any; country: string; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_parcel_label.php`,
      data
    );
  }

  getIssueSellerparcelLabel(data: { issue_date: any; country: string; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_issue_seller_parcel_label.php`,
      data
    );
  }
  saveDispatchStatementDataEntry(data: { issue_date: string; country: string; status: string; distribution_mode: any; state: any; district: any; place: any; total: number; added_by: number; prati: any; dispatch_date: string; delivery_mode: any; publish_date: string; sub_distribution_mode: any; distribution_representative: any; weight_of_copy: any; postal_rates: any; number_of_copies_in_bundle: number; weight_of_bundle: any; total_bundle: number; total_books: number; total_shape_amt: number; shape: any; allDistributerId: any; }[]) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_Dispatch_statement.php`,
      data
    );
  }

  saveIssueSellerDispatchStatementDataEntry(data: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_issue_seller_dispatch_statement.php`,
      data
    );
  }
  getDispatchStatement(data: { issue_date: any; country: string; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_list_Dispatch_statement.php`,
      data
    );
  }

  getIssueSellerDispatchStatement(data: { issue_date: any; country: string; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_issue_seller_dispatch_statement_list.php`,
      data
    );
  }

  AddNewBookAvailableStock(bookid: number, bookedition: any, total_copies: any, available_stock: any) {
    //console.log(magname)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_book_available_stock.php`,
      { bookid, bookedition, total_copies, available_stock }
    );
  }


  UpdateNewBookAvailableStock(bookid: number, bookedition: any, total_copies: number, available_stock: number) {
    //console.log(magname)
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/new_book_available_stock.php`,
      { bookid, bookedition, total_copies, available_stock }
    );
  }

  UpdateNewBookAvailableeStock(bookid: any, bookedition: any, total_copies: any, available_stock: any) {
    //console.log(magname)
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_book_available_stock.php`,
      { bookid, bookedition, total_copies, available_stock }
    );
  }

  getAllBookStockData(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_book_records.php`
    );
  }

  //issue seller credit note briefly report

  getIssueSellerCreditBrieflyReport(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_credit_briefly_report.php`,
      req
    );
  }

  bulkInsertCrdtPackagesAndDetails(payload: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_credit_voucher_package_details.php`,
      payload
    );
  }

  saveCrdtVoucherAllOtherExpenses(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/save_crdt_voucher_all_other_expenses.php`, { ...data });
  }

  saveCrdtVoucherAllExpExpenses(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/save_crdt_voucher_all_expenditure_expenses.php`, data);
  }

  getRegReportverybriflyrep(req: { representativeId: any; startDate: any; endDate: any; officeRepresentativeId: any; issueNameId: any; issueSellerDate: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_reg_report_vb_repwise_indetail.php`,
      req
    );
  }
  getAllRepBookCommission2(req: { start_date: string; end_date: string; office_rep_name: string; rep_name: string; book_seller_name: string; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_rep_commission_data_indetails.php`,
      req
    );
  }

  getIssueCreditRegiInBriefly(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_credit_datewise_Detail.php`,
      req
    );
  }

  getCreditNoteG2(date: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_credit_note_rcpt.php`,
      { date }
    );
  }

  getBooksellerTypeList() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_seller_type.php`,
      {}
    );
  }
  getAllRepBookCommission1(req: { start_date: string; end_date: string; office_rep_name: string; rep_name: string; book_seller_name: string; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_rep_commission_data_unpaid.data.php`,
      req
    );
  }

  getAllRepBookCommission(req: { start_date: string; end_date: string; office_rep_name: string; rep_name: string; book_seller_name: string; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_rep_commission_data_indetails.data.php`,
      req
    );
  }

  getBookPaymentRegiOffInDetails1(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_pytm_receipt_register_indetailall.php`,
      req
    );
  }

  getBookPaymentRegiOffInDetails2(req: { start_date: string; end_date: string; office_rep_name: any; rep_name: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_office_rep_monthly_summary.php`,
      req
    );
  }

  getBookCreditNoteMonthwise(req: { start_date: string; end_date: string; office_rep_name: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/book credit note month-wise.php`,
      req
    );
  }

  getBookCreditNoteReport(req: { start_crdtnote_date: string; end_crdtnote_date: string; office_rep_name: any; rep_name: any; bill_no: any; book_seller_name: any; crdtnote_no: any; book: any; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_data_for_book_crdt_payment_indetails.php`,
      req
    );
  }

  getBookRegistrationLedgerReport4(req: { start_date: string; end_date: string; rep_name: string[]; office_rep_name: string[]; book_name: string[]; book_seller_name: string[]; commissionFilter: string[]; complimentaryFilter: string[]; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_data_for_book_registration_ledger.indetail4.php`,
      req
    );
  }

  getBookRegistrationLedgerReport(req: { start_date: any; end_date: any; rep_name: any; office_rep_name: any; book_name?: string[]; book_seller_name: string | string[]; commissionFilter?: string[]; complimentaryFilter?: string[]; bill_no?: string; book?: string; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_data_for_book_registration_ledger.indetail.php`,
      req
    );
  }

  getBookRegistrationLedgerReport1(req: { start_date: any; end_date: any; rep_name: any; office_rep_name: any; book_name: any; book_seller_name: any; commissionFilter: string[]; complimentaryFilter: string[]; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_data_for_book_registration_ledger.indetail1.php`,
      req
    );
  }

  getBookRegistrationLedgerReport2(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_data_for_book_registration_ledger.indetail2.php`,
      req
    );
  }
  getBookRepSpecificData(request: { vstart_date: any; vend_date: any; estart_date: any; eend_date: any; rep_name: any; book_seller_name: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_vouchers_by_comission2.php`,
      request
    );
  }

  getAllBookData1(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_all_book_data.php`
    );

  }
  getBookWiseRep1(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_store_wise_rep_search.php`,
      req
    );
  }

  getRepCommissionData1(request: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_rep_commission_data_search.php`,
      request
    );
  }

  getBookRepSpecificData1(request: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_vouchers_by_comission1.php`,
      request
    );
  }

  deleteBookSellerEntry(bse_id: number): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_book_seller_data.php`,
      { bse_id }
    );
  }

  addExpenseLedgerWhenSubTypeAdds(data: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_expense_ledger_when_we_add_sub_type.php`,
      { data }
    );
  }

  getissueRegReportInDetailsdatewise(req1: { rep_name?: any; start_date?: any; end_date?: any; off_rep_name?: any; issuename?: any; issue_date?: any; representativeId?: any; startDate?: any; endDate?: any; officeRepresentativeId?: any; issueNameId?: any; issueSellerDate?: any; }): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_issue_reg_report_datewise_indetail.php`,
      { req1 }
    );
  }
  addBookSellerType(dev_mode: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_book_seller_type.php`,
      {
        dev_mode,
      }
    );
  }
  addComplimentryType(dev_mode: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_compl_type.php`,
      {
        dev_mode,
      }
    );
  }

  addAbhiyanType(dev_mode: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_new_abiyan.php`,
      {
        dev_mode,
      }
    );
  }
  deletedBookSellerType(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_book_seller_type.php`,
      { id }
    );
  }
  deletedComplType(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_comp_type.php`,
      { id }
    );
  }


  deletedAbhiyanType(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_abhiyan_type.php`,
      { id }
    );
  }


  updateBookSellerType(id: any, dev_mode: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_book_seller_type.php`,
      { id, dev_mode }
    );
  }
  updateComplType(id: any, dev_mode: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_compl_type.php`,
      { id, dev_mode }
    );
  }

  updateAbhiyanType(id: any, dev_mode: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_abhiyan_type.php`,
      { id, dev_mode }
    );
  }

  getBookComplementryList() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_complementry_type.php`,
      {}
    );
  }

  getBookAbhiyanList() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_abhiyan_type.php`,
      {}
    );
  }

  getBookGSTReportData(startdate: any, enddate: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_data_for_gst.php`,
      { startdate, enddate }
    );
  }

  getIssuebookingchildlist(issue_booking_id: number) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get.issue_booking_child_data.php`,
      { issue_booking_id }  // Send the ID in the request body
    );
  }

  getDeliverModelist(dis_mode: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_distribution_mode_rep.php`,
      { dis_mode }  // Send the ID in the request body
    );
  }


  getBookPaymentRegiOffInDetails(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_pymt_datewise_office_detail.php`,
      req
    );
  }

  getBookMonthwise(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_pymt_monthwise.php`,
      req
    );
  }

  getBookOfficerVb(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_pymt_officer_vb.php`,
      req
    );
  }

  getBookOfficerBriefly1(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_pymt_officer_b.php`,
      req
    );
  }

  getIssueInviceDataForView(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_issue_seller_invoice_for_vieww.php`,
      { id }
    );
  }



  getBasicInfoOfissueInvoice(id: number) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_invoice_for_view.php`,
      { id }
    );
  }

  getBookCommisionReceiptRegisterrSearch(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_data_for_book_comm_rcpt_pymt_search.php`,
      req
    );
  }

  updateActiveStatus(issueseller: { id: any; status: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_active_status.php`,
      { issueseller }
    );
  }

  deleteDispatchStatement(request: { ids: any; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/delete_dispatch_statement.php`,
      request
    );
  }

  getBankRecoReport(startDate: any, endDate: any, bankType: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_bank_reco_report_data.php`,
      { startDate, endDate, bankType }
    );
  }

  getBankRecoReport1(startDate: any, endDate: any, bankType: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_bank_reco_report_data1.php`,
      { startDate, endDate, bankType }
    );
  }

  getBankOpeningBalance(bankType: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/read_bank_opening_balance.php`,
      { bankType }
    );
  }
  getPrintOrderDataByFurgation(subPeriodFromDate: string, subPeriodToDate: string, subscription_type: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_print_order_by_furgation.php`,
      { subPeriodFromDate, subPeriodToDate, subscription_type }
    );
  }

  filterIssuesByCategoryAndYears(payload: { category: string; years: string[] }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_issue_date_filterd_by_year.php`,
      payload
    );
  }

  getDigiIssueByCategory(category: string) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_issue_by_year.php`,
      { category }
    );
  }
  getPrintOrderByfurgationList(issue_date: any, country: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_print_order_byfurgation_data.php`,
      { issue_date, country }
    );
  }
  getIssueChallanNumnerG2(date: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_challan_no.php`,
      { date }
    );
  }
  getRepresentativeSummary(repName: string) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_challan_list.php`,
      { distribution_representative: repName }
    );
  }

  getchallanlistdataSummary(repName: string) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get.issue_seller_challan_listdistribution_address.php`,
      { distribution_representative: repName }
    );
  }

  getLatestBooksData(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_book_latest_data.php`
    );
  }


  getBookStockOpeningData(request: { book_name: string; start_date: any; end_date: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_stock_ledger_briefly.php`,
      request
    );
  }

  getentrybyadvtrepnamelist(name: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_rep_invoiceList.php`,
      { name }
    );
  }


  getAllRepInvoicesForPymt(name: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_advt_rep_commission.php`,
      { name }
    );
  }



  insertchallanSaleInvoice(data: { challan_date: any; challan_no: any; issue_granth: any; issue_date: any; delivery_mode: any; distribution_representative: any; distribution_mode: any; sub_distribution_mode: any; copies: any; total_amount: any; status: string; }) {
    return this.httpClient.post(`${this.PHP_API_SERVER}/add_issue_seller_challan_details.php`, {
      data,
    });
  }

  insertPprintOrderByFurgation(data: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_print_order_byfurgation.php`,
      data
    );
  }

  getdatabyreceipt1(recpt_no: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_issue_sale_print_details_rcptwise.php`,
      { recpt_no }
    );
  }

  getIssueReceiptnumber(req: { date: string; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_last_issue_rcptno.php`,
      { req }
    );
  }
  getnewapi2(req1: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_sub_vargani_count_1.php`,
      { req1 }
    );
  }
  getlabelsforIssueSellerDispatch(filterPayload: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_Label_for_Issue_Seller_Dispatch.php`,
      filterPayload
    );
  }
  getissuenewapi2(req1: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_issue_seller_vargani_count_1.php`,
      { req1 }
    );
  }


  deleteIssuePymtreceipt(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_payment_rcpt_issuesale.php`,
      req
    );
  }

  saveIssueSellerDistrictwiseStatementDataEntry(data: { issue_date: any; country: any; state: any; number_of_subscribers: any; total: number; added_by: number; publish_date: string; delivery_mode: any; dispatch_date: string; no_of_books_in_bundle: any; bundle_count: any; district: any; }[]) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_issue_seller_districtwise_statements.php`,
      data
    );
  }

  getIssueSellerDistrictwiseStatementList(request: { issue_date: any; country: string; districts: any; state: any; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_issue_seller_districtwise_statement.php`,
      request
    );
  }

  deleteIssueSellerDistrictwiseStatement(request: { ids: any; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/delete_Issue_Seller_districtwise_statement.php`,
      request
    );
  }
  saveIssueSellerStatewiseStatement(data: { issue_date: string; country: string; state: any; number_of_subscribers: any; district: any; total: any; added_by: number; publish_date: string; delivery_mode: any; dispatch_date: string; }[]) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_issue_seller_ststewise_statement.php`,
      data
    );
  }


  getIssueSellerStatewiseStatementList(request: { issue_date: any; country: string; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_Issue_seller_statewise_statement_list.php`,
      request
    );
  }

  deleteIssueSellerStatewiseStatement(request: { ids: any; }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/delete_Issue_seller_statewise_statement.php`,
      request
    );
  }

  getMoreCallIds(): Observable<any> {
    return this.httpClient.get(`${this.PHP_API_SERVER}/get_subscription_type_ids.php`);
  }

  getMainExpenseLedger1(): Observable<any> {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/get_main_expense_ledger_names.php`
    );
  }

  getIssueSellerDispatchData(data: { delivery_mode_id: any; distribution_representative_id: any; distribution_mode: any; delevery_sub_mode_id: any; issueCatregoryId: any; issue_date: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_issue_seller_dispatch vitran_list.php`,
      data
    );
  }
  getIssueSellerDispatchData1(data: {
    DeliveryMode: any;
    DistributiveRep: any;
    DistributionMode: any;
    SubDistMode: any;
    booking_date: any;

    // LOCATION
    country: any;
    state: any;
    district: any;
    taluka: any;
    pincode: any;

    // REPRESENTATIVE
    repwise: any;
    officerepwise: any;

    // OTHER
    sellertype: any;
    type: any;
    bookwise: any;
    issue_date: any;
    issueCatregoryId: any;
    showMobileNo: any;
  }) {

    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_issue_seller_dispatch vitran_list1.php`,
      data
    );

  }

  getIssueSellerofficerepData(data: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_posting_office_representative_list_issuesale.php`,
      data
    );
  }
  getIssueSellerofficerepData1(data: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_posting_office_representative_list_issuesale1.php`,
      data
    );
  }

  getExpenseLedgerReportData(request: { exp_id: any; sub_exp_id: any; startdate: any; enddate: any; }): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_expense_ledger_report_latest.php`,
      request
    );
  }
  getissueInvoiceRegisterListrni(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_rni_report.php`,
      req
      // getAdvtInvoiceRegisterList
    );
  }

  getUserPermissions(userId: number) {
    // console.log(state_id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_user_permissions.php`,
      { userId }
    );
  }

  getUsers() {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/getUsers.php`,
      {} // empty body since you don’t need to send any data
    );
  }

  updateUserPermissions(req: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_user_permissions.php`,
      req  // empty body since you don’t need to send any data
    );
  }

  addNewUser(req: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_user.php`,
      req
    );
  }

  updateUser(req: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_user.php`,
      req
    );
  }
  getissuesPrintOrderData(issueName: string, issueDate: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_print_order_data.php`,
      {
        issueDate: issueDate,
        issueName: issueName
      }
    );
  }
  insertissuePrintOrderData(data: { order_date: string; issue_date_from: string | null; issue_date_to: string | null; total_prati: number; total_prustha: number; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_issue_seller_print_order.php`,
      { data }
    );
  }
  insertissuesellerPrintOrderPrustha(order_id: any, data: any[]) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_issue_seller_print_order_prustha.php`,
      { order_id, data }
    );
  }
  insertissuesellerPrintOrderTypes(order_id: any, data: { no: number; name: string; prati: number; shera: string; }[]) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/issue_seller_print_order_types`,
      { order_id, data }
    );
  }
  IssueSellercancelPrintOrder(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/cancel_issue_seller_print_order.php`,
      { req }
    );
  }

  getAllissuePrintOrderData() {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/get_all_issue_seller_print_order_data.php`
    );
  }

  // getissuesellerPrintDataByID(id: number) {
  //   return this.httpClient.post(
  //     `${this.PHP_API_SERVER}/get_issue_seller_print_order_data_by_id.php`,
  //     {
  //       id,
  //     }
  //   );
  // }
  updateissuesellerprintorder(prusthaData: any) {
    //console.log(mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_issue_seller_print_order_prustha.php`,
      { prusthaData }
    );
  }
  updateissuesellerprintorder2(typeData: any) {
    //console.log(mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_issue_seller_print_order_prustha2.php`,
      { typeData }
    );
  }

  updateissuesellerprintorder3(orderid: any, total: any) {
    //console.log(mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_issueseller_total_prushta.php`,
      { orderid, total }
    );
  }

  getPackageReportData(packageId: number, startDate: any, endDate: any) {
    // console.log(state_id);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_package_report_data.php`,
      { startDate, endDate, packageId }
    );
  }
  deleteBookledgerreg(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_ledeger_complimentry_status.php`,
      req  // ✅ send the object directly
    );
  }

  // book-seller.service.ts

  getBookSellerBookingById(rcpt_id: number) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_bookingdataedit.php`,
      { rcpt_id }
    );
  }
  updateBookSellerEntryBookingDetails(booking: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_bookseller_entrybooking.php`,
      booking
    );
  }

  // Update single book data
  updateBookData(book: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_bookdata.php`,
      book
    );
  }
  getBookSellerList(payload: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_book_seller_total_list.php`,
      payload
    );
  }
  getDistributionRepresentativeSBhetHastewise3(payload: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_Label_for_Issue_Seller_Dispatch6.php`,
      { data: payload }
    );
  }
  getIssuesaleSbhetdata2(req1: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_Label_for_Issue_Seller_Dispatch5.php`,
      req1,   // ✅ SEND DATA HERE
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
  }
  saveHandDeliveryData(data: any[]) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/save_hand_delivery.php`,
      data
    );
  }
  addAssignDistributionMode2(data: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/add_assign_dis_mode_to_rep2.php`,
      data
    );
  }
  getSubDeliveryModehaste(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/read_sub_delivery_modehaste.php`
    );
  }

  getRemovedBookIds(): Observable<number[]> {
    return this.httpClient.get<number[]>(
      `${this.PHP_API_SERVER}/book_removed_orders.php`
    );
  }

  saveRemovedBookIds(ids: number[]): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/book_removed_orders.php`,
      { ids }
    );
  }
  getAllissuePrintOrderData2(data: any) {

    return this.httpClient.post(
      `${this.PHP_API_SERVER}/printOrderSearch.php`,
      data
    );

  }
  getissuesPrintOrderData1(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_seller_print_order_data.php`,
      payload
    );
  }
  savePrintOrder(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/save_print_order.php`,
      payload
    );
  }
  getPrintOrderByIdgranth(id: number,): Observable<any> {
    return this.httpClient.get(`${this.PHP_API_SERVER}/get_granth1_seller_print_order_data_by_id.php?id=${id}`);
  }
  getPrintOrderById(id: number,): Observable<any> {
    return this.httpClient.get(`${this.PHP_API_SERVER}/get_book_seller_print_order_data_by_id.php?id=${id}`);
  }
  updatePrintOrder(payload: any) {
    return this.httpClient.put(
      `${this.PHP_API_SERVER}/update_book_seller_print_order_data.php`,
      payload
    );
  }
  getAllissuePrintOrderData1() {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/get_all_book_seller_print_order_data.php`
    );
  }
  getissuesellerPrintDataByID(id: number) {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_book_seller_print_order_data_by_id.php?id=${id}`
    );
  }
  getissuesellerPrintDataByID1(id: number) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_seller_print_order_data_by_id.php`,
      {
        id,
      }
    );
  }

  checkActiveReceipts(orderno: any) {
    //console.log(magname)
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/check_receipt_status.php`,
      { orderno }
    );
  }

  getdatabyinvoice1(invoice_no: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_open_invoice_print.php`,
      { invoice_no }
    );
  }


  deleteBookEntry(id: number): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/remove_book_entery_update.php`,
      { id }
    );
  }

  // booking.service.ts
  saveBooking(payload: any): Observable<any> {
    // payload should include: bookingId, bse_id, books[]
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/addor_update_book.php`,
      payload
    );
  }


  addBookSellerEntryBookingDetailsPackage(bookseller: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_book_seller_entry_booking_package_details.php`,
      { bookseller }
    );
  }

  addBookDataPackage(bookdata: any) {
    // console.log('bookdata', bookdata);
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_book_data_package.php`,
      { bookdata }
    );
  }

  addBookSellerEntryPackage(bookseller: { title: any; name: any; address: any; sellertype: any; comptype: any; pincode: any; country: any; state: any; district: any; taluka: any; mobileNumber: any; gstNumber: any; email: any; dob: any; doa: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_book_seller_entry_package.php`,
      { bookseller }
    );
  }


  updateBookSellerEntryPackage(bookseller: { bse_id: number; title: any; name: any; sellertype: any; comptype: any; address: any; pincode: any; country: any; state: any; district: any; taluka: any; mobileNumber: any; gstNumber: any; email: any; dob: any; doa: any; }) {
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/update_book_seller_entry_package.php`,
      { bookseller }
    );
  }


  deleteBookSellerEntryPackage(bse_id: number): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_book_seller_data_package.php`,
      { bse_id }
    );
  }

  updateBookSellerEntryBookingDetailsPackage(booking: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_bookseller_entrybooking_Package.php`,
      booking
    );
  }

  updateBookDataPackage(book: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/update_book_data_package.php`,
      book
    );
  }

  saveBookingPackage(payload: any): Observable<any> {
    // payload should include: bookingId, bse_id, books[]
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/addor_update_package.php`,
      payload
    );
  }

  getBookSellerBookingByIdPackage(rcpt_id: number) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_bookingdataedit_package.php`,
      { rcpt_id }
    );
  }

  checkActiveReceiptsPackage(orderno: any) {
    //console.log(magname)
    return this.httpClient.put<any>(
      `${this.PHP_API_SERVER}/check_receipt_status_package.php`,
      { orderno }
    );
  }


  getBookDataForCancelPackage(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_data_for_cancel_order_package.php`,
      { id }
    );
  }

  getBookDataforCancelPackage(bookname: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_data_for_cancel_package.php`,
      { bookname }
    );
  }

  getBookSellerList1(payload: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/read_book_seller_total_list_package.php`,
      payload
    );
  }
  getBookSellerEntryPackage() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_seller_entry_package.php`,
      {}
    );
  }

  getBookdeleteOrderPackage(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_order_for_view_package.php`,
      { data }
    );
  }

  getBookSellerIdPackage(date: string) {
    const requestBody = { req: { date } }; // Correct JSON format

    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_seller_package_id.php`,
      requestBody
    );
  }


  getbookInvoiceRegisterListbriefly(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_billing_register_Brifley_Report.php`,
      req
      // getAdvtInvoiceRegisterList
    );
  }
  getbookInvoiceRegisterListbriefly1(req: { start_date: any; end_date: any; rep_name: string; office_rep_name: string; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_billing_register_Brifley1_Report.php`,
      req
      // getAdvtInvoiceRegisterList
    );
  }
  getOfficeRepInDetailsReport(req: { start_date: any; end_date: any; rep_name: string; office_rep_name: string; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_billing_register_Brifley3_Report.php`,
      req
      // getAdvtInvoiceRegisterList
    );
  }
  getOfficeRepBrieflyReport(req: { start_date: any; end_date: any; rep_name: string; office_rep_name: string; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_billing_register_Brifley2_Report.php`,
      req
      // getAdvtInvoiceRegisterList
    );
  }

  getBookInvoiceRegisterList(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/book_billing_indetail_report.php`,
      req
      // getAdvtInvoiceRegisterList
    );
  }
  getBookCustInvoicePKGId(date: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_cust_invoiceid.php`,
      { date }
    );
  }
  getbooksaleRegisterListmonthly(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_billing_report_monthwise.php`,
      req
      // getAdvtInvoiceRegisterList
    );
  }


  getAllDistributerCopiesListForPincodewiseStatement(request): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_list_For_PincodeWise_All_Distributer_Copies_Total.php`,
      request
    );
  }

  getLetterTemplate(templateName: string): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_letter_template.php`,
      { template_name: templateName }   // ✔ send required value
    );
  }


  saveLetterTemplate(data: any): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/save_letter_template.php`,
      JSON.stringify(data),
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
    );
  }
  saveLetterTemplate1(data: any): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/save_letter_template.php`,
      JSON.stringify(data),
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
    );
  }


  getLetterTemplaterep(templateName: string): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_letter_template_rep_issue_seller.php`,
      { template_name: templateName }   // ✔ send required value
    );
  }




  saveLetterTemplaterep(data: any): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/save_letter_rep_template.php`,
      JSON.stringify(data),
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
    );
  }


  getMissingDebitVoucherNumbers(voucher_date: string, bank: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_missing_dv_numbers.php`,
      { voucher_date, bank }
    );
  }

  getMissingCreditVoucherNumbers(voucher_date: string, bank: string) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_missing_cv_numbers.php`,
      { voucher_date, bank }
    );
  }



  getSubscribersByRep(repId: number, month: number, year: number): Observable<any> {
    const url = `${this.PHP_API_SERVER}/subscribers.php`
      + `?rep=${repId}&m=${month}&y=${year}`;
    return this.httpClient.get<any>(url);
  }

  getVouchersByRep(repId: string): Observable<any> {
    const url = `${this.PHP_API_SERVER}/voucherlist.php?rep=${repId}`;
    return this.httpClient.get<any>(url);
  }

  getBalanceSheet(data: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/balance_sheet.php`,
      data
    );
  }

  detectCVIssues(reqData: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/detect_cv_issues.php`,
      reqData
    );
  }

  detectDVIssues(reqData: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/detect_dv_issues.php`,
      reqData
    );
  }

  detectCreditorsIssues(reqData: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/detect_creditors_issues.php`,
      reqData
    );
  }

  addLekhak(data: any): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/add-lekhak.php`,
      data
    );
  }

  addIssue(data: any): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/add-issue.php`,
      data
    );
  }

  updateLekhak(data: any): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/update-lekhak.php`,
      data
    );
  }

  updateIssue(data: any): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/update-issue.php`,
      data
    );
  }

  deleteLekhak(id: any): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete-lekhak.php`,
      { id }
    );
  }

  deleteIssue(id: number): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_issue.php`,
      { id }
    );
  }

  getIssuesByMonth(month: string): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issues_by_month.php`,
      { month }
    );
  }

  getLekhakList(): Observable<any> {
    return this.httpClient.get(`${this.PHP_API_SERVER}/get-lekhak-list.php`);
  }

  getIssueList(): Observable<any> {
    return this.httpClient.get(`${this.PHP_API_SERVER}/get-issue-list.php`);
  }

  addLekhEntry(data: any): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/add_lekh_entry.php`,
      data
    );
  }

  updateLekhEntry(data: any): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/update_lekh_entry.php`,
      data
    );
  }

  deleteLekhEntry(id: number): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete_lekh_entry.php`,
      { id }
    );
  }

  getLekhEntryList(): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_lekh_entries.php`,
      {}
    );
  }

  getLekhExcelData(month: string): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_lekhak_excel_data.php`,
      { month: month }
    );
  }



  getAdvtjama(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_monthwise_payment_data.php`,
      req
    );
  }

  saveUdhisthaMonthwise(req: any): Observable<any> {
    return this.httpClient.post(`${this.PHP_API_SERVER}/saveUdhisthaMonthwise.php`, req);
  }


  getAdvtjamaPratinidi(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_monthwise_pratinidiPayment.php`,
      req
    );
  }




  getYearIssueReportInDetail(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_yearwsieissue_data.php`,
      payload
    );
  }

  getLekhReport(issue_month: string): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_lekh_report.php`,
      { issue_month: issue_month }
    );
  }



  saveSelectedAdvt(payload: any): Observable<any> {
    // payload should include: bookingId, bse_id, books[]
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/save_selected_advtSize.php`,
      payload
    );
  }
  getlabelsforIssueSellerDispatch1(filterPayload: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_Label_for_Issue_Seller_Dispatch1.php`,
      filterPayload
    );
  }
  getlabelsforIssueSellerDispatch3(filterPayload: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_Label_for_Issue_Seller_Dispatch3.php`,
      filterPayload
    );
  }
  getlabelsforIssueSellerDispatch4(filterPayload: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_Label_for_Issue_Seller_Dispatch4.php`,
      filterPayload
    );
  }
  getlabelsforIssueSellerDispatch2(filterPayload: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_Label_for_Issue_Seller_Dispatch2.php`,
      filterPayload
    );
  }

  getSavedAdvt(saved_by: string): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/getSelectedAdvtData.php`,
      { saved_by: saved_by }
    );
  }


  saveUdhistha(data: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/save_rep_udhistha.php`,
      { data }
    );
  }


  getUdhisthaValues(financial_year: string) {
    return this.httpClient.get<{ [repName: string]: number }>(
      `${this.PHP_API_SERVER}/save_rep_udhistha.php?financial_year=${financial_year}`
    );
  }
  getGranthInvoiceData() {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_book_data_granth_invoice.php`,
      {}
    );
  }



  getgranthData1() {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_granth_data1.php`,
      {}
    );
  }
  getAllGranthData(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_all_granth_book_data.php`
    );
  }

  getgranthsaleSbhetdata2(req1: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_Label_for_Issue_Seller_Dispatchgranth.php`,
      req1,   // ✅ SEND DATA HERE
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
  }

  saveHandDeliveryDatagranth(data: any[]) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/save_hand_deliverygranth.php`,
      data
    );
  }

  getissuesPrintOrderDatagranth(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_book_seller_print_order_data_granth.php`,
      payload
    );
  }

  savePrintOrder1(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/save_print_order_granth.php`,
      payload
    );
  }
  getPrintOrderById1(id: number,): Observable<any> {
    return this.httpClient.get(`${this.PHP_API_SERVER}/get_granth_seller_print_order_data_by_id.php?id=${id}`);
  }
  getAllissuePrintOrderDatagranth() {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/get_all_book_seller_print_order_datagranth.php`
    );
  }
  getlabelsforIssueSellerDispatchgranth(filterPayload: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_Label_for_granth_Seller_Dispatch3.php`,
      filterPayload
    );
  }
  getlabelsforIssueSellerDispatchgranthparcel(filterPayload: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_Label_for_Issue_Seller_Dispatchgranth.php`,
      filterPayload
    );
  }

  getStatesByCountryId(country_id: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_states_by_country_id.php`,
      { country_id }
    );
  }

  getDistrictsByStateId(state_id: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_districts_by_state_id.php`,
      { state_id }
    );
  }

  getTalukasByDistrictId(district_id: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_talukas_by_district_id.php`,
      { district_id }
    );
  }

  addCampaign(data: any): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/add-campaign.php`,
      data
    );
  }

  getCampaigns(): Observable<any> {
    return this.httpClient.get(
      `${this.PHP_API_SERVER}/get-campaigns.php`
    );
  }

  deleteCampaign(id: any): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/delete-campaign.php`,
      { id }
    );
  }

  editCampaign(id: any, name: string): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/edit-campaign.php`,
      { id, name }
    );
  }

  // ─── WhatsApp Campaign: Department-wise Customer Fetch ───────────────────────
  // Filters carry resolved TEXT names (country, state, district, taluka) so
  // PHP can do a direct column comparison — no ID-to-name subqueries needed.

  /** Subscription department customers (वर्गणी) */
  getSubscriptionCustomers(filters: {
    country?: string;
    state?: string;
    district?: string;
    taluka?: string;
    status?: string;
    fromDate?: string;   // Issue date range — start (yyyy-MM-dd)
    toDate?: string;     // Issue date range — end   (yyyy-MM-dd)
  }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_customers_subscription.php`,
      filters
    );
  }

  /** Advertisement department customers (जाहिरात) */
  getAdvertisementCustomers(filters: {
    country?: string;
    state?: string;
    district?: string;
    taluka?: string;
    status?: string;
  }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_customers_advertisement.php`,
      filters
    );
  }

  /** Issue Seller department customers (अंक विक्रेता) */
  getIssueSellerCustomers(filters: {
    country?: string;
    state?: string;
    district?: string;
    taluka?: string;
    status?: string;
  }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_customers_issue_seller.php`,
      filters
    );
  }

  /** Office Rep / Book Store department customers (पुस्तक भांडार) */
  getOfficeRepCustomers(filters: {
    country?: string;
    state?: string;
    district?: string;
    taluka?: string;
    status?: string;
  }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_customers_office_rep.php`,
      filters
    );
  }

  /** Representative department customers (प्रतिनिधी) */
  getRepresentativeCustomers(filters: {
    country?: string;
    state?: string;
    district?: string;
    taluka?: string;
    status?: string;
  }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_customers_representative.php`,
      filters
    );
  }

  /** Generic fallback — fetch customers by dep_id when no specific method matches */
  getCustomersByDepartment(depId: any, filters: {
    country?: string;
    state?: string;
    district?: string;
    taluka?: string;
    status?: string;
  }): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/get_customers_by_department.php`,
      { depId, ...filters }
    );
  }

  getgranthRegistrationLedgerReport4(req: { start_date: string; end_date: string; rep_name: string[]; office_rep_name: string[]; book_name: string[]; book_seller_name: string[]; commissionFilter: string[]; complimentaryFilter: string[]; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_data_for_granth_registration_ledger_indetail_report.php`,
      req
    );
  }
  getBookRegistrationDataWithoutInvoicepackage(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.PHP_API_SERVER}/get_granth_registration_ledgerlist.php`,
      {}
    );
  }

  getlIssueabeldata(req1: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_Label_for_Issue_Seller_Dispatch.php`,
      { req1 }
    );
  }


  //     updateActiveStatus( issueseller: { id: any; status: any; }) {
  //   return this.httpClient.post<any>(
  //     `${this.PHP_API_SERVER}/update_active_status.php`,
  //     { issueseller }
  //   );
  // }

  updateOfficeRepT(data: any) {
    return this.httpClient.post<any>(`${this.PHP_API_SERVER}/update_off_rep_data.php`,
      { updateofficerep: data }
    );
  }

  deleteOfficeRep(id: number) {
    return this.httpClient.post<any>(`${this.PHP_API_SERVER}/delete_office_rep.php`, { id });
  }



  addlanguage(data: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/insert_language.php`,
      data  // ← just "data", no { data }
    );
  }

  deletecountry(data: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_country.php`,
      data
    );
  }



  insertPrantData(payload: { prant_name: string, sequence_id?: any }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/insert_prant_master.php`,
      payload
    );
  }

  updatePrantData(id: number, prant_name: any, sequence_id: number) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/update_prant_name.php`,
      {
        id,
        prant_name,
        sequence_id
      }
    );
  }
  getgranthRegistrationLedgerReport(req: { start_date: any; end_date: any; rep_name: any; office_rep_name: any; book_name?: string[]; book_seller_name: string | string[]; commissionFilter?: string[]; complimentaryFilter?: string[]; bill_no?: string; book?: string; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_granth_office_representative_indetail_report.php`,
      req
    );
  }

  getgranthRegistrationLedgerReport1(req: { start_date: any; end_date: any; rep_name: any; office_rep_name: any; book_name?: string[]; book_seller_name: string | string[]; commissionFilter?: string[]; complimentaryFilter?: string[]; bill_no?: string; book?: string; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_granth_office_monthwise_ledger_report.php`,
      req
    );
  }
  getgranthRegistrationLedgerReport2(req: { start_date: any; end_date: any; rep_name: any; office_rep_name: any; book_name: any; book_seller_name: any; commissionFilter: string[]; complimentaryFilter: string[]; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_granth_registration_report_ledger_representative_indetail.php`,
      req
    );
  }

  getGranthRegistrationLedgerReport3(req: { start_date: any; end_date: any; rep_name: any; office_rep_name: any; book_name: any; book_seller_name: any; commissionFilter: string[]; complimentaryFilter: string[]; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_granth_registration_report_very_officer.php`,
      req
    );
  }

  getGranthRegistrationLedgerReport5(req: { start_date: any; end_date: any; rep_name: any; office_rep_name: string[]; book_name: string[]; book_seller_name: string[]; commissionFilter: string[]; complimentaryFilter: string[]; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_granth_registration_ledger_granthwise_report.php`,
      req
    );
  }

  getGranthBusinessReport1(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_granth_business_report_indetail.php`,
      payload
    );
  }
  getGranthBusinessReport2(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_granth_business_report_indetail1.php`,
      payload
    );
  }

  getGranthData(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_granth_data.php`,
      {
        id,
      }
    );
  }

  deletepackagegranthIds(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/delete_granth_entry_package.php`,
      { id }
    );
  }

  getGranthOrderForView(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_granth_order_for_view.php`,
      { id }
    );
  }


  getGranthOrderDataForView(id: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_granth_order_data_for_view.php`,
      { id }
    );
  }

  saveGranthAllUdhistha(data: any[]) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/saveAllUdishitaGranth.php`,
      {
        data: data
      }
    );
  }


  saveAllRowsGranth(data: any[]) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/save_udishta_granth.php`,
      { data }
    );
  }

  getGranthRegReportInDetailsoff(req1: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_granth_registration_ledger_very_briefly.php`,
      { req1 }
    );
  }


  getgranthBusinessReportrepwise(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_granth_business_Repwise-indetail.php`,
      payload
    );
  }

  getgranthBusinessReportofficerepwise(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_granth_business_report_office_rep_indetail.php`,
      payload
    );
  }



  sendBookReminderWhatsapp(payload: { mobile: string; campaignName: string; templateParams: string[] }) {
    return this.httpClient.post(`${this.PHP_API_SERVER}/send_wp_msg_using_aisensy.php`, payload);
  }
  getlabelsforGranthDispatch1(filterPayload: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_label_for_granth_dispatch.php`,
      filterPayload
    );
  }



  sendWhatsAppReceiptAdvt(payload: { mobile: string; campaignName: string; templateParams: string[] }) {
    return this.httpClient.post(`${this.PHP_API_SERVER}/send_wp_msg_using_aisensy.php`, payload);
  }


  sendWhatsAppOutstandingAdvt(payload: { mobile: string; campaignName: string; templateParams: string[] }) {
    return this.httpClient.post(`${this.PHP_API_SERVER}/send_wp_msg_using_aisensy.php`, payload);
  }
  getIssueSellerDispatchDatagranth(data: {
    DeliveryMode: any;
    DistributiveRep: any;
    DistributionMode: any;
    SubDistMode: any;
    booking_date: any;

    // LOCATION
    country: any;
    state: any;
    district: any;
    taluka: any;
    pincode: any;

    // REPRESENTATIVE
    repwise: any;
    officerepwise: any;

    // OTHER
    sellertype: any;
    type: any;
    bookwise: any;
    issue_date: any;
    issueCatregoryId: any;
    showMobileNo: any;
  }) {

    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_granth_package_seller_list.php`,
      data
    );

  }

  getGranthSellerofficerepData1(data: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_dispatchoffreport_granth_selller.php`,
      data
    );
  }


  getpendingreceiptRepissue(req: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_issue_seller_reminder_letter.php`,
      req
    );
  }



  getLetterTemplaterepissueseller(templateName: string): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_letter_template_rep_issue_seller.php`,
      { template_name: templateName }   // ✔ send required value
    );
  }


  saveLetterIssueSellerTemplaterep(data: any): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/save_letter_rep_template_issue_seller.php`,
      JSON.stringify(data),
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
    );
  }


  getLetterTemplateissueseller(templateName: string): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_letter_template_issue_seller.php`,
      { template_name: templateName }   // ✔ send required value
    );
  }

  saveLetterTemplateissue(data: any): Observable<any> {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/save_letter_template_issue_seller.php`,
      JSON.stringify(data),
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
    );
  }

  getgranthStockOpeningData(request: { book_name: string; start_date: any; end_date: any; }) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get.book_stock_ledger_briefly_granth.php`,
      request
    );
  }

  getGranthSellerLedgerData(req1: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_granth_seller_ledger_indetail.php`,
      req1

    );
  }


  getgranthSeNames(name: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.PHP_API_SERVER}/read_granth_seller_name.php`,
      {
        name
      }
    );
  }
  getGranthSellerLedgerBriefly(req: { start_date: any; end_date: any; book_seller_name: string; }) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_granth_seller_briefly_ledger.php`,
      req
    );
  }

  getpendingreceiptgranth(req: any) {
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/getInvoiceBySeller.php`,
      req
    );
  }

  getPrantDistrictwiseReport(req: any) {
    //console.log(mobileNumber)
    return this.httpClient.post<any>(
      `${this.PHP_API_SERVER}/get_all_pranth_district_issue_seller.php`,
      req
    );
  }

  getBookSellerReport(payload: any) {
    return this.httpClient.post(
      `${this.PHP_API_SERVER}/get_granth_office_representative_indetail_report.php`,
      payload
    );
  }


}
